/**!
    @name    : ihunter-common
    @author  : Ⓒ 2026 Inside Outside Studios Inc. All rights reserved.
    @user    : hannahhenderson
    @version : 2.0.0
    @date    : 26/10/2026
    @time    : 11:16:07 AM Mountain Daylight Time
*/
import { getDatabase as Ra, get as pr, ref as G, update as Ta, set as Oa, onValue as Ee, query as re, onChildAdded as ya, onChildChanged as Ca, onChildRemoved as Aa, orderByChild as Sa, equalTo as Ia } from "firebase/database";
import { getStorage as ba, uploadBytes as Na, ref as Mt, deleteObject as wa, getDownloadURL as Pa } from "firebase/storage";
import _a from "moment";
import { sendPasswordResetEmail as Ma, updateProfile as Qt, EmailAuthProvider as va, signInWithCredential as La, updatePassword as Da } from "firebase/auth";
import Ua from "events";
var dt = { exports: {} };
function ka(a, e) {
  return a.replace(/\{\s*([^}\s]+)\s*\}/g, (t, r) => r in e ? e[r] : `{${r}}`);
}
dt.exports = ka;
const c = (dt.exports == null ? {} : dt.exports).default || dt.exports, be = {
  Waypoint: { id: "Waypoint", dbId: 0 },
  Track: { id: "Track", dbId: 1 },
  Drawing: { id: "Drawing", dbId: 2 }
};
Object.freeze(be);
const er = Object.values(be).map((a) => a.id);
Object.freeze(er);
const K = {
  Waypoint: {
    Color: {
      Red: "red",
      Orange: "orange",
      Yellow: "yellow",
      Green: "green",
      Cyan: "cyan",
      Blue: "blue",
      Purple: "purple",
      Brown: "brown",
      Grey: "grey"
    },
    PinResourcePrefix: "ihunter_pin_",
    PinBackgroundResourcePrefix: "ihunter_pin_background_",
    // Pin overlays are ordered to match mobile
    PinOverlay: {
      Camp: "camp",
      Stand: "stand",
      Truck: "truck",
      Treestand: "treestand",
      Deer: "deer",
      Moose: "moose",
      Whitetail: "whitetail",
      Muledeer: "muledeer",
      Doe: "doe",
      Antelope: "antelope",
      Bhs: "bhs",
      Mountaingoat: "mountaingoat",
      Bear: "bear",
      Bird: "bird",
      Coyote: "coyote",
      Cat: "cat",
      Turkey: "turkey",
      Grouse: "grouse",
      Pheasant: "pheasant",
      Skunk: "skunk",
      Goose: "goose",
      Duck: "duck",
      Fish: "fish",
      Rabbit: "rabbit",
      Blooddrop: "blooddrop",
      Dogtrack: "dogtrack",
      Deertrack: "deertrack",
      Deerscat: "deerscat",
      Rub: "rub",
      Scrape: "scrape",
      Waterhole: "waterhole",
      ElkShed: "elk_shed",
      MooseShed: "moose_shed",
      WhitetailShed: "whitetail_shed",
      MuleShed: "mule_shed",
      Hunting: "hunting",
      Archer: "archer",
      Camera: "camera",
      Binos: "binos",
      Fire: "fire",
      Sights: "sights",
      Trap: "trap",
      Snare: "snare",
      Cattle: "cattle",
      Gate: "gate",
      Farmer: "farmer",
      Mountain: "mountain",
      Trees: "trees",
      Mushroom: "mushroom",
      Bridge: "bridge",
      Culvert: "culvert",
      Boat: "boat",
      BoatDock: "boat_dock",
      Private: "private",
      Checkmark: "checkmark",
      Xmark: "xmark",
      Questionmark: "questionmark"
    }
  },
  Track: {
    Color: {
      Red: "red",
      Orange: "orange",
      Yellow: "yellow",
      Green: "green",
      Cyan: "cyan",
      Blue: "blue",
      Purple: "purple",
      Brown: "brown",
      Grey: "grey"
    },
    PinResourcePrefix: "listitem_signpost_",
    Annotation: {
      Xml: {
        Declaration: '<?xml version="1.0"?>',
        RootTag: "locations",
        ItemTag: "location",
        Properties: [
          { name: "altitude", type: Number },
          { name: "speed", type: Number },
          { name: "latitude", type: String },
          { name: "longitude", type: String },
          { name: "time", type: Date },
          { name: "course", type: Number },
          { name: "verticalaccuracy", type: Number },
          { name: "horizontalaccuracy", type: Number },
          { name: "pause", type: Boolean }
        ]
      }
    }
  },
  Drawing: {
    Color: {
      Red: "red",
      Orange: "orange",
      Yellow: "yellow",
      Green: "green",
      Cyan: "cyan",
      Blue: "blue",
      Purple: "purple",
      Brown: "brown",
      Grey: "grey"
    },
    PinResourcePrefix: "ihunter_pin_drawing_",
    Annotation: {
      Type: {
        Unknown: -1,
        //use this for legacy waypoints that don't have a type included in the annotationXML
        Freehand: 0,
        Line: 1,
        Rect: 2,
        Circle: 3
      },
      Color: {
        Red: "red",
        Green: "green",
        Orange: "orange",
        Blue: "blue"
      },
      Xml: {
        Declaration: '<?xml version="1.0"?>',
        RootTag: "annotations",
        ItemTag: "annotation",
        Properties: [
          { name: "type", type: Number, default: 0 },
          { name: "points", type: Array, default: [] },
          { name: "color", type: String, default: "#dc3a34" },
          { name: "thickness", type: Number, default: 5 },
          { name: "opacity", type: Number, default: 1 },
          { name: "elevations", type: String, default: "" },
          { name: "elevationPoints", type: String, default: "" }
        ]
      }
    }
  }
};
Object.freeze(K);
const De = {
  Waypoint: {
    Color: "green",
    PinOverlay: K.Waypoint.PinOverlay.Camp,
    // Legacy overlays do not have the PinResourcePrefix
    LegacyOverlays: [
      K.Waypoint.PinOverlay.Camp,
      K.Waypoint.PinOverlay.Deer,
      K.Waypoint.PinOverlay.Hunting,
      K.Waypoint.PinOverlay.Farmer
    ]
  },
  Track: {
    Color: "red",
    Thickness: 3
  },
  Drawing: {
    Color: "red"
  }
};
Object.freeze(De);
const je = {
  Default: [
    { name: "uuid", dbName: "UUID" },
    { name: "accuracy", default: 0 },
    { name: "altitude", default: 0 },
    { name: "creationUsername", default: "" },
    { name: "creatorUid" },
    { name: "originalUuid" },
    { name: "date" },
    { name: "dateUpdated" },
    { name: "desc", default: "" },
    { name: "imagesString", dbName: "image", default: "" },
    { name: "moonphase", default: -1 },
    { name: "name", default: "" },
    { name: "needsImageUpload", default: !1 },
    { name: "weatherImage", dbName: "weather_image", default: "" }
  ],
  Waypoint: [
    { name: "latitude", isEncrypted: !0 },
    { name: "longitude", isEncrypted: !0 },
    {
      name: "pinBackgroundResource",
      default: `${K.Waypoint.PinBackgroundResourcePrefix}${De.Waypoint.Color}`
    },
    { name: "pinResource", default: `${K.Waypoint.PinResourcePrefix}${De.Waypoint.PinOverlay}` },
    { name: "originalWeather", dbName: "weatherinfo", default: "" }
  ],
  Track: [
    { name: "annotationXML", dbName: "AnnotationXML" },
    { name: "CenterLatitude", isEncrypted: !0 },
    { name: "CenterLongitude", isEncrypted: !0 },
    { name: "pinResource", default: `${K.Track.PinResourcePrefix}${De.Track.Color}` },
    { name: "SpanLatitude", isEncrypted: !0 },
    { name: "SpanLongitude", isEncrypted: !0 }
  ],
  Drawing: [
    { name: "annotationXML", dbName: "AnnotationXML" },
    { name: "CenterLatitude", isEncrypted: !0 },
    { name: "CenterLongitude", isEncrypted: !0 },
    { name: "latitude", isEncrypted: !0 },
    { name: "longitude", isEncrypted: !0 },
    { name: "pinResource", default: `${K.Drawing.PinResourcePrefix}${De.Drawing.Color}` },
    { name: "SpanLatitude", isEncrypted: !0 },
    { name: "SpanLongitude", isEncrypted: !0 },
    { name: "showAreaLabel", dbName: "drawnwaypointShowArea", default: !0 },
    { name: "showElevation", dbName: "drawnwaypointShowElevation", default: !0 },
    { name: "showDistLabel", dbName: "drawnwaypointShowDist", default: !0 }
  ]
};
Object.freeze(je);
const le = {
  WAYPOINTS_ROUTE: "/sync/{userUuid}/waypoints",
  TRACKS_ROUTE: "/sync/{userUuid}/trackedwaypoints_v2",
  TRACKS_LIGHT_ROUTE: "/sync/{userUuid}/trackedwaypoints_light",
  DRAWINGS_ROUTE: "/sync/{userUuid}/drawnwaypoints",
  WAYPOINT_ROUTE: "/sync/{userUuid}/waypoints/{itemUuid}",
  TRACK_ROUTE: "/sync/{userUuid}/trackedwaypoints_v2/{itemUuid}",
  TRACK_LIGHT_ROUTE: "/sync/{userUuid}/trackedwaypoints_light/{itemUuid}",
  DRAWING_ROUTE: "/sync/{userUuid}/drawnwaypoints/{itemUuid}",
  ITEM_IMAGES_ROUTE: "/sync/{userUuid}/images/{itemUuid}",
  ITEM_IMAGE_STORAGE_ROUTE: "/sync/{userUuid}/images/{itemUuid}/{imageName}"
}, Ba = 25;
class Ue {
  static get All() {
    return er;
  }
  static get Waypoint() {
    return be.Waypoint.id;
  }
  static get Track() {
    return be.Track.id;
  }
  static get Drawing() {
    return be.Drawing.id;
  }
  static IsSupported(e) {
    return e && !!er.includes(e);
  }
  static FromDbId(e) {
    const t = Object.values(be).find((r) => r.dbId === e);
    return t ? t.id : be.Waypoint.id;
  }
  static ToDbId(e) {
    var t;
    return ((t = be[e]) == null ? void 0 : t.dbId) ?? be.Waypoint.dbId;
  }
  static FromPinResource(e) {
    return e != null && e.startsWith(K.Drawing.PinResourcePrefix) ? Ue.Drawing : e != null && e.startsWith(K.Track.PinResourcePrefix) ? Ue.Track : Ue.Waypoint;
  }
}
let vt, Lt, we;
class B {
  static DefaultPinResource(e) {
    var t, r;
    return (r = (t = je[e]) == null ? void 0 : t.find((s) => s.name === "pinResource")) == null ? void 0 : r.default;
  }
  static PinOverlayDbName(e) {
    return `${De.Waypoint.LegacyOverlays.includes(e) ? "" : B.Waypoint.PinResourcePrefix}${e}`;
  }
  static DefaultPinBackgroundResource(e) {
    var t, r;
    return (r = (t = je[e]) == null ? void 0 : t.find((s) => s.name === "pinBackgroundResource")) == null ? void 0 : r.default;
  }
  static DefaultProperties(e) {
    return Ue.IsSupported(e) ? je.Default.concat(je[e]) : je.Default;
  }
  static SetObjectAndArrayValues(e, t, r) {
    var n, i;
    const s = (n = K[e]) == null ? void 0 : n[r];
    if (s) {
      t[r] = s;
      const o = Object.values(s);
      if (o && o.length) {
        t[`${r}s`] = o;
        const u = ((i = De[e]) == null ? void 0 : i[r]) || o[0];
        t.Default[r] = u;
      }
    }
  }
  static Constants(e) {
    const t = {
      PinResourcePrefix: K[e].PinResourcePrefix,
      PinBackgroundResourcePrefix: K[e].PinBackgroundResourcePrefix,
      Default: {
        Thickness: De[e].Thickness,
        Properties: B.DefaultProperties(e),
        PinResource: B.DefaultPinResource(e),
        PinBackgroundResource: B.DefaultPinBackgroundResource(e)
      }
    };
    return B.SetObjectAndArrayValues(e, t, "Color"), B.SetObjectAndArrayValues(e, t, "PinOverlay"), B.SetObjectAndArrayValues(e, t, "Annotation"), t;
  }
  // EXAMPLE USAGE: CollectionItem.Waypoint.Colors, CollectionItem.Waypoint.Color.Green, CollectionItem.Waypoint.Default.PinOverlay, etc
  static get Waypoint() {
    return vt || (vt = B.Constants(Ue.Waypoint)), vt;
  }
  // EXAMPLE USAGE: CollectionItem.Track.Default.Properties, CollectionItem.Track.Default.Thickness, etc
  static get Track() {
    return Lt || (Lt = B.Constants(Ue.Track)), Lt;
  }
  // EXAMPLE USAGE: CollectionItem.Drawing.Default.Properties, CollectionItem.Drawing.Annotation, etc
  static get Drawing() {
    return we || (we = B.Constants(Ue.Drawing), we.Annotation.Colors = Object.values(we.Annotation.Color), we.Annotation.Types = Object.values(we.Annotation.Type).filter(
      (e) => e !== we.Annotation.Type.Unknown
    )), we;
  }
  static GenerateItemUuid() {
    return ("10000000-1000-4000-8000" + -1e11).replace(
      /[018]/g,
      (e) => (e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16)
    );
  }
  static PropertyNames(e) {
    return B[e].Default.Properties.map((t) => t.name);
  }
  static EncryptedPropertyNames(e) {
    return B[e].Default.Properties.filter((r) => r.isEncrypted).map((r) => r.name);
  }
  static InitializeDbData(e) {
    const t = { UUID: B.GenerateItemUuid() }, r = B[e].Default.Properties;
    for (const s of r)
      if (s.default !== void 0) {
        const n = s.dbName || s.name;
        t[n] = s.default;
      }
    return t;
  }
  static InitializeProperties(e, t = {}) {
    const r = { uuid: t.uuid || B.GenerateItemUuid() }, s = B[e].Default.Properties;
    for (const n of s)
      t[n.name] !== void 0 ? r[n.name] = t[n.name] : n.default !== void 0 && (r[n.name] = n.default);
    return r;
  }
  static ConvertDbDataToProperties(e, t) {
    const r = {}, s = B[e].Default.Properties;
    for (const n of s) {
      const i = n.dbName || n.name;
      r[n.name] = t[i] !== void 0 ? t[i] : n.default;
    }
    return r;
  }
  static ConvertPropertiesToDbData(e, t) {
    const r = {}, s = B[e].Default.Properties;
    for (const n of s) {
      const i = n.dbName || n.name, o = t[n.name] !== void 0 ? t[n.name] : n.default;
      o !== void 0 && (r[i] = o);
    }
    return r;
  }
}
class Dt {
  static WaypointsRoute(e) {
    return c(le.WAYPOINTS_ROUTE, { userUuid: e });
  }
  static TracksRoute(e) {
    return c(le.TRACKS_ROUTE, { userUuid: e });
  }
  static TracksLightRoute(e) {
    return c(le.TRACKS_LIGHT_ROUTE, { userUuid: e });
  }
  static DrawingsRoute(e) {
    return c(le.DRAWINGS_ROUTE, { userUuid: e });
  }
  static WaypointRoute(e, t) {
    return c(le.WAYPOINT_ROUTE, { userUuid: e, itemUuid: t });
  }
  static TrackRoute(e, t) {
    return c(le.TRACK_ROUTE, { userUuid: e, itemUuid: t });
  }
  static TrackLightRoute(e, t) {
    return c(le.TRACK_LIGHT_ROUTE, { userUuid: e, itemUuid: t });
  }
  static DrawingRoute(e, t) {
    return c(le.DRAWING_ROUTE, { userUuid: e, itemUuid: t });
  }
  static ItemImagesRoute(e, t) {
    return c(le.ITEM_IMAGES_ROUTE, { userUuid: e, itemUuid: t });
  }
  static ItemImageStorageRoute(e, t, r) {
    return c(le.ITEM_IMAGE_STORAGE_ROUTE, { userUuid: e, itemUuid: t, imageName: r });
  }
  static get MaxFreeItems() {
    return Ba;
  }
}
class Nn {
  constructor(e) {
    this.measurementId = e;
  }
  report(e, t) {
    gtag("event", e, t);
  }
  async lookupAnalyticsIds(e = 2e3) {
    try {
      if (!this.clientId || !this.sessionId) {
        if (!this.measurementId)
          return console.warn("Analytics measurement ID not configured."), { analyticsClientId: null, analyticsSessionId: null };
        if (typeof gtag > "u")
          return console.warn("Google Analytics (gtag) is not available - likely blocked by privacy settings."), { analyticsClientId: null, analyticsSessionId: null };
        const t = Promise.all([
          new Promise((o) => {
            if (this.clientId) return o(this.clientId);
            gtag("get", this.measurementId, "client_id", (u) => o(u));
          }),
          new Promise((o) => {
            if (this.sessionId) return o(this.sessionId);
            gtag("get", this.measurementId, "session_id", (u) => o(u));
          })
        ]);
        let r;
        const s = new Promise((o) => {
          r = setTimeout(() => {
            console.warn("Analytics ID lookup timed out - privacy blocker may be active."), o([this.clientId || null, this.sessionId || null]);
          }, e);
        }), [n, i] = await Promise.race([t, s]);
        clearTimeout(r), this.clientId = n, this.sessionId = i;
      }
      return {
        analyticsClientId: this.clientId,
        analyticsSessionId: this.sessionId
      };
    } catch (t) {
      return console.warn("Analytics IDs not found:", t.message), {
        analyticsClientId: this.clientId || null,
        analyticsSessionId: this.sessionId || null
      };
    }
  }
}
const Re = {
  ELEVATION: "/location/elevation/{lat},{lng}.json",
  WEATHER: "/location/weather/{lat},{lng}.json?lang={lang}",
  MESSAGES: "/product/{region}/messages.json",
  PLATFORM_MESSAGES: "/product/{region}/{platform}/messages.json",
  REGIONS: "/product/regions.json",
  CATALOG: "/product/catalog.json",
  SKUS: "/product/skus.json",
  PRICES: "/product/prices.json",
  REGION_CATALOG: "/product/{region}/catalog.json"
};
class Te {
  static Regions() {
    return c(Re.REGIONS);
  }
  static Catalog() {
    return c(Re.CATALOG);
  }
  static Skus() {
    return c(Re.SKUS);
  }
  static Prices() {
    return c(Re.PRICES);
  }
  static RegionCatalog(e) {
    return c(Re.REGION_CATALOG, { region: e });
  }
  static Messages(e, t = null) {
    const r = t ? Re.PLATFORM_MESSAGES : Re.MESSAGES;
    return c(r, { region: e, platform: t });
  }
  static Weather(e, t, r) {
    return c(Re.WEATHER, { lat: e, lng: t, lang: r });
  }
  static Elevation(e, t) {
    return c(Re.ELEVATION, { lat: e, lng: t });
  }
}
const $ = {
  USERS: "users",
  CUSTOMERS: "customers",
  SUBSCRIPTIONS: "subscriptions",
  SCHEDULES: "schedules",
  PRODUCTS: "products",
  PRICES: "prices",
  PROMOTIONS: "promotions",
  COUPONS: "coupons",
  PAYMENTS: "payments",
  INVOICES: "invoices"
}, Je = {
  CUSTOMER: `/${$.USERS}/{uid}/${$.CUSTOMERS}/{cid}`,
  SUBSCRIPTION: `/${$.USERS}/{uid}/${$.SUBSCRIPTIONS}`,
  PRODUCT: `/${$.PRODUCTS}/{product}`,
  PRICE: `/${$.PRODUCTS}/{product}/${$.PRICES}/{price}`
}, $a = {
  CHECKOUT: "/billing-api/checkout"
};
class wn {
  static Customer(e, t) {
    return c(Je.CUSTOMER, { uid: e, cid: t });
  }
  static SubscriptionsCollection(e) {
    return c(Je.SUBSCRIPTION, { uid: e });
  }
  // static CustomerPromotionClaim(uid, claim) {
  //     return templ8r(BILLING.PROMOTION, {uid, claim});
  // }
  static CustomerRoute() {
    return Je.CUSTOMER;
  }
  static PriceRoute() {
    return Je.PRICE;
  }
  static ProductRoute() {
    return Je.PRODUCT;
  }
  static Users() {
    return $.USERS;
  }
  static Customers() {
    return $.CUSTOMERS;
  }
  static Subscriptions() {
    return $.SUBSCRIPTIONS;
  }
  static Schedules() {
    return $.SCHEDULES;
  }
  static Products() {
    return $.PRODUCTS;
  }
  static Prices() {
    return $.PRICES;
  }
  static Promotions() {
    return $.PROMOTIONS;
  }
  static Payments() {
    return $.PAYMENTS;
  }
  static Coupons() {
    return $.COUPONS;
  }
  static Invoices() {
    return $.INVOICES;
  }
  static Checkout() {
    return $a.CHECKOUT;
  }
}
class st {
  constructor(e) {
    this.db = Ra(e), this.storage = ba(e);
  }
  async get(e) {
    let t = await pr(G(this.db, e));
    return t.exists() ? t.val() : null;
  }
  async countChildren(e) {
    let t = await pr(G(this.db, e));
    return t.exists() ? t.size : 0;
  }
  async update(e, t) {
    return await Ta(G(this.db, e), t);
  }
  async set(e, t) {
    return await Oa(G(this.db, e), t);
  }
  // Returns the unsubscribe function (not a Promise) so callers can stop watching
  watch(e, t, r) {
    return Ee(
      re(G(this.db, e)),
      (s) => {
        t(s.exists() ? s.val() : null);
      },
      r
    );
  }
  onAdded(e, t, r) {
    return ya(
      re(G(this.db, e)),
      (s) => {
        t(s);
      },
      r
    );
  }
  onUpdated(e, t, r) {
    return Ca(
      re(G(this.db, e)),
      (s) => {
        t(s);
      },
      r
    );
  }
  onRemoved(e, t, r) {
    return Aa(
      re(G(this.db, e)),
      (s) => {
        t(s.key);
      },
      r
    );
  }
  encodeKey(e) {
    return e.replace(/[\/\.\$\[\]#!]/g, (t) => `!${t.charCodeAt(0).toString(16).toUpperCase()}`);
  }
  decodeKey(e) {
    return e.replace(/!([0-9a-f]{2})/gi, (t, r) => String.fromCharCode(parseInt(r, 16)));
  }
  async uploadObject(e, t, r) {
    return await Na(Mt(this.storage, e), t, r);
  }
  async deleteObject(e) {
    return await wa(Mt(this.storage, e));
  }
  async objectUrl(e) {
    return await Pa(Mt(this.storage, e));
  }
}
const q = {
  REGION: "/product/metadata/{region}/region",
  SUBSCRIPTION: "/product/metadata/{region}/subscriptions/{subscription}",
  SUBSCRIPTION_LAYER: "/product/metadata/{region}/subscriptions_layers/{subscription}/{layer}",
  RESOURCE: "/product/metadata/{region}/resources/{resource}",
  RESOURCE_LAYER: "/product/metadata/{region}/resources_layers/{resource}/{layer}",
  MAP: "/product/metadata/{region}/maps/{resource}/{layer}/{map}",
  PRODUCT: "/product/metadata/{region}/products/{resource}/{layer}/{map}/{product}"
};
Object.freeze(q);
const pt = {
  REGIONS: "/product/regions/{region}"
};
Object.freeze(pt);
const x = {
  REGION: "/product/catalog/{region}",
  SUBSCRIPTION: "/product/catalog/{region}/subscriptions/{subscription}",
  SUBSCRIPTION_LAYER: "/product/catalog/{region}/subscriptions/{subscription}/layers/{layer}",
  RESOURCE: "/product/catalog/{region}/resources/{resource}",
  RESOURCE_LAYER: "/product/catalog/{region}/resources/{resource}/layers/{layer}",
  MAP: "/product/catalog/{region}/resources/{resource}/layers/{layer}/maps/{map}",
  PRODUCT: "/product/catalog/{region}/resources/{resource}/layers/{layer}/maps/{map}/products/{product}"
};
Object.freeze(x);
const tr = {
  PRODUCT: "/product/skus/{product}"
};
Object.freeze(tr);
const rr = {
  PRODUCT: "/product/prices/{product}"
};
Object.freeze(rr);
const Hr = {
  PROMOTIONS: "/store/promotions"
};
Object.freeze(Hr);
class M {
  static Catalog() {
    return it(c(x.REGION, { region: "" }));
  }
  static AllRegions() {
    return it(c(pt.REGIONS, { region: "" }));
  }
  static RegionsRoute() {
    return pt.REGIONS;
  }
  static Regions(e) {
    return c(pt.REGIONS, { region: e });
  }
  static RegionRoute() {
    return x.REGION;
  }
  static Region(e) {
    return c(x.REGION, { region: e });
  }
  static RegionMetadataRoute() {
    return q.REGION;
  }
  static RegionMetadata(e) {
    return c(q.REGION, { region: e });
  }
  static SubscriptionRoute() {
    return x.SUBSCRIPTION;
  }
  static Subscription(e, t) {
    return c(x.SUBSCRIPTION, { region: e, subscription: t });
  }
  static SubscriptionMetadataRoute() {
    return q.SUBSCRIPTION;
  }
  static SubscriptionMetadata(e, t) {
    return c(q.SUBSCRIPTION, { region: e, subscription: t });
  }
  static SubscriptionLayerRoute() {
    return x.SUBSCRIPTION_LAYER;
  }
  static SubscriptionLayer(e, t, r) {
    return c(x.SUBSCRIPTION_LAYER, { region: e, subscription: t, layer: r });
  }
  static SubscriptionLayerMetadataRoute() {
    return q.SUBSCRIPTION_LAYER;
  }
  static SubscriptionLayerMetadata(e, t, r) {
    return c(q.SUBSCRIPTION_LAYER, { region: e, subscription: t, layer: r });
  }
  static ResourceRoute() {
    return x.RESOURCE;
  }
  static Resource(e, t) {
    return c(x.RESOURCE, { region: e, resource: t });
  }
  static ResourceMetadataRoute() {
    return q.RESOURCE;
  }
  static ResourceMetadata(e, t) {
    return c(q.RESOURCE, { region: e, resource: t });
  }
  static ResourceLayerRoute() {
    return x.RESOURCE_LAYER;
  }
  static ResourceLayer(e, t, r) {
    return c(x.RESOURCE_LAYER, { region: e, resource: t, layer: r });
  }
  static ResourceLayerMetadataRoute() {
    return q.RESOURCE_LAYER;
  }
  static ResourceLayerMetadata(e, t, r) {
    return c(q.RESOURCE_LAYER, { region: e, resource: t, layer: r });
  }
  static MapRoute() {
    return x.MAP;
  }
  static Map(e, t, r, s) {
    return c(x.MAP, { region: e, resource: t, layer: r, map: s });
  }
  static MapMetadataRoute() {
    return q.MAP;
  }
  static MapMetadata(e, t, r, s) {
    return c(q.MAP, { region: e, resource: t, layer: r, map: s });
  }
  static ProductRoute() {
    return x.PRODUCT;
  }
  static Product(e, t, r, s, n) {
    return c(x.PRODUCT, { region: e, resource: t, layer: r, map: s, product: n });
  }
  static ProductMetadataRoute() {
    return q.PRODUCT;
  }
  static ProductMetadata(e, t, r, s, n) {
    return c(q.PRODUCT, { region: e, resource: t, layer: r, map: s, product: n });
  }
  static AllProductSkus() {
    return it(c(tr.PRODUCT, { product: "" }));
  }
  static ProductSku(e) {
    return c(tr.PRODUCT, { product: e });
  }
  static AllProductPrices() {
    return it(c(rr.PRODUCT, { product: "" }));
  }
  static ProductPrice(e) {
    return c(rr.PRODUCT, { product: e });
  }
  static AllStorePromotions() {
    return Hr.PROMOTIONS;
  }
}
const it = (a) => a.endsWith("/") ? a.slice(0, -1) : a;
class qr {
  constructor(e) {
    this.product = e, this.regions = {}, this.catalog = {}, this.writable = !1;
  }
  get readonly() {
    return !this.writable;
  }
  processRegions(e, t) {
    let r = {};
    Object.assign(r, this.regions);
    for (let s of e)
      this.regions[s] ? r[s] && delete r[s] : (this.regions[s] = !0, this.watchRegion(s, t));
    for (let s in r)
      console.log("Unwatching region: " + s), delete this.regions[s], this.unwatchRegion(s);
  }
  unwatchCatalog() {
  }
  unwatchRegion(e) {
  }
}
class Pn extends qr {
  constructor(e, t) {
    super(e), this.firebase = new st(t), this.writable = !0;
  }
  watchFullCatalog(e, t) {
    console.log(`Watching ${this.product} product catalog`), this.firebase.watch(
      M.Catalog(),
      (r) => {
        e(r);
      },
      (r) => {
        console.error(`Watching ${this.product} product catalog`, r), t && t(r);
      }
    );
  }
  watchCatalog(e, t, r) {
    console.log(`Watching ${this.product} product regions`);
    let s = G(this.firebase.db, M.AllRegions()), n = !1;
    this.unwatchCatalog = Ee(
      re(s, Sa("product"), Ia(this.product)),
      (i) => {
        let o = i.val();
        if (o) {
          let u = Object.keys(o);
          const d = new Set(u);
          this.processRegions(u, (l, E) => {
            e(l, E), n || (d.delete(l), d.size === 0 && (n = !0, t && t()));
          });
        } else n || (n = !0, t && t());
      },
      (i) => {
        console.error(`Watching ${this.product} product regions`, i), r && r(i);
      }
    );
  }
  watchRegion(e, t) {
    console.log(`Watching ${this.product} ${e} product catalog`);
    let r = G(this.firebase.db, M.Region(e));
    this.unwatchRegion[e] = Ee(
      re(r),
      (s) => {
        this.catalog[e] = s.val(), t(e, this.catalog[e]);
      },
      (s) => {
        console.error(`Watching ${e} product catalog`, s);
      }
    );
  }
  unwatchRegion(e) {
    this.unwatchRegion[e] && this.unwatchRegion[e]();
  }
  watchProducts(e) {
    console.log("Watching products");
    let t = G(this.firebase.db, M.AllProductSkus());
    this.unwatchProductsNode = Ee(
      re(t),
      (r) => {
        let s = r.val();
        s && e(s);
      },
      (r) => {
        console.error("Watching products", r);
      }
    );
  }
  unwatchProducts() {
    this.unwatchProductsNode && (console.log("unwatchProductsNode"), this.unwatchProductsNode(), this.unwatchProductsNode = null);
  }
  watchPrices(e) {
    console.log("Watching prices");
    let t = G(this.firebase.db, M.AllProductPrices());
    this.unwatchPricesNode = Ee(
      re(t),
      (r) => {
        let s = r.val();
        s && e(s);
      },
      (r) => {
        console.error("Watching prices", r);
      }
    );
  }
  unwatchPrices() {
    this.unwatchPricesNode && (console.log("unwatchPricesNode"), this.unwatchPricesNode(), this.unwatchPricesNode = null);
  }
  watchPromotions(e) {
    console.log("Watching promotions");
    let t = G(this.firebase.db, M.AllStorePromotions());
    this.unwatchPromotionsNode = Ee(
      re(t),
      (r) => {
        let s = r.val();
        s && e(s);
      },
      (r) => {
        console.error("Watching promotions", r);
      }
    );
  }
  unwatchPromotions() {
    this.unwatchPromotionsNode && (console.log("unwatchPromotionsNode"), this.unwatchPromotionsNode(), this.unwatchPromotionsNode = null);
  }
  watchSync(e, t) {
    console.log("Watching sync");
    let r = G(this.firebase.db, M.Sync(e));
    this.unwatchSyncNode = Ee(
      re(r),
      (s) => {
        let n = s.val();
        n && t(n);
      },
      (s) => {
        console.error("Watching sync", s);
      }
    );
  }
  unwatchSync() {
    this.unwatchSyncNode && (console.log("unwatchSyncNode"), this.unwatchSyncNode(), this.unwatchSyncNode = null);
  }
  watchPreferences(e, t) {
    console.log("Watching preferences");
    let r = G(this.firebase.db, M.Preferences(e));
    this.unwatchPreferencesNode = Ee(
      re(r),
      (s) => {
        let n = s.val();
        n && t(n);
      },
      (s) => {
        console.error("Watching preferences", s);
      }
    );
  }
  unwatchPreferences() {
    this.unwatchPreferencesNode && (this.unwatchPreferencesNode(), this.unwatchPreferencesNode = null);
  }
  watchCountyMaps(e, t) {
    console.log("Watching county maps");
    let r = G(this.firebase.db, M.CountyMaps(e));
    this.unwatchCountyMapNode = Ee(
      re(r),
      (s) => {
        let n = s.val();
        n && t(n);
      },
      (s) => {
        console.error("Watching county maps", s);
      }
    );
  }
  unwatchCountyMap() {
    this.unwatchCountyMapNode && (this.unwatchCountyMapNode(), this.unwatchCountyMapNode = null);
  }
  async getRegions() {
    let e = await this.firebase.get(M.AllRegions());
    return Object.keys(e);
  }
  async getRegion(e) {
    return this.firebase.get(M.Region(e));
  }
  async getRegionMetadata(e) {
    return this.firebase.get(M.RegionMetadata(e));
  }
  async getSubscriptionMetadata(e, t) {
    return this.firebase.get(M.SubscriptionMetadata(e, t));
  }
  async getSubscriptionLayerMetadata(e, t, r) {
    return this.firebase.get(M.SubscriptionLayerMetadata(e, t, r));
  }
  async getResourceMetadata(e, t) {
    return this.firebase.get(M.ResourceMetadata(e, t));
  }
  async getResourceLayerMetadata(e, t, r) {
    return this.firebase.get(M.ResourceLayerMetadata(e, t, r));
  }
  async getResourceLayerMapMetadata(e, t, r, s) {
    return this.firebase.get(M.MapMetadata(e, t, r, s));
  }
  async getResourceLayerProductMetadata(e, t, r, s, n) {
    return this.firebase.get(M.ProductMetadata(e, t, r, s, n));
  }
  async getProductSkus() {
    return this.firebase.get(M.AllProductSkus());
  }
  async getProductPrices() {
    return this.firebase.get(M.AllProductPrices());
  }
  async getProductPromotions() {
    return this.firebase.get(M.AllStorePromotions());
  }
  encodeKeys(e) {
    var t = {};
    for (let r in e) {
      let s = this.firebase.encodeKey(r);
      typeof e[r] == "object" ? t[s] = this.encodeKeys(e[r]) : t[s] = e[r];
    }
    return t;
  }
  async updateRegionMetadata(e, t) {
    return t = this.encodeKeys(t), await this.firebase.update(M.RegionMetadata(e), t);
  }
  async updateSubscriptionMetadata(e, t, r) {
    return r = this.encodeKeys(r), await this.firebase.update(M.SubscriptionMetadata(e, t), r);
  }
  async updateSubscriptionLayerMetadata(e, t, r, s) {
    return s = this.encodeKeys(s), await this.firebase.update(M.SubscriptionLayerMetadata(e, t, r), s);
  }
  async updateResourceMetadata(e, t, r) {
    return r = this.encodeKeys(r), await this.firebase.update(M.ResourceMetadata(e, t), r);
  }
  async updateResourceLayerMetadata(e, t, r, s) {
    return s = this.encodeKeys(s), await this.firebase.update(M.ResourceLayerMetadata(e, t, r), s);
  }
  async updateMapMetadata(e, t, r, s, n) {
    return n = this.encodeKeys(n), await this.firebase.update(M.MapMetadata(e, t, r, s), n);
  }
  async updateProductMetadata(e, t, r, s, n, i) {
    return i = this.encodeKeys(i), await this.firebase.update(M.ProductMetadata(e, t, r, s, n), i);
  }
  async setStorePromotions(e) {
    return await this.firebase.set(M.AllStorePromotions(), e);
  }
}
class ot extends Error {
  constructor(e, t, r) {
    super(t), this.name = "NetworkError", this.status = e, this.cause = r, this.stack = null, this.details = null;
  }
}
const Z = "application/json", Ga = "application/octet-stream";
class Wa {
  constructor() {
  }
  async getAccessToken() {
    return await window.app.getFirebaseToken();
  }
  async get(e, t, r) {
    let n = {
      method: "GET",
      headers: {
        Authorization: "Firebase " + await await this.getAccessToken(),
        "Content-Type": t || Z,
        Accept: r || Z
      }
    };
    return this.request(e, n);
  }
  async getJson(e, t) {
    let r = {
      method: "GET",
      headers: {
        Accept: Z
      }
    };
    if (t) {
      let s = await this.getAccessToken();
      r.headers.Authorization = "Firebase " + s;
    }
    return this.request(e, r);
  }
  async put(e, t, r, s) {
    let i = {
      method: "PUT",
      headers: {
        Authorization: "Firebase " + await this.getAccessToken(),
        "Content-Type": r || Z,
        Accept: s || Z
      },
      body: JSON.stringify(t)
    };
    return this.request(e, i);
  }
  async patch(e, t, r, s) {
    let i = {
      method: "PATCH",
      headers: {
        Authorization: "Firebase " + await this.getAccessToken(),
        "Content-Type": r || Z,
        Accept: s || Z
      },
      body: JSON.stringify(t)
    };
    return this.request(e, i);
  }
  async post(e, t, r, s) {
    let i = {
      method: "POST",
      headers: {
        Authorization: "Firebase " + await this.getAccessToken(),
        "Content-Type": r || Z,
        Accept: s || Z
      },
      body: JSON.stringify(t)
    };
    return this.request(e, i);
  }
  async delete(e, t, r) {
    let n = {
      method: "DELETE",
      headers: {
        Authorization: "Firebase " + await this.getAccessToken(),
        "Content-Type": t || Z,
        Accept: r || Z
      }
    };
    return this.request(e, n);
  }
  async request(e, t) {
    return t || (t = {}), t.headers || (t.headers = {}), new Promise((r, s) => {
      try {
        return fetch ? fetch(e, t).then(async (n) => {
          if (n) {
            if (!n.ok) {
              let i = new ot(n.status, n.statusText), o = n.headers.get("Content-Type");
              if (o && o.startsWith(Z)) {
                let u = await n.json();
                i.stack = u.stack, i.message = u.error;
              } else {
                let u = await n.text();
                !i.message || i.message === "" ? i.message = u : i.details = u;
              }
              return s(i);
            }
          } else return s(new ot(500, "Unexpected response"));
          if (n.body && n.status === 200) {
            let i = t.headers.Accept || n.headers.get("Content-Type");
            return i && i.startsWith(Z) ? r(await n.json()) : i && i.startsWith(Ga) ? r(await n.blob()) : r(await n.text());
          } else
            return r();
        }).catch((n) => s(new ot(500, n.message, n))) : s(new ot(500, "No fetch"));
      } catch (n) {
        return s(n);
      }
    });
  }
}
const Y = {
  REGIONS: "/res/provinces/provinces.json",
  REGION: "/res/provinces/{region}/province.json",
  RESOURCE: "/res/provinces/{region}/{resource}/metadata.json",
  RESOURCE_LAYER: "/res/provinces/{region}/{resource}/{layer}/metadata.json",
  RESOURCE_GEOJSON: "/res/provinces/{region}/{resource}/{layer}/boundarydata.geojson",
  SUBSCRIPTION: "/res/provinces/{region}/{subscription}/metadata.json",
  // Depreciated; use resource metadata instead
  SUBSCRIPTION_LAYER: "/res/provinces/{region}/{subscription}/{layer}/metadata.json",
  // Deprecated; use resource layer metadata instead
  RESOURCE_RASTER_TILES: "/tiles/{region}/{layer}/{z}/{x}/{y}.png",
  PRODUCTS: "/tiles/{region}/counties.json",
  PRODUCT: "/tiles/{region}/{sku}/metadata.json",
  PRODUCT_GEOJSON: "/tiles/{region}/{sku}/boundary.geojson",
  PRODUCT_RASTER_TILES: "/tiles/{region}/{sku}/{z}/{x}/{y}.png",
  // Deprecated; use resource raster tiles instead
  // Deprecated
  LEGACY_RESOURCE_LAYER: "/getBoundariesFromDatabase.php?&database=res/provinces/{region}/{resource}/{layer}/boundarydata.db&identifyby=1",
  LEGACY_SUBSCRIPTION_LAYER: "/getBoundariesFromDatabase.php?&database=res/provinces/{region}/subscription/{layer}/boundarydata.db&identifyby=2"
};
Object.freeze(Y);
class z {
  static CopyProperties(e, t, r) {
    r || (r = {});
    for (let s in e) {
      const n = e[s];
      t[n] && (r[s] = t[n]);
    }
    return r;
  }
  static RegionsPath() {
    return Y.REGIONS;
  }
  static AllRegions() {
    return this.RegionsPath();
  }
  static RegionPath(e) {
    return c(Y.REGION, { region: e });
  }
  static RegionMetadata(e) {
    return this.RegionPath(e);
  }
  static ResourceMetadata(e, t) {
    return c(Y.RESOURCE, { region: e, resource: t });
  }
  static ResourceLayerMetadata(e, t, r) {
    return c(Y.RESOURCE_LAYER, { region: e, resource: t, layer: r });
  }
  static ResourceLayerBoundarydata(e, t, r) {
    return c(Y.LEGACY_RESOURCE_LAYER, { region: e, resource: t, layer: r });
  }
  static ResourceLayerBoundaryGeoJson(e, t, r) {
    return c(Y.RESOURCE_GEOJSON, { region: e, resource: t, layer: r });
  }
  static ResourceLayerRasterTiles(e, t) {
    return c(Y.RESOURCE_RASTER_TILES, { region: e, layer: t });
  }
  static SubscriptionPath(e, t) {
    return (!t || t === "pro") && (t = "subscription"), c(Y.SUBSCRIPTION, { region: e, subscription: t });
  }
  static SubscriptionMetadata(e, t) {
    return this.SubscriptionPath(e, t);
  }
  static SubscriptionLayerMetadata(e, t, r) {
    return (!t || t === "pro") && (t = "subscription"), c(Y.SUBSCRIPTION_LAYER, { region: e, layer: r, subscription: t });
  }
  static SubscriptionLayerBoundarydata(e, t) {
    return c(Y.LEGACY_SUBSCRIPTION_LAYER, { region: e, layer: t });
  }
  // static SubscriptionLayerBoundaryGeoJson(region, subscription, layer) {
  //     return templ8r(CATALOG_DATA.RESOURCE_GEOJSON, { region: region, resource: subscription, layer: layer });
  // }
  static CountyMetadata(e) {
    return c(Y.PRODUCTS, { region: e });
  }
  static CountyBoundaryGeoJson(e, t) {
    return c(Y.PRODUCT_GEOJSON, { region: e, sku: t });
  }
  static CountyProductMetadata(e, t) {
    return c(Y.PRODUCT, { region: e, sku: t });
  }
  static ProductMetadata(e, t) {
    return c(Y.PRODUCT, { region: e, sku: t });
  }
  static CountyBoundaryTiles(e, t) {
    return c(Y.PRODUCT_RASTER_TILES, { region: e, sku: t });
  }
  static cacheBuster() {
    return "?v=" + Date.now();
  }
}
const hr = {
  METADATA: {
    name: "PROVINCE_NAME",
    short: "PROVINCE_NAME_SHORT",
    project: "project",
    resource_id: "SERVER_FOLDER",
    regulations_version: "regulations_version",
    subscription_version: "subscription_version",
    url: "STR_PROVINCE_URL"
  }
}, gr = {
  METADATA: {
    name: "name",
    sku_web: "sku_web",
    sku_ios: "sku",
    sku_android: "sku_android",
    url: "more_info_url",
    header: "description_header",
    description: "description",
    generic: "name_generic"
  }
}, Er = {
  METADATA: {
    name: "name",
    color: "color",
    visibilityDefault: "visibilityDefault",
    visibilityPreference: "visibilityPreference"
  }
}, mr = {
  METADATA: {
    name: "name"
  }
}, Ut = {
  METADATA: {
    name: "name",
    name_plural: "name_plural",
    color: "color",
    visibilityDefault: "visibilityDefault",
    visibilityPreference: "visibilityPreference"
  },
  BOUNDARYDATA: {
    name: "Title",
    product: "Subtitle"
    // north: 'North',
    // east: 'East',
    // south: 'South',
    // west: 'West'
  }
}, fr = {
  METADATA: {
    name: "name",
    description: "description"
  },
  BOUNDARYDATA: {
    name: "Title"
    //product: 'Subtitle'
  }
}, Fa = {
  METADATA: {
    //sku: 'name', // This is a bad assumption; name != sku
    bounds: "bounds"
  }
};
class Oe {
  static RegionPropertyMap() {
    return hr.METADATA;
  }
  static SubscriptionPropertyMap() {
    return gr.METADATA;
  }
  static SubscriptionLayerPropertyMap() {
    return Er.METADATA;
  }
  static ResourcePropertyMap() {
    return mr.METADATA;
  }
  static ResourceLayerPropertyMap() {
    return Ut.METADATA;
  }
  static ResourceLayerBoundarydataPropertyMap() {
    return Ut.BOUNDARYDATA;
  }
  static ProductBoundarydataPropertyMap() {
    return fr.BOUNDARYDATA;
  }
  static ExtractRegionFromMetadata(e, t) {
    return this.CopyProperties(hr.METADATA, e, t);
  }
  static ExtractSubscriptionFromMetadata(e, t) {
    return this.CopyProperties(gr.METADATA, e, t);
  }
  static ExtractSubscriptionLayerFromMetadata(e, t) {
    return this.CopyProperties(Er.METADATA, e, t);
  }
  static ExtractResourceFromMetadata(e, t) {
    return this.CopyProperties(mr.METADATA, e, t);
  }
  static ExtractResourceLayerFromMetadata(e, t) {
    return this.CopyProperties(Ut.METADATA, e, t);
  }
  static ExtractMapFromMetadata(e, t) {
    return this.CopyProperties(fr.METADATA, e, t);
  }
  static ExtractProductFromMetadata(e, t) {
    return this.CopyProperties(Fa.METADATA, e, t);
  }
  static CopyProperties(e, t, r) {
    if (r || (r = {}), t)
      for (let s in e) {
        const n = e[s];
        t[n] && (r[s] = t[n]);
      }
    return r;
  }
}
var ht = { exports: {} };
function Va(a) {
  let e = a.lastIndexOf("_"), t = a.slice(e + 1);
  return {
    map: a.slice(0, e).replace(/(^[^A-Za-z0-9]*)|([^A-Za-z0-9]*$)/g, ""),
    // Trim non-alphanumeric
    version: t
  };
}
ht.exports = Va;
const kt = (ht.exports == null ? {} : ht.exports).default || ht.exports;
var gt = { exports: {} };
async function ja(a) {
  const e = await Promise.all(Object.values(a));
  return Object.fromEntries(Object.keys(a).map((t, r) => [t, e[r]]));
}
gt.exports = ja;
const xa = (gt.exports == null ? {} : gt.exports).default || gt.exports;
Promise.allMap = xa;
class Ya {
  constructor(e) {
    this.provider = e, this.includeMetadata = !0, this.countyLayerBoundarydata = {};
  }
  async getRegions() {
    return this.provider.getRegions();
  }
  clearCache() {
    this.countyLayerBoundarydata = {};
  }
  // The county boundary data is large (~3MB per region), so cache the request so concurrent lookups share one download
  getCountyLayerBoundarydata(e) {
    return this.countyLayerBoundarydata[e] || (this.countyLayerBoundarydata[e] = this.provider.getCountyLayerBoundarydata(e)), this.countyLayerBoundarydata[e];
  }
  copyProperties(e, t, r) {
    for (let s in r) {
      const n = r[s];
      t[n] && n && (e[s] = t[n]);
    }
    return e;
  }
  addMetadata(e, t) {
    this.includeMetadata && e && t && (e.metadata = t);
  }
  async getRegion(e) {
    let t = await this.provider.getRegionMetadata(e), r = {
      id: e,
      product: this.provider.product,
      resources: {}
    };
    this.addMetadata(r, t), this.copyProperties(r, t, Oe.RegionPropertyMap());
    let s = r.resource_id || e;
    if (t && t.required_resources) {
      let n = {};
      for (let i of t.required_resources)
        n[i] = this.getResource(s, i);
      r.resources = await Promise.allMap(n);
    }
    if (t && t.subscriptions) {
      let n = {};
      for (let i of t.subscriptions)
        n[i] = this.getSubscription(s, i);
      r.subscriptions = await Promise.allMap(n);
    }
    return r;
  }
  async getResource(e, t) {
    let r = await this.provider.getResourceMetadata(e, t), s = {
      layers: {}
    };
    this.addMetadata(s, r), this.copyProperties(s, r, Oe.ResourcePropertyMap());
    let n = {};
    for (let i of r.layers)
      n[i] = this.getResourceLayer(e, t, i);
    return s.layers = await Promise.allMap(n), s;
  }
  async getResourceLayer(e, t, r) {
    let s = await this.provider.getResourceLayerMetadata(e, t, r), n = {};
    return this.addMetadata(n, s), this.copyProperties(n, s, Oe.ResourceLayerPropertyMap()), t === "purchasable_layers" && r === "county" && (n.maps = await this.getCountyMaps(e)), n;
  }
  async getSubscription(e, t) {
    let r = await this.provider.getSubscriptionMetadata(e, t), s = {};
    if (this.addMetadata(s, r), this.copyProperties(s, r, Oe.SubscriptionPropertyMap()), r.layers) {
      s.layers = {};
      let n = {};
      for (let i of r.layers)
        n[i] = this.getSubscriptionLayer(e, t, i);
      s.layers = await Promise.allMap(n);
    }
    return s;
  }
  async getSubscriptionLayer(e, t, r) {
    let s = {};
    try {
      let n = await this.provider.getSubscriptionLayerMetadata(e, t, r);
      if (!n)
        return s;
      this.addMetadata(s, n), this.copyProperties(s, n, Oe.SubscriptionLayerPropertyMap());
    } catch (n) {
      console.error(n);
    }
    return s;
  }
  async getCountyMapMetadata(e, t) {
    let r = await this.getCountyLayerBoundarydata(e);
    if (r)
      for (let s in r) {
        let n = r[s], i = n[Oe.ResourceLayerBoundarydataPropertyMap().product];
        if (t === i) {
          let o = {};
          return this.copyProperties(o, n, Oe.ProductBoundarydataPropertyMap()), o;
        }
      }
    return console.error("getCountyMapMetadata failed to metch metadata for " + t), null;
  }
  async getCountyMaps(e) {
    let t = await this.provider.getCountyLayerMetadata(e), r = {};
    for (let i of t.counties) {
      let o = kt(i);
      r[o.map] || (r[o.map] = {
        products: {}
      }), r[o.map].products[i] = this.getCountyProduct(e, i);
    }
    let s = await Promise.allMap(r);
    for (let i in t.freeupdates) {
      let o = t.freeupdates[i], u = kt(o);
      s[u.map].products[o].freeupdate = i;
    }
    let n = await this.getCountyLayerBoundarydata(e);
    if (n)
      for (let i in n) {
        let o = n[i], u = o[Oe.ResourceLayerBoundarydataPropertyMap().product];
        s[u] && this.copyProperties(s[u], o, Oe.ProductBoundarydataPropertyMap());
      }
    return s;
  }
  async getCountyProduct(e, t) {
    let r = kt(t), s = {
      map: r.map,
      version: r.version
    };
    return this.includeMetadata && this.addMetadata(s, await this.provider.getCountyProductMetadata(e, t)), s;
  }
  // getProductId(sku) {
  //     let product = sku.slice(0, -5);     // Remove date
  //     return product.replace(/\W+$/, ""); // Trim non-alphanumeric
  // }
  // splitMapProduct(sku) {
  //     let split = sku.lastIndexOf('_');
  //     let version = sku.slice(split + 1);
  //     let product = sku.slice(0, split);     // Remove date
  //     return {
  //         map: product.replace(/(^[^A-Za-z0-9]*)|([^A-Za-z0-9]*$)/g, ""), // Trim non-alphanumeric
  //         version: version
  //     };
  // }
}
class _n extends qr {
  constructor(e, t) {
    super(e), this.urls = t || {}, this.http = new Wa(), this.builder = new Ya(this), this.builder.includeMetadata = !1;
  }
  async getRegions() {
    return (await this.http.getJson(this.server("tiles") + z.AllRegions())).provinces;
  }
  async getCatalog() {
    this.builder.clearCache();
    const e = await this.builder.getRegions(), t = await Promise.all(e.map(async (r) => [r, await this.builder.getRegion(r)]));
    return this.catalog = Object.fromEntries(t), this.catalog;
  }
  watchCatalog(e) {
    this.builder.getRegions().then((t) => this.processRegions(t, e)).catch((t) => {
      throw t;
    });
  }
  watchRegions(e, t) {
    this.processRegions(e, t);
  }
  watchRegion(e, t) {
    this.builder.getRegion(e).then((r) => (this.catalog[e] = r, t(e, this.catalog[e]))).catch((r) => {
      throw r;
    });
  }
  server(e) {
    return this.urls[e] || "";
  }
  async getRegionMetadata(e) {
    return this.http.getJson(this.server("tiles") + z.RegionMetadata(e));
  }
  async getSubscriptionMetadata(e, t) {
    try {
      return await this.http.getJson(this.server("tiles") + z.SubscriptionMetadata(e, t));
    } catch {
      return null;
    }
  }
  async getSubscriptionLayerMetadata(e, t, r) {
    try {
      return await this.http.getJson(this.server("tiles") + z.SubscriptionLayerMetadata(e, t, r));
    } catch {
      return null;
    }
  }
  async getSubscriptionLayerBoundaryGeoJson(e, t, r) {
    try {
      return await this.http.getJson(
        this.server("tiles") + z.SubscriptionLayerBoundaryGeoJson(e, t, r)
      );
    } catch {
      return null;
    }
  }
  async getResourceMetadata(e, t) {
    try {
      return await this.http.getJson(this.server("tiles") + z.ResourceMetadata(e, t));
    } catch {
      return null;
    }
  }
  async getResourceLayerMetadata(e, t, r) {
    try {
      return await this.http.getJson(this.server("tiles") + z.ResourceLayerMetadata(e, t, r));
    } catch {
      return null;
    }
  }
  async getResourceLayerBoundarydata(e, t, r) {
    try {
      return await this.http.getJson(this.server("web") + z.ResourceLayerBoundarydata(e, t, r));
    } catch {
      return null;
    }
  }
  async getResourceLayerBoundaryGeoJson(e, t, r) {
    try {
      return await this.http.getJson(this.server("tiles") + z.ResourceLayerBoundaryGeoJson(e, t, r));
    } catch {
      return null;
    }
  }
  async getResourceLayerMapMetadata(e, t, r, s) {
    try {
      return t === "purchasable_layers" && r === "county" ? this.builder.getCountyMapMetadata(e, s) : null;
    } catch {
      return null;
    }
  }
  async getResourceLayerProductMetadata(e, t, r, s, n) {
    try {
      return t === "purchasable_layers" && r === "county" ? await this.getCountyProductMetadata(e, n) : null;
    } catch {
      return null;
    }
  }
  async getCountyLayerMetadata(e) {
    try {
      return await this.http.getJson(this.server("tiles") + z.CountyMetadata(e));
    } catch {
      return null;
    }
  }
  async getCountyLayerBoundarydata(e) {
    var r;
    const t = await this.getResourceLayerBoundaryGeoJson(e, "purchasable_layers", "county");
    return ((r = t == null ? void 0 : t.features) == null ? void 0 : r.map((s) => s.properties)) || null;
  }
  async getCountyLayerBoundaryGeoJson(e, t) {
    try {
      return await this.http.getJson(this.server("tiles") + z.CountyBoundaryGeoJson(e, t));
    } catch {
      return null;
    }
  }
  async getCountyProductMetadata(e, t) {
    try {
      return await this.http.getJson(this.server("tiles") + z.CountyProductMetadata(e, t));
    } catch {
      return null;
    }
  }
  getProductId(e) {
    return e.slice(0, -5).replace(/\W+$/, "");
  }
  // splitMapProduct(sku) {
  //     let split = sku.lastIndexOf('_');
  //     let version = sku.slice(split + 1);
  //     let product = sku.slice(0, split);     // Remove date
  //     return {
  //         product: product.replace(/(^[^A-Za-z0-9]*)|([^A-Za-z0-9]*$)/g, ""), // Trim non-alphanumeric
  //         version: version
  //     };
  // }
}
const ct = {
  UPGRADE: 0.2,
  // 20% off map upgrades
  UPGRADE_NAME: "Map update discount",
  UPGRADE_EXPIRES_IN_HOURS: 24
  // Stripe checkout sessions expire in 24 hours by default
};
class Mn {
  static ApplyUpgradeDiscount(e) {
    return this.ApplyDiscount(e, ct.UPGRADE);
  }
  static UpgradeDiscount() {
    return 100 * ct.UPGRADE;
  }
  static UpgradeDiscountName() {
    return ct.UPGRADE_NAME;
  }
  static UpgradeDiscountMinDateBeforeExpiry() {
    return new Date(Date.now() - ct.UPGRADE_EXPIRES_IN_HOURS * 60 * 60 * 1e3);
  }
  static ApplyDiscount(e, t) {
    return (e * (1 - t)).toFixed(2);
  }
}
class ur {
  constructor(e, t) {
    this.environment = null, this.config = {}, this.initialize(e, t);
  }
  get name() {
    return this.config.name;
  }
  get product() {
    return this.config.product;
  }
  get firebase() {
    return this.config.firebase;
  }
  initialize(e, t) {
    var r, s;
    try {
      t != null && t.default && ur.isLocal() ? (this.environment = t.default, console.log(`Selected ${this.environment} environment configuration`)) : (this.environment = this.findDefault(e), console.log(`Detected ${this.environment} environment configuration`)), this.config = e[this.environment], t != null && t.override && ((r = this.config) != null && r.debug || console.warn("Applying configuration overrides - for development purposes only!"), this.applyOverrides(e, t.override)), (s = this.config) != null && s.debug && console.log(`${this.config.name} environment loaded`);
    } catch (n) {
      throw console.error("Loading environment configuration", n), n;
    }
  }
  findDefault(e) {
    var n, i;
    const t = window.location.hostname;
    let r = null, s = null;
    for (let o in e) {
      (n = e[o]) != null && n.default && (r = o);
      for (let u of (i = e[o]) == null ? void 0 : i.hostname)
        if (t.includes(u))
          return o;
      s = s || o;
    }
    if (r || s)
      return r || s;
    throw new Error("Detecting default configuration");
  }
  applyOverrides(e, t, r = []) {
    for (const s in t)
      if (Object.prototype.hasOwnProperty.call(t, s)) {
        const n = t[s], i = [...r, s];
        if (n !== null && typeof n == "object") {
          this.applyOverrides(e, n, i);
          continue;
        }
        let o = !1, u = n, d = e[n];
        if (d) {
          for (const m of i) {
            if (!d[m]) {
              o = !0;
              break;
            }
            d = d[m];
          }
          u = d;
        }
        if (o) {
          console.log(`Override missing for ${i.join(".")}`);
          continue;
        }
        let l = this.config;
        for (let m = 0; m < i.length - 1; m++) {
          const f = i[m];
          l[f] || (l[f] = {}), l = l[f];
        }
        const E = i[i.length - 1];
        l[E] = u, console.log(`Override ${i.join("-")}: ${u} [${n}]`);
      }
  }
  static get projectId() {
    return this.isProduction() ? "ihunter-d5eab" : this.isDevelopment() || this.isLocal() && USE_DEV_WHEN_LOCAL ? "ihunterdev" : (this.isLocal(), "localhost");
  }
  static firebaseConfig() {
    var e;
    return process && ((e = process == null ? void 0 : process.env) == null ? void 0 : e.FIREBASE_CONFIG) && JSON.parse(process.env.FIREBASE_CONFIG);
  }
  static isLocal() {
    return window.location.hostname.includes("localhost") || window.location.hostname.includes("127.0.0.1");
  }
  static isDevelopment() {
    return window.location.hostname.includes("dev");
  }
  static isProduction() {
    return !this.isDevelopment() && !this.isLocal();
  }
}
const Rr = (a) => a && (typeof a == "string" || a instanceof String), Kr = (a) => a === 0 || a && !isNaN(Number(a)), za = (a) => Kr(a) && Number(a) > 1e12;
class Pt {
  /**
   * Gets the current date as a string in ISO format (UTC time).
   * This is used as a prefix for chat message keys in the db.
   * @returns {number} the current UTC date and time in the format: YYYY-MM-DD HH:mm:ss
   */
  static get CurrentUTCDateString() {
    const e = /* @__PURE__ */ new Date();
    return this.formatUTCDate(e);
  }
  /**
   * Generates a UTC date string formatted as 'YYYY-MM-DD HH:MM:SS' offset by a specified number of days in the future.
   *
   * @param {number} [days] - The number of days to offset into the future.
   * @returns {string} The formatted UTC date string (e.g., '2026-10-05 10:49:17').
   */
  static getFutureUTCDateString(e = 0) {
    const t = /* @__PURE__ */ new Date();
    return t.setDate(t.getDate() + e), this.formatUTCDate(t);
  }
  static formatUTCDate(e) {
    return e.toISOString().replace(/\.[0-9]{3}/, "").replace("T", " ").replace("Z", "");
  }
  /**
   * Gets the current date as a string in ISO format, but with the local date and time instead of UTC.
   * !!! WARNING !!! This only returns local time if called client-side (ie. a web browser or generator utility from command line),
   * It will return UTC if called from a cloud function.
   *
   * Waypoint dates are stored as local time in the db.
   * Future improvement: store waypoint dates as epoch timestamps instead.
   * @returns {number} the current local date and time in the format: YYYY-MM-DD HH:mm:ss
   */
  static get CurrentLocalDateString() {
    const e = (d) => String(d).padStart(2, "0"), t = /* @__PURE__ */ new Date(), r = t.getFullYear(), s = e(t.getMonth() + 1), n = e(t.getDate()), i = e(t.getHours()), o = e(t.getMinutes()), u = e(t.getSeconds());
    return `${r}-${s}-${n} ${i}:${o}:${u}`;
  }
  /**
   * Converts a date to an epoch timestamp in milliseconds.
   * @param {(string|number)} date - an integer epoch timestamp, or a string representing a date in ISO format (details below).
   * @returns {number} an integer representing the epoch timestamp in milliseconds. The current time will be returned if the input parameter is invalid.
   *
   * Supported string formats:
   * - ISO 8601 format: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'" (UTC)
   * - Format used by many gps: "yyyy-MM-dd'T'HH:mm:ss'Z'" (UTC)
   * - Format used in our db: "yyyy-MM-DD HH:mm:ss" (local timezone)
   * - An epoch timestamp in seconds since 1970
   * - An epoch timestamp in milliseconds since 1970
   */
  static ConvertDateToEpochTimeMs(e) {
    let t;
    if (Kr(e)) {
      const r = Number(e);
      t = new Date(za(r) ? r : r * 1e3);
    } else if (Rr(e)) {
      let r = e.replace(" ", "T");
      t = new Date(r);
    }
    return (!t || isNaN(t.getTime())) && (t = /* @__PURE__ */ new Date()), t.getTime();
  }
  /**
   * Converts a date to an epoch timestamp in seconds.
   * @param {(string|number)} date - an integer epoch timestamp, or a string representing a date in ISO format.
   * @returns {number} an integer representing the epoch timestamp in seconds. The current time will be returned if the input parameter is invalid.
   *
   * Supported string formats:
   * - ISO 8601 format: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'" (UTC)
   * - Format used by many gps: "yyyy-MM-dd'T'HH:mm:ss'Z'" (UTC)
   * - Format used in our db: "yyyy-MM-DD HH:mm:ss" (local timezone)
   * - An epoch timestamp in seconds since 1970
   * - An epoch timestamp in milliseconds since 1970
   */
  static ConvertDateToEpochTimeSeconds(e) {
    return Math.floor(Pt.ConvertDateToEpochTimeMs(e) / 1e3);
  }
  /**
  * Parses a UTC date string in the format used by clients for synced UTC dates (e.g. collection filter dates),
  * and converts it to an epoch timestamp in milliseconds.
  * 
  * Mobile equivalent: dateFromStringUTC. 
  *
  * The expected format is 'YYYY-MM-DD HH:mm:ss' in UTC.
  * A 'T' separator and a trailing 'Z' are also accepted, e.g. '2026-09-01T06:00:00Z'.
  *
  * Unlike {@link DateHelpers.ConvertDateToEpochTimeMs}, which interprets strings without a timezone as local time
  * and falls back to the current time for invalid input, this parser:
  * - always interprets the value as UTC, and
  * - returns null for missing or invalid values,
  *   so callers can ignore the value rather than silently treating it as 'now'.
  *
  * @example
  * DateHelpers.ParseUTCDateString('2026-09-01 06:00:00'); // 1788242400000 (2026-09-01T06:00:00.000Z)
  * DateHelpers.ParseUTCDateString('2026-09-01T06:00:00Z'); // 1788242400000
  * DateHelpers.ParseUTCDateString('2026-02-30 00:00:00'); // null (invalid day)
  * DateHelpers.ParseUTCDateString('9/1/2026'); // null (unsupported format)
  * DateHelpers.ParseUTCDateString(undefined); // null
  *
  * @param {string} dateString - a UTC date string formatted as 'YYYY-MM-DD HH:mm:ss'.
  * @returns {(number|null)} the epoch timestamp in milliseconds, or null if the value is missing or invalid.
  */
  static ParseUTCDateString(e) {
    if (!Rr(e))
      return null;
    const t = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})Z?$/.exec(e.trim());
    if (!t)
      return null;
    const [r, s, n, i, o, u] = t.slice(1).map(Number), d = Date.UTC(r, s - 1, n, i, o, u), l = new Date(d);
    return l.getUTCFullYear() === r && l.getUTCMonth() === s - 1 && l.getUTCDate() === n && l.getUTCHours() === i && l.getUTCMinutes() === o && l.getUTCSeconds() === u ? d : null;
  }
  /**
   * Formats a duration in hours, minutes and/or seconds as appropriate.
   * @param {(string|number)} durationMs - the duration in milliseconds.
   * @returns {string} the formatted duration (trailing ':00' is omitted):
   * - in seconds for durations under 1 minute (e.g. 0:45 s),
   * - in mm:ss for durations over 1 minute (e.g. 5 min, 5:25 min),
   * - in hh:mm:ss for durations over 1 hour (e.g. 2 h, 2:15 h, 2:15:30 h)
   */
  static FormatDurationMsAsString(e) {
    if (e = Number(e), isNaN(e) || e < 0) return null;
    const t = Math.floor(e / 1e3), r = Math.floor(t / 3600), s = Math.floor(t % 3600 / 60), n = t % 60, i = (o) => String(o).padStart(2, "0");
    if (r >= 1)
      return s === 0 && n === 0 ? `${r} h` : n === 0 ? `${r}:${i(s)} h` : `${r}:${i(s)}:${i(n)} h`;
    if (s >= 1) {
      const o = Math.floor(t / 60);
      return n === 0 ? `${o} min` : `${o}:${i(n)} min`;
    } else
      return n === 0 ? "0 s" : `${s}:${i(n)} s`;
  }
}
class Jr {
  static firebaseConfig() {
    var e;
    return process && ((e = process == null ? void 0 : process.env) == null ? void 0 : e.FIREBASE_CONFIG) && JSON.parse(process.env.FIREBASE_CONFIG);
  }
  static isLocal() {
    return window.location.hostname.includes("localhost") || window.location.hostname.includes("127.0.0.1");
  }
  static isDevelopment() {
    return window.location.hostname.includes("dev");
  }
  static isProduction() {
    return !this.isDevelopment() && !this.isLocal();
  }
  constructor(e, t) {
    this.environment = null, this.config = {}, this.initialize(e, t);
  }
  get name() {
    return this.config.name;
  }
  get product() {
    return this.config.product;
  }
  get firebase() {
    return this.config.firebase;
  }
  initialize(e, t) {
    var r, s;
    try {
      t != null && t.default && Jr.isLocal() ? (this.environment = t.default, console.log(`Selected ${this.environment} environment configuration`)) : (this.environment = this.findDefault(e), console.log(`Detected ${this.environment} environment configuration`)), this.config = e[this.environment], t != null && t.override && ((r = this.config) != null && r.debug || console.warn("Applying configuration overrides - for development purposes only!"), this.applyOverrides(e, t.override)), (s = this.config) != null && s.debug && console.log(`${this.config.name} environment loaded`);
    } catch (n) {
      throw console.error("Loading environment configuration", n), n;
    }
  }
  findDefault(e) {
    var n, i, o, u, d;
    const t = window.location.hostname;
    let r = null, s = null;
    for (let l in e) {
      if ((n = e[l]) != null && n.default && (r = l), (i = e[l]) != null && i.hostname && ((u = (o = e[l]) == null ? void 0 : o.hostname) != null && u.length)) {
        for (let E of (d = e[l]) == null ? void 0 : d.hostname)
          if (E && t.includes(E))
            return l;
      }
      s = s || l;
    }
    if (r || s)
      return r || s;
    throw new Error("Detecting default configuration");
  }
  applyOverrides(e, t, r = []) {
    for (const s in t)
      if (Object.prototype.hasOwnProperty.call(t, s)) {
        const n = t[s], i = [...r, s];
        if (n !== null && typeof n == "object") {
          this.applyOverrides(e, n, i);
          continue;
        }
        let o = !1, u = n, d = e[n];
        if (d) {
          for (const m of i) {
            if (!d[m]) {
              o = !0;
              break;
            }
            d = d[m];
          }
          u = d;
        }
        if (o) {
          console.log(`Override missing for ${i.join(".")}`);
          continue;
        }
        let l = this.config;
        for (let m = 0; m < i.length - 1; m++) {
          const f = i[m];
          l[f] || (l[f] = {}), l = l[f];
        }
        const E = i[i.length - 1];
        l[E] = u, console.log(`Override ${i.join("-")}: ${u} [${n}]`);
      }
  }
  // async fetchFirebaseConfig() {
  //     try {
  //         const response = await fetch('/__/firebase/init.json');
  //         return await response.json();
  //     } catch (error) {
  //         console.error("Fetching hosted configuration", error);
  //         return null;
  //     }
  // }
}
const ae = {
  BOUNDARIES: "/layers/{region}/{group}/{layer}/boundaries.json?include={include}",
  BOUNDARIES_AT_LOCATION: "/layers/{region}/{group}/{layer}/boundaries/{lat},{lon}.json?include={include}",
  BOUNDARIES_MATCHING_SEARCH: "/layers/{region}/{group}/{layer}/boundaries.json?&search={search}&field={field}&include={include}&max={max}",
  BOUNDARY_AG_LEASE_INFO: "/layers/{region}/{group}/{layer}/boundaries/{code}/aglease.json",
  BATCH_BOUNDARIES_AT_LOCATION: "/layers/{region}/boundaries/batch/location",
  BATCH_BOUNDARIES_MATCHING_SEARCH: "/layers/{region}/boundaries/batch/search",
  REGULATIONS: "/layers/{region}/regulations/{code}.json",
  VECTOR_METADATA: "/layers/{region}/{group}/{layer}.json",
  VECTOR_TILE: "/layers/{region}/{group}/{layer}/boundaries/{z}/{x}/{y}.pbf",
  BOUNDARY_HTML_FILE: "/res/provinces/{region}/{group}/{layer}/{file}",
  BOUNDARY_PDF_FILE: "/res/provinces/{region}/pdfs/{file}"
};
Object.freeze(ae);
class Xe {
  static Boundaries(e, t, r, s) {
    return c(ae.BOUNDARIES, { region: e, group: t, layer: r, include: s });
  }
  static BoundariesAtLocation(e, t, r, s) {
    return c(ae.BOUNDARIES_AT_LOCATION, { region: e, group: t, layer: r, include: s });
  }
  static BoundariesMatchingSearch(e, t, r, s, n, i, o) {
    return c(ae.BOUNDARIES_MATCHING_SEARCH, { region: e, group: t, layer: r, search: s, field: n, include: i, max: o });
  }
  static BatchBoundariesAtLocation(e) {
    return c(ae.BATCH_BOUNDARIES_AT_LOCATION, { region: e });
  }
  static BatchBoundariesMatchingSearch(e) {
    return c(ae.BATCH_BOUNDARIES_MATCHING_SEARCH, { region: e });
  }
  static Regulations(e, t) {
    return c(ae.REGULATIONS, { region: e, code: t });
  }
  static VectorMetadata(e, t, r) {
    return c(ae.VECTOR_METADATA, { region: e, group: t, layer: r });
  }
  static VectorTile(e, t, r) {
    return c(ae.VECTOR_TILE, { region: e, group: t, layer: r });
  }
  static BoundaryHtmlFile(e, t, r, s) {
    return c(ae.BOUNDARY_HTML_FILE, { region: e, group: t, layer: r, file: s });
  }
  static BoundaryPdfFile(e, t) {
    return c(ae.BOUNDARY_PDF_FILE, { region: e, file: t });
  }
  static BoundaryAgLeaseInfo(e, t, r, s) {
    return c(ae.BOUNDARY_AG_LEASE_INFO, { region: e, group: t, layer: r, code: s });
  }
}
const ke = {
  PREFERENCES: "/mailinglist/users/{uid}",
  OPT_IN: "/mailinglist/users/{uid}/optin",
  // Set to true to opt-in to mailing list
  STATUS: "/mailinglist/users/{uid}/status",
  // Latest status from Mailchimp (pending, subscribed, unsubscribed, cleaned)
  EMAIL: "/mailinglist/users/{uid}/email"
  // Email address used for mailing list
};
class Ze {
  static Preferences(e) {
    return c(ke.PREFERENCES, { uid: e });
  }
  static OptIn(e) {
    return c(ke.OPT_IN, { uid: e });
  }
  static OptInRoute() {
    return ke.OPT_IN;
  }
  static Status(e) {
    return c(ke.STATUS, { uid: e });
  }
  static StatusRoute() {
    return ke.STATUS;
  }
  static Email(e) {
    return c(ke.EMAIL, { uid: e });
  }
  static EmailRoute() {
    return ke.EMAIL;
  }
}
class vn extends st {
  constructor(e) {
    super(), this.auth = e, this.unwatch = null, this.optin = !1, this.email = null, this.status = null;
  }
  async watchPreferences(e, t, r) {
    return console.log("Watching mailing list preferences"), this.unwatch = await this.watch(
      Ze.Preferences(e),
      async (s) => {
        s && (this.optin = s.optin, this.email = s.email, this.status = s.status, t(s));
      },
      r
    ), () => this.unwatchPreferences();
  }
  unwatchPreferences() {
    this.unwatch && (this.unwatch(), this.unwatch = null);
  }
  async setOptIn(e) {
    return await this.set(Ze.OptIn(this.uid), e);
  }
  async setEmail(e) {
    return await this.set(Ze.Email(this.uid), e);
  }
  async getOptIn() {
    return await this.get(Ze.OptIn(this.uid));
  }
  async getEmail() {
    return await this.get(Ze.Email(this.uid));
  }
  get uid() {
    return this.auth.currentUser.uid;
  }
}
const He = {
  AB: {
    boundaries: [
      [-120, 48.994],
      [-110.005, 60]
    ]
  },
  BC: {
    boundaries: [
      [-130, 48.5],
      [-118, 60]
    ]
  },
  MB: {
    boundaries: [
      [-102, 48.993],
      [-88.999, 60]
    ]
  },
  NB: {
    boundaries: [
      [-69.058, 44.584],
      [-63.664, 48.069]
    ]
  },
  NL: {
    boundaries: [
      [-70, 46.565],
      [-52, 60.335]
    ]
  },
  NS: {
    boundaries: [
      [-66.375, 43.38],
      [-59.786, 47.096]
    ]
  },
  ON: {
    boundaries: [
      [-95.153, 41.681],
      [-74.343, 56.856]
    ]
  },
  PEI: {
    boundaries: [
      [-64.634, 45.898],
      [-61.975, 47.076]
    ]
  },
  QC: {
    boundaries: [
      [-79.763, 44.993],
      [-57.108, 62.583]
    ]
  },
  SK: {
    boundaries: [
      [-110.005, 48.994],
      [-101.36, 60]
    ]
  },
  NW: {
    boundaries: [
      [-136.5, 60],
      [-102, 75]
    ]
  },
  NV: {
    boundaries: [
      [-141, 60],
      [-52.636, 83.116]
    ]
  },
  YT: {
    boundaries: [
      [-141, 60],
      [-123, 69.65]
    ]
  },
  Canada: {
    boundaries: [
      // Broad majority of Canada
      [-138, 49],
      [-45, 60]
    ],
    center: { lat: 56.74726821145677, lng: -91.69492971359193 }
  }
};
Object.freeze(He);
const Xr = Object.keys(He);
Object.freeze(Xr);
const Zr = Object.keys(He).map((a) => a.toLowerCase());
Object.freeze(Zr);
const ar = "Canada", Ha = ar.toLowerCase();
class Ln {
  static get RegionNames() {
    return Xr;
  }
  static get RegionNamesLower() {
    return Zr;
  }
  static get Region() {
    return He;
  }
  static GetRegion(e) {
    return e.toLowerCase() === Ha ? He[ar] : He[e.toUpperCase()];
  }
  static get DefaultRegionName() {
    return ar;
  }
}
const Me = {
  PREFERENCES: "/sync/{uid}/preferences",
  REGION: "/sync/{uid}/preferences/{region}",
  SETTINGS: "/sync/{uid}/settings",
  MAP_LAYERS: "/sync/{uid}/maplayers",
  COUNTY_MAPS: "/sync/{uid}/countymaps",
  REGION_MAPS: "/sync/{uid}/countymaps/{region}",
  WEB: "/sync/{uid}/web"
};
Object.freeze(Me);
const D = {
  HUNTLOG_OPT_IN: "UofaOptedIn",
  METRIC_UNITS: "IsMetric",
  COORD_FORMAT: "CoordinateFormat",
  YARDS_UNITS: "UseYards",
  HIGHLIGHT_SELECTED: "HighlightSelectedWMU",
  COLLECTION_LAYER_VISIBLE: "ShowCollectionLayers",
  BUILT_IN_LAYER_VISIBLE: "ShowBuiltInLayers",
  REGULATIONS_VISIBLE: "ShowRegulations",
  SUBSCRIPTION_LAYER_VISIBLE: "ShowSubscriptionLayers",
  LANDOWNER_MAPS_VISIBLE: "ShowLandownerMaps",
  CUSTOM_LAYER_VISIBLE: "ShowCustomLayers",
  LAST_PIN_OVERLAY: "LastPinOverlay",
  LAST_PIN_COLOR: "LastPinColor",
  LAST_INK_COLOR: "LastInkColor",
  LAST_INK_TOOL: "LastInkTool",
  SHOW_DIST_LABELS: "ShowDistanceLabels",
  SHOW_AREA_LABELS: "ShowAreaLabels"
};
Object.freeze(D);
const Et = {
  MAP_VISIBLE: "showMap",
  BOUNDARY_VISIBLE: "showBoundary",
  OPACITY: "opacity"
};
Object.freeze(Et);
const Qr = {
  LANGUAGE: "language"
};
Object.freeze(Qr);
const ve = {
  ENGINE: "basemapEngine",
  PROVIDER: "basemapProvider",
  TYPE: "basemapType",
  CENTER: "mapCenter",
  ZOOM: "mapZoom",
  PITCH: "mapPitch",
  BEARING: "mapBearing"
};
Object.freeze(ve);
const sr = {
  ACTIVE_REGION: "activeProvince"
};
Object.freeze(sr);
class Le {
  static Preferences(e) {
    return c(Me.PREFERENCES, { uid: e });
  }
  static Region(e, t) {
    return c(Me.REGION, { uid: e, region: t });
  }
  static MapLayers(e) {
    return c(Me.MAP_LAYERS, { uid: e });
  }
  static CountyMaps(e) {
    return c(Me.COUNTY_MAPS, { uid: e });
  }
  static RegionMaps(e, t) {
    return c(Me.REGION_MAPS, { uid: e, region: t });
  }
  static Web(e) {
    return c(Me.WEB, { uid: e });
  }
  static Settings(e) {
    return c(Me.SETTINGS, { uid: e });
  }
  static MetricRoute(e, t) {
    return `${Le.Region(e, t)}/${D.METRIC_UNITS}`;
  }
  static ActiveRegionRoute(e) {
    return `${Le.Web(e)}/${sr.ACTIVE_REGION}`;
  }
  static UseYardsRoute(e, t) {
    return `${Le.Region(e, t)}/${D.YARDS_UNITS}`;
  }
  static CoordinateFormatRoute(e, t) {
    return `${Le.Region(e, t)}/${D.COORD_FORMAT}`;
  }
  static HighlightSelectedWmuRoute(e, t) {
    return `${Le.Region(e, t)}/${D.HIGHLIGHT_SELECTED}`;
  }
  static LanguageRoute(e) {
    return `${Le.Settings(e)}/${Le.Language()}`;
  }
  static ActiveRegion() {
    return sr.ACTIVE_REGION;
  }
  static HuntLogOptIn() {
    return D.HUNTLOG_OPT_IN;
  }
  static Metric() {
    return D.METRIC_UNITS;
  }
  static UseYards() {
    return D.YARDS_UNITS;
  }
  static CoordinateFormat() {
    return D.COORD_FORMAT;
  }
  static HighlightSelected() {
    return D.HIGHLIGHT_SELECTED;
  }
  static Language() {
    return Qr.LANGUAGE;
  }
  static BasemapEngine() {
    return ve.ENGINE;
  }
  static BasemapProvider() {
    return ve.PROVIDER;
  }
  static BasemapType() {
    return ve.TYPE;
  }
  static MapCenter() {
    return ve.CENTER;
  }
  static MapZoom() {
    return ve.ZOOM;
  }
  static MapPitch() {
    return ve.PITCH;
  }
  static MapBearing() {
    return ve.BEARING;
  }
  static CollectionLayerSetVisibility() {
    return D.COLLECTION_LAYER_VISIBLE;
  }
  static BuiltInLayerSetVisibility() {
    return D.BUILT_IN_LAYER_VISIBLE;
  }
  static RegulationsSetVisibility() {
    return D.REGULATIONS_VISIBLE;
  }
  static SubscriptionLayerSetVisibility() {
    return D.SUBSCRIPTION_LAYER_VISIBLE;
  }
  static LandownerMapsSetVisibility() {
    return D.LANDOWNER_MAPS_VISIBLE;
  }
  static CustomLayerSetVisibility() {
    return D.CUSTOM_LAYER_VISIBLE;
  }
  static MapProductVisibility() {
    return Et.MAP_VISIBLE;
  }
  static MapBoundaryVisibility() {
    return Et.BOUNDARY_VISIBLE;
  }
  static MapOpacity() {
    return Et.OPACITY;
  }
  static LastPinOverlay() {
    return D.LAST_PIN_OVERLAY;
  }
  static LastPinColor() {
    return D.LAST_PIN_COLOR;
  }
  static LastInkColor() {
    return D.LAST_INK_COLOR;
  }
  static LastInkTool() {
    return D.LAST_INK_TOOL;
  }
  static ShowDistanceLabels() {
    return D.SHOW_DIST_LABELS;
  }
  static ShowAreaLabels() {
    return D.SHOW_AREA_LABELS;
  }
}
const Tr = {
  PICTURE_STORAGE: "/users/{uid}/UserProfilePic.jpg",
  PICTURE_DATE: "/users/{uid}/profilePicDate"
  // YYYY-MM-DD HH:mm:ss
};
class Qe {
  static PictureStorage(e) {
    return c(Tr.PICTURE_STORAGE, { uid: e });
  }
  static PictureDate(e) {
    return c(Tr.PICTURE_DATE, { uid: e });
  }
}
var mt = { exports: {} };
class qa {
  constructor(e, t) {
    this.blob = e, this.filename = t;
  }
}
var Ka = function(a) {
  var e = a.file, t = a.maxSize, r = new FileReader(), s = new Image(), n = document.createElement("canvas"), i = function(u) {
    for (var d = u.split(",")[0].indexOf("base64") >= 0 ? atob(u.split(",")[1]) : unescape(u.split(",")[1]), l = u.split(",")[0].split(":")[1].split(";")[0], E = d.length, m = new Uint8Array(E), f = 0; f < E; f++) m[f] = d.charCodeAt(f);
    return new qa(new Blob([m], { type: l }), e.name);
  }, o = function() {
    var u = s.width, d = s.height;
    u > d ? u > t && (d *= t / u, u = t) : d > t && (u *= t / d, d = t), n.width = u, n.height = d, n.getContext("2d").drawImage(s, 0, 0, u, d);
    var l = n.toDataURL("image/jpeg");
    return i(l);
  };
  return new Promise(function(u, d) {
    if (!e.type.match(/image.*/)) {
      d(new Error("Not an image"));
      return;
    }
    r.onload = function(l) {
      s.onload = function() {
        return u(o());
      }, s.src = l.target.result;
    }, r.readAsDataURL(e);
  });
};
mt.exports = Ka;
const Ja = (mt.exports == null ? {} : mt.exports).default || mt.exports;
class Dn extends st {
  constructor(e) {
    super(), this.auth = e;
  }
  async uploadProfilePicture(e) {
    try {
      let t = await Ja({
        file: e,
        maxSize: 750
        //adjust this if the size is too big/small. This seems to be about 100-150kb, which is OK quality
      }), r = { contentType: e.type };
      await this.uploadObject(Qe.PictureStorage(this.uid), t.blob, r);
      let s = await this.objectUrl(Qe.PictureStorage(this.uid));
      return console.log(`Profile photo updated: ${s}`), await this.updatePhoto(s), await this.updatePictureDate(), s;
    } catch (t) {
      throw console.error("Upload profile: " + t.message), t;
    }
  }
  async deleteProfilePicture() {
    try {
      const e = Qe.PictureStorage(this.uid);
      await this.deleteObject(e), await this.updatePhoto(""), await this.updatePictureDate();
    } catch (e) {
      throw console.error("Delete profile: " + e.message), e;
    }
  }
  async updatePictureDate() {
    return await this.set(Qe.PictureDate(this.uid), this.currentTime);
  }
  get uid() {
    return this.auth.currentUser.uid;
  }
  get currentTime() {
    return _a().format("YYYY-MM-DD HH:mm:ss");
  }
  async getPhotoUrl() {
    const e = Qe.PictureStorage(this.uid);
    return await this.objectUrl(e);
  }
  // get profilePictureExists() {
  //     (async () => {
  //         try {
  //             const path = ProfileResources.PictureStorage(this.uid);
  //             await this.objectUrl(path)
  //             return true;
  //         } catch(e) {
  //             return false;
  //         }
  //         })();
  // }
  async sendPasswordResetEmail() {
    try {
      return await Ma(this.auth, this.auth.currentUser.email);
    } catch (e) {
      throw console.error("Password reset: " + e.message), e;
    }
  }
  async updateEmail(e) {
    try {
      return await updateEmail(this.auth.currentUser, e);
    } catch (t) {
      throw console.error("Updating email address: " + t.message), t;
    }
  }
  async updateUserProfile(e) {
    try {
      return await Qt(this.auth.currentUser, {
        displayName: e.trim()
      });
    } catch (t) {
      throw console.error("Updating profile name: " + t.message), t;
    }
  }
  async updatePhoto(e) {
    try {
      return await Qt(this.auth.currentUser, {
        photoURL: e
      });
    } catch (t) {
      throw console.error("Updating profile photo: " + t.message), t;
    }
  }
  async reauthenticateWithCredential(e) {
    try {
      const t = va.credential(this.auth.currentUser.email, e);
      return await La(this.auth, t);
    } catch (t) {
      throw console.error("Verifying credentials: " + t.message), t;
    }
  }
}
const xe = {
  APPLE: "/purchases_ios/{uid}",
  ANDROID: "/purchases_android/{uid}",
  WEB: "/purchases_web/{uid}",
  SKU: "/{region}/{sku}"
};
Object.freeze(xe);
class Bt {
  static Apple(e) {
    return c(xe.APPLE, { uid: e });
  }
  static Android(e) {
    return c(xe.ANDROID, { uid: e });
  }
  static Web(e) {
    return c(xe.WEB, { uid: e });
  }
  static WebPurchase(e, t, r) {
    return c(xe.WEB, { uid: e }) + c(xe.SKU, { region: t, sku: r });
  }
}
class Xa extends Ua {
  constructor() {
    super();
  }
  createHandlerMethod(e) {
    return (t) => {
      if (typeof t != "function")
        throw TypeError("Invalid callback handler");
      return super.on(e, (...r) => {
        t(...r);
      });
    };
  }
  emit(e, ...t) {
    if (!e)
      throw new Error("Unable to emit undefined event");
    ur.isLocal() && (t.length > 0 ? console.info(`Event ${e} %o`, [...t]) : console.info(`Event ${e}`)), super.emit(e, ...t);
  }
}
var ft = { exports: {} };
function Za(a) {
  return !isNaN(parseFloat(a)) && isFinite(a);
}
ft.exports = Za;
const Qa = (ft.exports == null ? {} : ft.exports).default || ft.exports, $t = {
  Update: "purchase-update"
  // Update to purchases
}, Q = {
  Apple: "apple",
  Android: "android",
  Web: "web"
};
class Un extends Xa {
  constructor() {
    super(), this.firebase = new st(), this.unwatchPlatform = {}, this.keymap = {}, this.items = {}, this.purchases = {}, this.onUpdate = this.createHandlerMethod($t.Update);
  }
  updateProductCatalog(e, t) {
    this.updateMobileKeymap(e, t), this.refreshPurchases();
  }
  updateMobileKeymap(e, t) {
    if (!(!e || !e.subscriptions))
      for (const r of Object.values(e.subscriptions))
        r.sku_ios && (this.keymap[Q.Apple] || (this.keymap[Q.Apple] = {}), this.keymap[Q.Apple][t] || (this.keymap[Q.Apple][t] = {}), this.keymap[Q.Apple][t][r.sku_ios] = r.sku_web), r.sku_android && (this.keymap[Q.Android] || (this.keymap[Q.Android] = {}), this.keymap[Q.Android][t] || (this.keymap[Q.Android][t] = {}), this.keymap[Q.Android][t][r.sku_android] = r.sku_web);
  }
  // Convert possibly-duplicate, regional, platform-specific, mobile product keys to unique web skus
  remapMobileKey(e, t, r) {
    return this.keymap[e] && this.keymap[e][t] && this.keymap[e][t][r] ? this.keymap[e][t][r] : r;
  }
  // remapMobilePlatformPurchase(key, platform) {
  //     // Check to see if mobile key exist in our platform-specific keymap
  //     if (this.keymap[platform] && this.keymap[platform][key]) {
  //         // Convert key to sku
  //         const sku = this.keymap[platform][key];
  //         if(!this.purchases[sku]) {
  //             this.purchases[sku] = {};
  //         }
  //         if(!this.purchases[sku][platform]) {
  //             this.purchases[sku][platform] = {};
  //         }
  //         // Add new sku purchase
  //         this.purchases[sku][platform] = this.purchases[key][platform];
  //         // Remove entire old platform key purchase
  //         delete this.purchases[key];
  //     }
  // }
  refreshPurchases() {
    this.purchases = {};
    for (let e in this.items)
      this.processPurchases(e, this.items[e]);
    this.emit($t.Update, this.purchases);
  }
  watch(e, t) {
    this.onUpdate(t), this.watchPlatform(Q.Apple, Bt.Apple(e)), this.watchPlatform(Q.Android, Bt.Android(e)), this.watchPlatform(Q.Web, Bt.Web(e));
  }
  watchPlatform(e, t) {
    if (this.unwatchPlatform[e])
      return;
    console.log(`Watching ${e} product purchases`);
    let r = G(this.firebase.db, t);
    this.unwatchPlatform[e] = Ee(
      re(r),
      async (s) => {
        try {
          console.log(`Platform purchase update ${e}`), this.items[e] = s.val(), this.processPurchases(e, this.items[e]), this.emit($t.Update, this.purchases);
        } catch (n) {
          console.error(`Updating ${e} product purchases`, n);
        }
      },
      (s) => {
        console.error(`Watching ${e} product purchases`, s);
      }
    );
  }
  processPurchases(e, t) {
    if (!t)
      return this.purchases;
    for (let r in t)
      for (let s in t[r])
        if (this.validatePurchase(t[r][s])) {
          let n = this.reconstructSku(s);
          n = this.remapMobileKey(e, r, n), this.purchases[n] || (this.purchases[n] = {}), this.purchases[n][e] || (this.purchases[n][e] = {}), this.purchases[n][e] = t[r][s];
        }
    return this.purchases;
  }
  reconstructSku(e) {
    return e.replace(/,/g, ".");
  }
  validatePurchase(e) {
    if (!e)
      return !1;
    let t = e.expirydate || e;
    if (Qa(t)) {
      const r = new Date(Number(t) * 1e3);
      if (r.getTime() > 0) {
        const s = /* @__PURE__ */ new Date();
        return s.setHours(0, 0, 0, 0), !(r.getTime() < s.getTime());
      }
    }
    return !0;
  }
}
const nr = {
  PROMOTIONS: "/store/promotions",
  CART: "/store/cart/{uid}"
};
Object.freeze(nr);
class kn {
  static Promotions() {
    return nr.PROMOTIONS;
  }
  static Cart(e) {
    return c(nr.CART, { uid: e });
  }
}
const ge = {
  BILLING: "billing",
  UPDATES: "updates",
  PURCHASES: "purchases",
  SUPPORT: "support",
  ACCOUNT: "account",
  REGION: "{region}",
  PRODUCT: "product/{sku}",
  MAP: "map/{sku}",
  SUBSCRIPTION: "subscription/{sku}"
};
Object.freeze(ge);
class Bn {
  static Billing() {
    return ge.BILLING;
  }
  static Updates() {
    return ge.UPDATES;
  }
  static Purchases() {
    return ge.PURCHASES;
  }
  static Support() {
    return ge.SUPPORT;
  }
  static Account() {
    return ge.ACCOUNT;
  }
  static Region(e) {
    return c(ge.REGION, { region: e });
  }
  static Product(e) {
    return c(ge.PRODUCT, { sku: e });
  }
  static Map(e) {
    return c(ge.MAP, { sku: e });
  }
  static Subscription(e) {
    return c(ge.SUBSCRIPTION, { sku: e });
  }
}
const U = {
  STORE_READY: "storeReady",
  VIEW_REGION: "viewRegion",
  VIEW_PRODUCT: "viewProduct",
  VIEW_MAP_PRODUCT: "viewMapProduct",
  VIEW_SUBSCRIPTION_PRODUCT: "viewSubscriptionProduct",
  VIEW_BILLING: "viewBilling",
  VIEW_UPDATES: "viewUpdates",
  VIEW_PURCHASES: "viewPurchases",
  VIEW_SUPPORT: "viewSupport",
  VIEW_ACCOUNT: "viewAccount"
};
Object.freeze(U);
class $n {
  static StoreReadyMessage() {
    return U.STORE_READY;
  }
  static StoreReady() {
    return {
      type: U.STORE_READY
    };
  }
  static ViewRegionMessage() {
    return U.VIEW_REGION;
  }
  static ViewRegion(e) {
    return {
      type: U.VIEW_REGION,
      region: e
    };
  }
  static ViewProductMessage() {
    return U.VIEW_PRODUCT;
  }
  static ViewProduct(e) {
    return {
      type: U.VIEW_PRODUCT,
      sku: e
    };
  }
  static ViewMapProductMessage() {
    return U.VIEW_MAP_PRODUCT;
  }
  static ViewMapProduct(e) {
    return {
      type: U.VIEW_MAP_PRODUCT,
      sku: e
    };
  }
  static ViewSubscriptionProductMessage() {
    return U.VIEW_SUBSCRIPTION_PRODUCT;
  }
  static ViewSubscriptionProduct(e) {
    return {
      type: U.VIEW_SUBSCRIPTION_PRODUCT,
      sku: e
    };
  }
  static ViewBillingMessage() {
    return U.VIEW_BILLING;
  }
  static ViewBilling() {
    return {
      type: U.VIEW_BILLING
    };
  }
  static ViewUpdatesMessage() {
    return U.VIEW_UPDATES;
  }
  static ViewUpdates() {
    return {
      type: U.VIEW_UPDATES
    };
  }
  static ViewPurchasesMessage() {
    return U.VIEW_PURCHASES;
  }
  static ViewPurchases() {
    return {
      type: U.VIEW_PURCHASES
    };
  }
  static ViewSupportMessage() {
    return U.VIEW_SUPPORT;
  }
  static ViewSupport() {
    return {
      type: U.VIEW_SUPPORT
    };
  }
  static ViewAccountMessage() {
    return U.VIEW_ACCOUNT;
  }
  static ViewAccount() {
    return {
      type: U.VIEW_ACCOUNT
    };
  }
}
const $e = Object.freeze({
  SEND: "send",
  RESEND: "resend",
  REVOKE: "revoke",
  ACCEPT: "accept",
  DECLINE: "decline"
}), ir = Object.freeze({
  CONTACT_EXISTS_DIFFERENT_EMAIL: "ContactExistsDifferentEmail"
}), ne = Object.freeze({
  LIMIT_EXCEEDED: "MaxInvitesExceeded",
  EMAIL_BELONGS_TO_REQUESTER: "EmailBelongsToRequester",
  INVITE_EXISTS: "InviteExists",
  CONTACT_EXISTS: "ContactExists",
  INVALID_OPERATION: "InvalidOperation",
  INVITE_NOT_FOUND: "InviteNotFound",
  CANNOT_ACCEPT_OWN_INVITE: "CannotAcceptOwnInvite",
  BAD_REQUEST: "BadRequest",
  UNEXPECTED_ERROR: "UnexpectedError"
}), es = 30, ts = 5, rs = "invites";
let Gt, Wt, Ft;
class Vt {
  static get Send() {
    return $e.SEND;
  }
  static get Resend() {
    return $e.RESEND;
  }
  static get Revoke() {
    return $e.REVOKE;
  }
  static get Accept() {
    return $e.ACCEPT;
  }
  static get Decline() {
    return $e.DECLINE;
  }
}
class as {
  static get ContactExistsDifferentEmail() {
    return ir.CONTACT_EXISTS_DIFFERENT_EMAIL;
  }
}
class ye {
  static get MaxInvitesExceeded() {
    return ne.LIMIT_EXCEEDED;
  }
  static get InviteExists() {
    return ne.INVITE_EXISTS;
  }
  static get EmailBelongsToRequester() {
    return ne.EMAIL_BELONGS_TO_REQUESTER;
  }
  static get ContactExists() {
    return ne.CONTACT_EXISTS;
  }
  static get InvalidOperation() {
    return ne.INVALID_OPERATION;
  }
  static get InviteNotFound() {
    return ne.INVITE_NOT_FOUND;
  }
  static get CannotAcceptOwnInvite() {
    return ne.CANNOT_ACCEPT_OWN_INVITE;
  }
  static get BadRequest() {
    return ne.BAD_REQUEST;
  }
  static get UnexpectedError() {
    return ne.UNEXPECTED_ERROR;
  }
}
class lr {
  constructor(e, t) {
    this.code = e, this.message = t;
  }
  static ContactExistsDifferentEmail() {
    return new lr(as.ContactExistsDifferentEmail, "Already a contact using a different email.");
  }
}
class ie {
  constructor(e, t) {
    this.code = e, this.message = t;
  }
  static MaxInvitesExceeded() {
    const e = new ie(
      ye.MaxInvitesExceeded,
      `Maximum number of ${We.MaxFreeInvites} invites has been reached`
    );
    return e.status = 400, e;
  }
  static InviteExists() {
    const e = new ie(ye.InviteExists, "Pending request already exists for the invited email");
    return e.status = 400, e;
  }
  static EmailBelongsToRequester() {
    const e = new ie(ye.EmailBelongsToRequester, "Invited email matches the requester's email");
    return e.status = 400, e;
  }
  static ContactExists() {
    const e = new ie(ye.ContactExists, "Contact already exists with the invited email");
    return e.status = 400, e;
  }
  static InvalidOperation(e) {
    const t = new ie(ye.InvalidOperation, `Invalid operation: ${e}`);
    return t.status = 400, t;
  }
  static InviteNotFound(e, t) {
    const r = new ie(ye.InviteNotFound, `Invite ${e} not found (${t})`);
    return r.status = 404, r;
  }
  // HUNT-2064 A user with multiple accounts tried to accept their own invite while signed in to the account that sent it
  static CannotAcceptOwnInvite() {
    const e = new ie(ye.CannotAcceptOwnInvite, "Requester cannot accept their own request");
    return e.status = 400, e;
  }
  static BadRequest(e) {
    const t = new ie(ye.BadRequest, e.message || e);
    return t.status = 400, t;
  }
  static UnexpectedError(e) {
    const t = new ie(ye.UnexpectedError, e.message || e);
    return t.status = 500, t;
  }
}
class We {
  static get ExpiryDays() {
    return es;
  }
  static get MaxFreeInvites() {
    return ts;
  }
  static get FirestoreInvitesPath() {
    return rs;
  }
  /*
   * GetTestInfoOrError() - facilitate info & error testing in the Dev env.
   *
   * Format: <Prefix>+<Operation>.<Code>@<server>.com
   *
   * <Prefix>+ can be used to support plus addressing, ie. to send the invite to a specific recipient but raise an error when the recipient responds.
   *
   * e.g. Send.MaxInvitesExceeded@test.com will return a 'MaxInvitesExceeded' error when the invite is sent.
   * e.g. hannah+Accept.UnexpectedError@insideoutsidestudios.com will return an 'UnexpectedError' when the recipient accepts the invite.
   * e.g. Send.ContactExistsDifferentEmail@test.com will return 'ContactExistsDifferentEmail' info when the invite is sent.
   *
   */
  static GetTestInfoOrError(e, t) {
    const r = We.GetTestOperationAndCodeFromEmail(e);
    if (r && t === r.operation) {
      if (r.infoCode)
        return new lr(r.infoCode, "Test info");
      if (r.errorCode)
        return new ie(r.errorCode, "Test error");
    }
    return null;
  }
  static GetTestOperationAndCodeFromEmail(e) {
    if (e) {
      const r = e.substring(e.indexOf("+") + 1, e.indexOf("@")).split(".");
      if (r.length === 2) {
        const s = r[0].toLowerCase(), n = r[1].toLowerCase(), i = We.AllInfoCodes.find((u) => u.toLowerCase() === n), o = We.AllErrorCodes.find((u) => u.toLowerCase() === n);
        return i || o ? { operation: s, infoCode: i, errorCode: o } : null;
      }
    }
    return null;
  }
  static get AllOperations() {
    return Gt || (Gt = Object.keys($e).map((e) => $e[e])), Gt;
  }
  static get AllInfoCodes() {
    return Wt || (Wt = Object.keys(ir).map((e) => ir[e])), Wt;
  }
  static get AllErrorCodes() {
    return Ft || (Ft = Object.keys(ne).map((e) => ne[e])), Ft;
  }
}
const F = {
  // HUNT-1714: remove legacy Add Contact flow
  ADD_CONTACT_ROUTE: "/outgoingrequests/{requesterUid}/{responderUid}",
  ADD_CONTACT_PROCESSED_ROUTE: "/outgoingrequests/{requesterUid}/{responderUid}/processed",
  // Legacy clients (Sept 2024-Jul 2025)
  ADD_CONTACT_ACCEPTED_ROUTE: "/outgoingrequests/{requesterUid}/{responderUid}/accepted",
  // Extra legacy clients (pre Sept 2024)
  // Invite Contacts
  INVITES_ROUTE: "/outgoingrequests/invites/{requesterUid}",
  INVITE_ROUTE: "/outgoingrequests/invites/{requesterUid}/{inviteUid}",
  INVITE_OPERATION_ROUTE: "/outgoingrequests/invites/{requesterUid}/{inviteUid}/operation",
  INVITE_INFO_ROUTE: "/outgoingrequests/invites/{requesterUid}/{inviteUid}/info",
  CREATE_CHAT_ROUTE: "/outgoingrequests/chats/{requesterUid}/{chatKey}",
  CREATE_MESSAGE_ROUTE: "/outgoingrequests/messages/{requesterUid}/{chatKey}",
  DELETE_CONTACT_GROUP_ROUTE: "/outgoingrequests/delete/contactgroups/{requesterUid}/{chatKey}"
}, Pe = {
  INVITES_ROUTE: "/requests/{responderUid}",
  CREATE_CONTACT_ROUTE: "/requests/{responderUid}/{requesterUid}",
  CREATE_CONTACT_ACCEPTED_ROUTE: "/requests/{responderUid}/{requesterUid}/accepted",
  CREATE_CONTACT_DATE_ROUTE: "/requests/{responderUid}/{requesterUid}/receivedDate",
  CREATE_CONTACT_ERROR_ROUTE: "/requests/{responderUid}/{requesterUid}/error",
  LAST_VIEWED_ROUTE: "/requests/{responderUid}/{requesterUid}/lastViewedDate"
}, ss = {
  ROUTE: "/contacts/{uid}"
}, Or = {
  ROUTE: "/contacts/{uid1}/{uid2}",
  DATA: { accepted: !0 }
}, Fe = {
  ROUTE: "/conversations/chats/{chatKey}",
  PARTICIPANTS_ROUTE: "/conversations/chats/{chatKey}/participants",
  PARTICIPANT_ROUTE: "/conversations/chats/{chatKey}/participants/{participantUid}",
  LAST_VIEWED_ROUTE: "/conversations/chats/{chatKey}/lastviewed/{participantUid}",
  LAST_CLEARED_ROUTE: "/conversations/chats/{chatKey}/lastcleared/{participantUid}",
  GROUP_NAME: "New Group"
}, ns = {
  ROUTE: "/activeconversations/{uid}"
}, jt = {
  ROUTE: "/activeconversations/{uid}/{chatKey}",
  DATA: !0
}, yr = {
  SHARINGWITH_ROUTE: "/sharedlocation/sharingwith/{uid}/{sharingWithUid}",
  VIEWING_CONTACT_ROUTE: "/sharedlocation/viewing/{uid}/{viewingContactUid}"
};
class bt {
  static OutgoingInviteRequests(e) {
    return c(F.INVITES_ROUTE, { requesterUid: e });
  }
  static OutgoingInviteRoute() {
    return F.INVITE_ROUTE;
  }
  static OutgoingInviteRequest(e, t) {
    return c(F.INVITE_ROUTE, { requesterUid: e, inviteUid: t });
  }
  static OutgoingInviteOperationRoute() {
    return F.INVITE_OPERATION_ROUTE;
  }
  static OutgoingInviteOperation(e, t) {
    return c(F.INVITE_OPERATION_ROUTE, { requesterUid: e, inviteUid: t });
  }
  static OutgoingInviteInfo(e, t) {
    return c(F.INVITE_INFO_ROUTE, { requesterUid: e, inviteUid: t });
  }
  static OutgoingInviteSentData(e) {
    return {
      email: e,
      operation: Vt.Send,
      processed: !1
    };
  }
  static OutgoingInviteOperationProcessedData(e, t, r) {
    return {
      email: e,
      operation: null,
      info: t || null,
      error: r || null,
      processed: !0,
      processedDate: Date.now()
    };
  }
  static OutgoingInviteResentData(e) {
    return { ...e, operation: Vt.Resend, processed: !1 };
  }
  static OutgoingInviteRevokedData(e) {
    return {
      email: e,
      operation: Vt.Revoke,
      processed: !1
    };
  }
  static FirestoreInviteData(e, t, r) {
    const s = {
      requesterUid: e,
      responderEmail: t,
      createdDate: Date.now(),
      expiresDate: bt.DaysFromNowTimestamp(We.ExpiryDays),
      resentCount: 0
    };
    return r && (s.responderUid = r), s;
  }
  static FirestoreInviteResentData(e, t) {
    const r = e.data();
    t === r.responderEmail && (r.expiresDate = bt.DaysFromNowTimestamp(We.ExpiryDays));
    const s = r.resentCount + 1;
    return {
      ...r,
      resentCount: s,
      resentDate: Date.now(),
      emailResentTo: t
    };
  }
  // HUNT-1714: remove legacy Add Contact flow
  static LegacyOutgoingContactRequestProcessedRoute() {
    return F.ADD_CONTACT_PROCESSED_ROUTE;
  }
  static LegacyOutgoingContactRequestAcceptedRoute() {
    return F.ADD_CONTACT_ACCEPTED_ROUTE;
  }
  // HUNT-1714: remove legacy Add Contact flow
  static LegacyOutgoingContactRequestProcessed(e, t) {
    return c(F.ADD_CONTACT_PROCESSED_ROUTE, { requesterUid: e, responderUid: t });
  }
  // HUNT-1714: remove legacy Add Contact flow
  static OutgoingContactRequest(e, t) {
    return c(F.ADD_CONTACT_ROUTE, { requesterUid: e, responderUid: t });
  }
  static OutgoingChatRequestRoute() {
    return F.CREATE_CHAT_ROUTE;
  }
  static OutgoingChatRequest(e, t) {
    return c(F.CREATE_CHAT_ROUTE, { requesterUid: e, chatKey: t });
  }
  static OutgoingChatRequestData(e) {
    const t = { participants: {} };
    for (let r of e)
      t.participants[r] = !0;
    return t;
  }
  static OutgoingDeleteContactGroupRequestRoute() {
    return F.DELETE_CONTACT_GROUP_ROUTE;
  }
  static OutgoingDeleteContactGroupRequest(e, t) {
    return c(F.DELETE_CONTACT_GROUP_ROUTE, { requesterUid: e, chatKey: t });
  }
  static OutgoingMessageRequestRoute() {
    return F.CREATE_MESSAGE_ROUTE;
  }
  static OutgoingMessageRequest(e, t) {
    return c(F.CREATE_MESSAGE_ROUTE, { requesterUid: e, chatKey: t });
  }
  static IncomingInviteRequests(e) {
    return c(Pe.INVITES_ROUTE, { responderUid: e });
  }
  static IncomingInviteRequestLastViewed(e, t) {
    return c(Pe.LAST_VIEWED_ROUTE, { responderUid: e, requesterUid: t });
  }
  static IncomingContactRequestRoute() {
    return Pe.CREATE_CONTACT_ROUTE;
  }
  static IncomingContactRequest(e, t) {
    return c(Pe.CREATE_CONTACT_ROUTE, { responderUid: t, requesterUid: e });
  }
  static IncomingContactRequestDate(e, t) {
    return c(Pe.CREATE_CONTACT_DATE_ROUTE, { responderUid: t, requesterUid: e });
  }
  static IncomingContactRequestError(e, t) {
    return c(Pe.CREATE_CONTACT_ERROR_ROUTE, { responderUid: t, requesterUid: e });
  }
  static IncomingContactRequestData(e) {
    return {
      inviteUid: e,
      accepted: "",
      receivedDate: Date.now()
    };
  }
  // HUNT-1714: remove legacy Add Contact flow
  static LegacyIncomingContactRequestData() {
    return {
      accepted: !1
    };
  }
  static IncomingContactRequestAcceptedRoute() {
    return Pe.CREATE_CONTACT_ACCEPTED_ROUTE;
  }
  static IncomingContactRequestAccepted(e, t) {
    return c(Pe.CREATE_CONTACT_ACCEPTED_ROUTE, { responderUid: t, requesterUid: e });
  }
  static Contacts(e) {
    return c(ss.ROUTE, { uid: e });
  }
  static Contact(e, t) {
    return c(Or.ROUTE, { uid1: e, uid2: t });
  }
  static ContactData() {
    return Or.DATA;
  }
  static Chat(e) {
    return c(Fe.ROUTE, { chatKey: e });
  }
  static ChatData(e, t, r) {
    var m, f;
    let { participants: s } = e;
    const n = Date.now();
    let i = Object.keys(s).length > 2, o = {}, u = {};
    for (const y in s)
      o[y] = ((m = t == null ? void 0 : t.lastviewed) == null ? void 0 : m[y]) || n, u[y] = ((f = t == null ? void 0 : t.lastcleared) == null ? void 0 : f[y]) || n;
    const d = (e == null ? void 0 : e.chatname) || (t == null ? void 0 : t.chatname) || (i ? Fe.GROUP_NAME : null), l = (e == null ? void 0 : e.profilePicDate) || (t == null ? void 0 : t.profilePicDate);
    return {
      participants: s,
      isgroupchat: i,
      lastviewed: o,
      lastcleared: u,
      ...d && { chatname: d },
      ...l && { profilePicDate: l }
    };
  }
  static ChatParticipants(e) {
    return c(Fe.PARTICIPANTS_ROUTE, { chatKey: e });
  }
  static ChatParticipant(e, t) {
    return c(Fe.PARTICIPANT_ROUTE, { chatKey: e, participantUid: t });
  }
  static ChatLastViewed(e, t) {
    return c(Fe.LAST_VIEWED_ROUTE, { chatKey: e, participantUid: t });
  }
  static ChatLastCleared(e, t) {
    return c(Fe.LAST_CLEARED_ROUTE, { chatKey: e, participantUid: t });
  }
  static ActiveConversations(e) {
    return c(ns.ROUTE, { uid: e });
  }
  static ActiveConversationRoute() {
    return jt.ROUTE;
  }
  static ActiveConversation(e, t) {
    return c(jt.ROUTE, { uid: e, chatKey: t });
  }
  static ActiveConversationData() {
    return jt.DATA;
  }
  static DaysFromNowTimestamp(e) {
    const t = /* @__PURE__ */ new Date();
    return t.setDate(t.getDate() + e), t.getTime();
  }
  static SharedLocationSharingWith(e, t) {
    return c(yr.SHARINGWITH_ROUTE, { uid: e, sharingWithUid: t });
  }
  static SharedLocationViewingContact(e, t) {
    return c(yr.VIEWING_CONTACT_ROUTE, { uid: e, viewingContactUid: t });
  }
}
const Cr = {
  ROUTE: "/users/{uid}",
  UNKNOWN_NAME: "Unknown Name"
}, xt = {
  ONLINE: "/users/{uid}/online_web",
  LAST_LOGIN: "/users/{uid}/lastlogin_web",
  VERSION: "/users/{uid}/version_web"
}, is = {
  ROUTE: "/email_new_user/{uid}"
}, os = {
  MAPLAYERS_ROUTE: "/sync/{uid}/maplayers"
}, et = {
  ROUTE: "/auth/{uid}",
  EMAIL_LINK_SIGN_IN_ROUTE: "/auth/{uid}/emailLinkSignInAt",
  PASSWORD_UPDATED_ROUTE: "/auth/{uid}/passwordUpdatedAt",
  NEEDS_PASSWORD_RESET_ROUTE: "/auth/{uid}/needsPasswordReset",
  EMAIL_AUTO_VERIFIED_ROUTE: "/auth/{uid}/emailAutoVerifiedAt"
};
class oe {
  static User(e) {
    return c(Cr.ROUTE, { uid: e });
  }
  static WebOnline(e) {
    return c(xt.ONLINE, { uid: e });
  }
  static WebLastLogin(e) {
    return c(xt.LAST_LOGIN, { uid: e });
  }
  static WebVersion(e) {
    return c(xt.VERSION, { uid: e });
  }
  static NewUserData(e) {
    var i, o;
    let t = (i = e.displayName) == null ? void 0 : i.trim(), r = e.email || ((o = e.providerData[0]) == null ? void 0 : o.email) || "";
    if (r = r.toLowerCase(), !t)
      if (r)
        if (r.includes("@")) {
          var s = r.split("@"), n = s[0];
          t = n;
        } else
          t = r;
      else
        t = oe.UnknownUserName();
    return {
      username: t,
      lowername: t.toLowerCase(),
      email: r,
      uid: e.uid,
      online_web: !0
    };
  }
  static EmailNewUser(e) {
    return c(is.ROUTE, { uid: e });
  }
  static MaplayersRoute(e) {
    return c(os.MAPLAYERS_ROUTE, { uid: e });
  }
  static UnknownUserName() {
    return Cr.UNKNOWN_NAME;
  }
  static AuthRoute(e) {
    return c(et.ROUTE, { uid: e });
  }
  static AuthRoutePasswordUpdated(e) {
    return c(et.PASSWORD_UPDATED_ROUTE, { uid: e });
  }
  static AuthRouteNeedsPasswordReset(e) {
    return c(et.NEEDS_PASSWORD_RESET_ROUTE, { uid: e });
  }
  static AuthRouteEmailAutoVerified(e) {
    return c(et.EMAIL_AUTO_VERIFIED_ROUTE, { uid: e });
  }
  static AuthRouteEmailLinkSignIn(e) {
    return c(et.EMAIL_LINK_SIGN_IN_ROUTE, { uid: e });
  }
}
class Gn extends st {
  constructor(e) {
    super(e);
  }
  async createNewUser(e, t) {
    const r = oe.NewUserData(e);
    await this.update(oe.User(e.uid), r), await this.update(oe.EmailNewUser(e.uid), { email: r.email }), e.displayName = r.username, await Qt(e, { displayName: e.displayName }), console.info(`Updated profile for Firebase Auth user ${e.uid}: ${e.displayName}`), t && (await Da(e, t), console.info(`Updated password for Firebase Auth user ${e.uid}`));
  }
  async updatePasswordStatus(e, t, r) {
    await this.updateAuthData(e, oe.AuthRoutePasswordUpdated(e), t), await this.updateAuthData(e, oe.AuthRouteNeedsPasswordReset(e), r);
  }
  async updateEmailAutoVerifiedTimestamp(e) {
    await this.updateAuthData(e, oe.AuthRouteEmailAutoVerified(e), Date.now());
  }
  async updateEmailLinkSignInTimestamp(e) {
    await this.updateAuthData(e, oe.AuthRouteEmailLinkSignIn(e), Date.now());
  }
  async updateAuthData(e, t, r) {
    try {
      r || typeof r == "boolean" ? (await this.set(t, r), console.info(`Updated auth data for user ${e}: set ${t} = ${r}`)) : console.warn(`No data provided to update for user ${e} (${t})`);
    } catch (s) {
      console.error(`Failed to update auth data for user ${e} (${t} = ${r})`, s);
    }
  }
  async getNeedsPasswordReset(e) {
    return await this.get(oe.AuthRouteNeedsPasswordReset(e));
  }
  async countWaypoints(e) {
    return await this.countChildren(Dt.WaypointsRoute(e));
  }
  async countTracks(e) {
    return await this.countChildren(Dt.TracksRoute(e));
  }
  async countDrawings(e) {
    return await this.countChildren(Dt.DrawingsRoute(e));
  }
  async countMaplayers(e) {
    return await this.countChildren(oe.MaplayersRoute(e));
  }
  async countContacts(e) {
    return await this.countChildren(bt.Contacts(e));
  }
}
const Ar = {
  LEGEND: "/tiles/{region}/{sku}/legend.png",
  COPYRIGHT: "/tiles/{region}/{sku}/copyright.png"
};
class Wn {
  static Legend(e, t) {
    return c(Ar.LEGEND, { region: e, sku: t });
  }
  static Copyright(e, t) {
    return c(Ar.COPYRIGHT, { region: e, sku: t });
  }
}
const me = Object.freeze({
  CONTACT_US: { id: "contactUs" },
  CREATE_ACCOUNT: { id: "createAccount", subject: "Create iHunter Account", linkPage: "login" },
  INVITE: { id: "invite", subject: null, linkPage: "accept-invite" },
  RESET_PASSWORD: { id: "resetPassword", subject: "Reset your iHunter password", linkPage: "reset-password" },
  SIGN_IN: { id: "signIn", subject: "Sign in to iHunter", linkPage: "login" },
  SIGN_IN_UNVERIFIED: { id: "signInUnverified", subject: "Sign in to iHunter", linkPage: "login" },
  WELCOME: { id: "welcome", subject: "Welcome to iHunter!" },
  WELCOME_REPROMAP: { id: "welcomeRepromap", subject: "Welcome to Repromap and iHunter!" }
}), cs = Object.freeze({
  REPROMAP: "rm"
}), us = Object.freeze({
  EMAIL_FAILED_TO_SEND: "EmailFailedToSend"
});
class Fn {
  static ContactUs() {
    return ce.TypeWithName(me.CONTACT_US);
  }
  static CreateAccount() {
    return ce.TypeWithName(me.CREATE_ACCOUNT);
  }
  static Invite() {
    return ce.TypeWithName(me.INVITE);
  }
  static ResetPassword() {
    return ce.TypeWithName(me.RESET_PASSWORD);
  }
  static SignIn() {
    return ce.TypeWithName(me.SIGN_IN);
  }
  static SignInUnverified() {
    return ce.TypeWithName(me.SIGN_IN_UNVERIFIED);
  }
  static Welcome() {
    return ce.TypeWithName(me.WELCOME);
  }
  static WelcomeRepromap() {
    return ce.TypeWithName(me.WELCOME_REPROMAP);
  }
}
class ce {
  static AllTypes() {
    return Object.keys(me).map((e) => ce.TypeWithName(me[e]));
  }
  static TypesFromIds(e) {
    return ce.AllTypes().filter((t) => e.includes(t.id));
  }
  static TypeWithName(e) {
    if (!e.name) {
      const t = e.id.replace(/([A-Z])/g, " $1");
      e.name = t.charAt(0).toUpperCase() + t.slice(1);
    }
    return e;
  }
  static RepromapClient() {
    return cs.REPROMAP;
  }
}
class ls {
  static get EmailFailedToSend() {
    return us.EMAIL_FAILED_TO_SEND;
  }
}
class ea {
  constructor(e, t) {
    this.code = e, this.message = t;
  }
  static EmailFailedToSend(e) {
    const t = new ea(ls.EmailFailedToSend, "Unexpected error sending the email");
    return t.status = e.statusCode || 500, t;
  }
}
const tt = {
  MESSAGES: "/conversations/messages/{chatKey}",
  MESSAGE: "/conversations/messages/{chatKey}/{messageKey}",
  ALERTS: "/conversations/alerts/{uid}",
  ALERT: "/conversations/alerts/{uid}/{alertKey}"
}, Ge = {
  NOTIFICATION: "notification",
  TEXT: "text",
  WAYPOINT: "waypoint",
  CURRENT_LOCATION: "currentlocation",
  BROADCAST_LOCATION: "broadcastlocation"
}, _e = {
  FIRST_SOLO_MESSAGE: "first_solo_message",
  FIRST_GROUP_MESSAGE: "first_group_message",
  JOINED_GROUP: "joined_group",
  REMOVED_FROM_GROUP: "removed_from_group",
  LEFT_GROUP: "left_group",
  ADDED_CONTACT: "added_contact",
  REMOVED_CONTACT: "removed_contact",
  UNKNOWN: "unknown"
}, de = {
  FIRST_SOLO_MESSAGE: "You are now connected",
  FIRST_GROUP_MESSAGE: "{usernames} have joined the group",
  JOINED_GROUP: "{username} has joined the group",
  REMOVED_FROM_GROUP: "{username} has been removed from the group",
  LEFT_GROUP: "{username} has left the group",
  ADDED_CONTACT: "{username} has added you",
  REMOVED_CONTACT: "{username} has removed you as a contact",
  SHARED_WAYPOINT: "Shared waypoint",
  SHARED_LOCATION: "Shared location"
}, Sr = {
  GROUP_DELETED: "group_deleted",
  REMOVED_FROM_GROUP: "removed_from_group"
}, Yt = {
  ITEM: "/clipboard/{senderUid}/waypoints/{itemUid}",
  ITEM_ACCEPTED: "/clipboard/{senderUid}/waypoints/{itemUid}/accepted",
  ITEM_ACCEPTED_RECIPIENT: "/clipboard/{senderUid}/waypoints/{itemUid}/accepted/{recipientUid}"
}, rt = {
  SHARINGWITH: "/sharedlocation/sharingwith/{senderUid}",
  SHARINGWITH_RECIPIENT: "/sharedlocation/sharingwith/{senderUid}/{recipientUid}",
  VIEWING: "/sharedlocation/viewing/{viewerUid}",
  VIEWING_SENDER: "/sharedlocation/viewing/{viewerUid}/{senderUid}",
  DETAILS: "/sharedlocation/locations/{senderUid}"
}, ds = "notify_all";
class zt {
  static get Notification() {
    return Ge.NOTIFICATION;
  }
  static get Text() {
    return Ge.TEXT;
  }
  static get BroadcastLocation() {
    return Ge.BROADCAST_LOCATION;
  }
  static get CurrentLocation() {
    return Ge.CURRENT_LOCATION;
  }
  static get Waypoint() {
    return Ge.WAYPOINT;
  }
}
class V {
  static get FirstSoloMessage() {
    return _e.FIRST_SOLO_MESSAGE;
  }
  static get FirstGroupMessage() {
    return _e.FIRST_GROUP_MESSAGE;
  }
  static get JoinedGroup() {
    return _e.JOINED_GROUP;
  }
  static get RemovedFromGroup() {
    return _e.REMOVED_FROM_GROUP;
  }
  static get LeftGroup() {
    return _e.LEFT_GROUP;
  }
  static get AddedContact() {
    return _e.ADDED_CONTACT;
  }
  static get RemovedContact() {
    return _e.REMOVED_CONTACT;
  }
  static get Unknown() {
    return _e.UNKNOWN;
  }
}
class Vn {
  static get GroupDeleted() {
    return Sr.GROUP_DELETED;
  }
  static get RemovedFromGroup() {
    return Sr.REMOVED_FROM_GROUP;
  }
}
class Ye {
  static Messages(e) {
    return c(tt.MESSAGES, { chatKey: e });
  }
  static MessageRoute() {
    return tt.MESSAGE;
  }
  static Message(e, t) {
    const r = Ye.MessageKey(t);
    return c(tt.MESSAGE, { chatKey: e, messageKey: r });
  }
  static Alerts(e) {
    return c(tt.ALERTS, { uid: e });
  }
  static Alert(e, t) {
    return c(tt.ALERT, { uid: e, alertKey: t });
  }
  static AlertKey(e, t) {
    return `${e}_${t}`;
  }
  static FirstMessageData(e) {
    let t, r;
    if (e.length > 2) {
      let s = e.join(", ");
      t = V.FirstGroupMessage, r = { usernames: s };
    } else
      t = V.FirstSoloMessage, r = {};
    return Ye.NotificationMessageData(null, t, r);
  }
  static NotificationMessageData(e, t, r) {
    const s = Ye.GetLegacyMessageForNotificationType(t, r);
    return {
      uid: e || Ye.NotifyAll(),
      type: Ge.NOTIFICATION,
      notificationType: t,
      notificationParams: r,
      time: Date.now(),
      msg: s
    };
  }
  static TextMessageData(e, t) {
    return {
      uid: e,
      type: Ge.TEXT,
      time: Date.now(),
      msg: t
    };
  }
  static RawMessageText(e) {
    return e.type === zt.BroadcastLocation || e.type === zt.CurrentLocation ? de.SHARED_LOCATION : e.type === zt.Waypoint ? de.SHARED_WAYPOINT : e.msg;
  }
  /**
   * Generates a unique message key by combining the current UTC date,
   * the sender's identifier, and a short 4-character random string.
   * The random string acts as a collision safeguard for multiple messages
   * sent by the same user at the exact same time.
   *
   * @param {string} sender - The unique identifier (UID) of the user sending the message.
   * @returns {string} The constructed unique message key (e.g., "2026-08-11T17:47:00Z_7Tg5eoMC0kQ73oUkey0HllvVJp42_a1b2").
   */
  static MessageKey(e) {
    const t = Math.random().toString(36).substring(2, 6);
    return `${Pt.CurrentUTCDateString}_${e}_${t}`;
  }
  static NotifyAll() {
    return ds;
  }
  /**
   * Support legacy client messages that don't have the 'notificationType' property by attempting to determine it from the message text.
   * TBD: we can remove this once we remove support for legacy clients
   * @param {string} text the decrypted message text
   * @returns {MessageNotificationType} the corresponding type, or 'unknown' if no matching type was found.
   */
  static GetNotificationTypeForLegacyMessage(e) {
    return e === de.FIRST_SOLO_MESSAGE ? V.FirstSoloMessage : e != null && e.includes("have joined the group") ? V.FirstGroupMessage : e != null && e.includes("has joined the group") || e != null && e.includes("a rejoint le groupe") ? V.JoinedGroup : e != null && e.includes("has left the group") || e != null && e.includes("a quitté le groupe") ? V.LeftGroup : e != null && e.includes("has added you") || e != null && e.includes("vous a ajouté") ? V.AddedContact : e != null && e.includes("has removed you as a contact") || e != null && e.includes("vous a supprimé en tant que contact") ? V.RemovedContact : V.Unknown;
  }
  /**
   * Support legacy clients that don't use the 'notificationType' property by converting the type to the raw message text instead.
   * TBD: we can remove this once we remove support for legacy clients
   * @param {MessageNotificationType} type the type of notification
   * @param {String} params the params to use to construct the message text
   * @returns {String} the raw message text
   */
  static GetLegacyMessageForNotificationType(e, t) {
    switch (e) {
      case V.FirstSoloMessage:
        return de.FIRST_SOLO_MESSAGE;
      case V.FirstGroupMessage:
        return c(de.FIRST_GROUP_MESSAGE, t);
      case V.JoinedGroup:
        return c(de.JOINED_GROUP, t);
      case V.RemovedFromGroup:
        return c(de.REMOVED_FROM_GROUP, t);
      case V.LeftGroup:
        return c(de.LEFT_GROUP, t);
      case V.AddedContact:
        return c(de.ADDED_CONTACT, t);
      case V.RemovedContact:
        return c(de.REMOVED_CONTACT, t);
    }
    return e;
  }
  static ClipboardItem(e, t) {
    return c(Yt.ITEM, { senderUid: e, itemUid: t });
  }
  static ClipboardItemAccepted(e, t) {
    return c(Yt.ITEM_ACCEPTED, { senderUid: e, itemUid: t });
  }
  static ClipboardItemAcceptedByRecipient(e, t, r) {
    return c(Yt.ITEM_ACCEPTED_RECIPIENT, { senderUid: e, itemUid: t, recipientUid: r });
  }
  static SharingLocationWith(e) {
    return c(rt.SHARINGWITH, { senderUid: e });
  }
  static SharingLocationWithRecipient(e, t) {
    return c(rt.SHARINGWITH_RECIPIENT, { senderUid: e, recipientUid: t });
  }
  static SharedLocationViewing(e) {
    return c(rt.VIEWING, { viewerUid: e });
  }
  static SharedLocationViewingSender(e, t) {
    return c(rt.VIEWING_SENDER, { viewerUid: e, senderUid: t });
  }
  static SharedLocationDetails(e) {
    return c(rt.DETAILS, { senderUid: e });
  }
}
const Ir = {
  NOTIFICATIONS: "/notifications/{uid}",
  FCM_TOKEN: "/notifications/{uid}/{fcmToken}"
}, ps = "Notification", hs = "New iHunter message from {senderUsername}";
class jn {
  static Notifications(e) {
    return c(Ir.NOTIFICATIONS, { uid: e });
  }
  static FCMToken(e, t) {
    return c(Ir.FCM_TOKEN, { uid: e, fcmToken: t });
  }
  static Title(e, t) {
    return e === Ye.NotifyAll() ? ps : c(hs, { senderUsername: t });
  }
}
const ze = 65, X = 73, se = 79;
function gs(a, e) {
  if (e = typeof e == "number" ? e : 5, !Array.isArray(a)) throw new TypeError("forward did not receive an array");
  if (typeof a[0] == "string" || typeof a[1] == "string") throw new TypeError("forward received an array of strings, but it only accepts an array of numbers.");
  const [t, r] = a;
  if (t < -180 || t > 180) throw new TypeError("forward received an invalid longitude of " + t);
  if (r < -90 || r > 90) throw new TypeError("forward received an invalid latitude of " + r);
  if (r < -80 || r > 84) throw new TypeError(`forward received a latitude of ${r}, but this library does not support conversions of points in polar regions below 80°S and above 84°N`);
  return function(s, n) {
    const i = "00000" + s.easting, o = "00000" + s.northing;
    return s.zoneNumber + s.zoneLetter + function(u, d, l) {
      const E = ra(l), m = Math.floor(u / 1e5), f = Math.floor(d / 1e5) % 20;
      return function(y, C, O) {
        const _ = O - 1, b = "AJSAJS".charCodeAt(_), w = "AFAFAF".charCodeAt(_);
        let g = b + y - 1, R = w + C, v = !1;
        return g > 90 && (g = g - 90 + ze - 1, v = !0), (g === X || b < X && g > X || (g > X || b < X) && v) && g++, (g === se || b < se && g > se || (g > se || b < se) && v) && (g++, g === X && g++), g > 90 && (g = g - 90 + ze - 1), R > 86 ? (R = R - 86 + ze - 1, v = !0) : v = !1, (R === X || w < X && R > X || (R > X || w < X) && v) && R++, (R === se || w < se && R > se || (R > se || w < se) && v) && (R++, R === X && R++), R > 86 && (R = R - 86 + ze - 1), String.fromCharCode(g) + String.fromCharCode(R);
      }(m, f, E);
    }(s.easting, s.northing, s.zoneNumber) + i.substr(i.length - 5, n) + o.substr(o.length - 5, n);
  }(function(s) {
    const n = s.lat, i = s.lon, o = 6378137, u = Ht(n), d = Ht(i);
    let l;
    l = Math.floor((i + 180) / 6) + 1, i === 180 && (l = 60), n >= 56 && n < 64 && i >= 3 && i < 12 && (l = 32), n >= 72 && n < 84 && (i >= 0 && i < 9 ? l = 31 : i >= 9 && i < 21 ? l = 33 : i >= 21 && i < 33 ? l = 35 : i >= 33 && i < 42 && (l = 37));
    const E = Ht(6 * (l - 1) - 180 + 3), m = o / Math.sqrt(1 - 669438e-8 * Math.sin(u) * Math.sin(u)), f = Math.tan(u) * Math.tan(u), y = 0.006739496752268451 * Math.cos(u) * Math.cos(u), C = Math.cos(u) * (d - E), O = o * (0.9983242984503243 * u - 0.002514607064228144 * Math.sin(2 * u) + 2639046602129982e-21 * Math.sin(4 * u) - 3418046101696858e-24 * Math.sin(6 * u)), _ = 0.9996 * m * (C + (1 - f + y) * C * C * C / 6 + (5 - 18 * f + f * f + 72 * y - 0.39089081163157013) * C * C * C * C * C / 120) + 5e5;
    let b = 0.9996 * (O + m * Math.tan(u) * (C * C / 2 + (5 - f + 9 * y + 4 * y * y) * C * C * C * C / 24 + (61 - 58 * f + f * f + 600 * y - 2.2240339282485886) * C * C * C * C * C * C / 720));
    return n < 0 && (b += 1e7), { northing: Math.trunc(b), easting: Math.trunc(_), zoneNumber: l, zoneLetter: ms(n) };
  }({ lat: r, lon: t }), e);
}
function Es(a) {
  if (a === "") throw new TypeError("toPoint received a blank string");
  const e = ta(fs(a.toUpperCase()));
  return typeof e.lat == "number" && typeof e.lon == "number" ? [e.lon, e.lat] : [(e.left + e.right) / 2, (e.top + e.bottom) / 2];
}
function Ht(a) {
  return a * (Math.PI / 180);
}
function br(a) {
  return a / Math.PI * 180;
}
function ta(a) {
  const e = a.northing, t = a.easting, { zoneLetter: r, zoneNumber: s } = a;
  if (s < 0 || s > 60) return null;
  const n = 6378137, i = (1 - Math.sqrt(0.99330562)) / (1 + Math.sqrt(0.99330562)), o = t - 5e5;
  let u = e;
  r < "N" && (u -= 1e7);
  const d = 6 * (s - 1) - 180 + 3, l = u / 0.9996 / 6367449145945056e-9, E = l + (3 * i / 2 - 27 * i * i * i / 32) * Math.sin(2 * l) + (21 * i * i / 16 - 55 * i * i * i * i / 32) * Math.sin(4 * l) + 151 * i * i * i / 96 * Math.sin(6 * l), m = n / Math.sqrt(1 - 669438e-8 * Math.sin(E) * Math.sin(E)), f = Math.tan(E) * Math.tan(E), y = 0.006739496752268451 * Math.cos(E) * Math.cos(E), C = 0.99330562 * n / Math.pow(1 - 669438e-8 * Math.sin(E) * Math.sin(E), 1.5), O = o / (0.9996 * m);
  let _ = E - m * Math.tan(E) / C * (O * O / 2 - (5 + 3 * f + 10 * y - 4 * y * y - 0.06065547077041606) * O * O * O * O / 24 + (61 + 90 * f + 298 * y + 45 * f * f - 1.6983531815716497 - 3 * y * y) * O * O * O * O * O * O / 720);
  _ = br(_);
  let b, w = (O - (1 + 2 * f + y) * O * O * O / 6 + (5 - 2 * y + 28 * f - 3 * y * y + 0.05391597401814761 + 24 * f * f) * O * O * O * O * O / 120) / Math.cos(E);
  if (w = d + br(w), typeof a.accuracy == "number") {
    const g = ta({ northing: a.northing + a.accuracy, easting: a.easting + a.accuracy, zoneLetter: a.zoneLetter, zoneNumber: a.zoneNumber });
    b = { top: g.lat, right: g.lon, bottom: _, left: w };
  } else b = { lat: _, lon: w };
  return b;
}
function ms(a) {
  return a <= 84 && a >= 72 ? "X" : a < 72 && a >= -80 ? "CDEFGHJKLMNPQRSTUVWX"[Math.floor((a - -80) / 8)] : a > 84 || a < -80 ? "Z" : void 0;
}
function ra(a) {
  let e = a % 6;
  return e === 0 && (e = 6), e;
}
function fs(a) {
  if (a && a.length === 0) throw new TypeError("MGRSPoint coverting from nothing");
  a = a.replace(/ /g, "");
  const { length: e } = a;
  let t, r = null, s = "", n = 0;
  for (; !/[A-Z]/.test(t = a.charAt(n)); ) {
    if (n >= 2) throw new Error("MGRSPoint bad conversion from: " + a);
    s += t, n++;
  }
  const i = parseInt(s, 10);
  if (n === 0 || n + 3 > e) throw new Error("MGRSPoint bad conversion from " + a);
  const o = a.charAt(n++);
  if (o <= "A" || o === "B" || o === "Y" || o >= "Z" || o === "I" || o === "O") throw new Error(`MGRSPoint zone letter ${o} not handled: ${a}`);
  r = a.substring(n, n += 2);
  const u = ra(i), d = function(O, _) {
    let b = "AJSAJS".charCodeAt(_ - 1), w = 1e5, g = !1;
    for (; b !== O.charCodeAt(0); ) {
      if (b++, b === X && b++, b === se && b++, b > 90) {
        if (g) throw new Error("Bad character: " + O);
        b = ze, g = !0;
      }
      w += 1e5;
    }
    return w;
  }(r.charAt(0), u);
  let l = function(O, _) {
    if (O > "V") throw new TypeError("MGRSPoint given invalid Northing " + O);
    let b = "AFAFAF".charCodeAt(_ - 1), w = 0, g = !1;
    for (; b !== O.charCodeAt(0); ) {
      if (b++, b === X && b++, b === se && b++, b > 86) {
        if (g) throw new Error("Bad character: " + O);
        b = ze, g = !0;
      }
      w += 1e5;
    }
    return w;
  }(r.charAt(1), u);
  for (; l < Rs(o); ) l += 2e6;
  const E = e - n;
  if (E % 2 != 0) throw new Error(`MGRSPoint has to have an even number
of digits after the zone letter and two 100km letters - front
half for easting meters, second half for
northing meters ` + a);
  const m = E / 2;
  let f = 0, y = 0;
  const C = 1e5 / Math.pow(10, m);
  if (m > 0) {
    const O = a.substring(n, n + m);
    f = parseFloat(O) * C;
    const _ = a.substring(n + m);
    y = parseFloat(_) * C;
  }
  return { easting: f + d, northing: y + l, zoneLetter: o, zoneNumber: i, accuracy: C };
}
function Rs(a) {
  let e;
  switch (a) {
    case "C":
      e = 11e5;
      break;
    case "D":
      e = 2e6;
      break;
    case "E":
      e = 28e5;
      break;
    case "F":
      e = 37e5;
      break;
    case "G":
      e = 46e5;
      break;
    case "H":
      e = 55e5;
      break;
    case "J":
      e = 64e5;
      break;
    case "K":
      e = 73e5;
      break;
    case "L":
      e = 82e5;
      break;
    case "M":
      e = 91e5;
      break;
    case "N":
      e = 0;
      break;
    case "P":
      e = 8e5;
      break;
    case "Q":
      e = 17e5;
      break;
    case "R":
      e = 26e5;
      break;
    case "S":
      e = 35e5;
      break;
    case "T":
      e = 44e5;
      break;
    case "U":
      e = 53e5;
      break;
    case "V":
      e = 62e5;
      break;
    case "W":
      e = 7e6;
      break;
    case "X":
      e = 79e5;
      break;
    default:
      e = -1;
  }
  if (e >= 0) return e;
  throw new TypeError("Invalid zone letter: " + a);
}
var Nt = 0.9996, fe = 669438e-8, dr = Math.pow(fe, 2), _t = Math.pow(fe, 3), qe = fe / (1 - fe), Nr = Math.sqrt(1 - fe), Ke = (1 - Nr) / (1 + Nr), Ts = Math.pow(Ke, 2), aa = Math.pow(Ke, 3), sa = Math.pow(Ke, 4), na = Math.pow(Ke, 5), ia = 1 - fe / 4 - 3 * dr / 64 - 5 * _t / 256, Os = 3 * fe / 8 + 3 * dr / 32 + 45 * _t / 1024, ys = 15 * dr / 256 + 45 * _t / 1024, Cs = 35 * _t / 3072, As = 3 / 2 * Ke - 27 / 32 * aa + 269 / 512 * na, Ss = 21 / 16 * Ts - 55 / 32 * sa, Is = 151 / 96 * aa - 417 / 128 * na, bs = 1097 / 512 * sa, wt = 6378137, oa = "CDEFGHJKLMNPQRSTUVWXX";
function Ns(a, e, t, r, s, n) {
  if (n = n !== void 0 ? n : !0, !r && s === void 0)
    throw new Error("either zoneLetter or northern needs to be set");
  if (r && s !== void 0)
    throw new Error("set either zoneLetter or northern, but not both");
  if (n) {
    if (a < 1e5 || 1e6 <= a)
      throw new RangeError("easting out of range (must be between 100 000 m and 999 999 m)");
    if (e < 0 || e > 1e7)
      throw new RangeError("northing out of range (must be between 0 m and 10 000 000 m)");
  }
  if (t < 1 || t > 60)
    throw new RangeError("zone number out of range (must be between 1 and 60)");
  if (r) {
    if (r = r.toUpperCase(), r.length !== 1 || oa.indexOf(r) === -1)
      throw new RangeError("zone letter out of range (must be between C and X)");
    s = r >= "N";
  }
  var i = a - 5e5, o = e;
  s || (o -= 1e7);
  var u = o / Nt, d = u / (wt * ia), l = d + As * Math.sin(2 * d) + Ss * Math.sin(4 * d) + Is * Math.sin(6 * d) + bs * Math.sin(8 * d), E = Math.sin(l), m = Math.pow(E, 2), f = Math.cos(l), y = Math.tan(l), C = Math.pow(y, 2), O = Math.pow(y, 4), _ = 1 - fe * m, b = Math.sqrt(_), w = wt / b, g = (1 - fe) / _, R = Ke * f * f, v = R * R, W = i / (w * Nt), nt = Math.pow(W, 2), pa = Math.pow(W, 3), ha = Math.pow(W, 4), ga = Math.pow(W, 5), Ea = Math.pow(W, 6), ma = l - y / g * (nt / 2 - ha / 24 * (5 + 3 * C + 10 * R - 4 * v - 9 * qe)) + Ea / 720 * (61 + 90 * C + 298 * R + 45 * O - 252 * qe - 3 * v), fa = (W - pa / 6 * (1 + 2 * C + R) + ga / 120 * (5 - 2 * R + 28 * C - 3 * v + 8 * qe + 24 * O)) / f;
  return {
    latitude: wr(ma),
    longitude: wr(fa) + ca(t)
  };
}
function ws(a, e, t) {
  if (a > 84 || a < -80)
    throw new RangeError("latitude out of range (must be between 80 deg S and 84 deg N)");
  if (e > 180 || e < -180)
    throw new RangeError("longitude out of range (must be between 180 deg W and 180 deg E)");
  var r = qt(a), s = Math.sin(r), n = Math.cos(r), i = Math.tan(r), o = Math.pow(i, 2), u = Math.pow(i, 4), d;
  d = _s(a, e);
  var l = Ps(a), E = qt(e), m = ca(d), f = qt(m), y = wt / Math.sqrt(1 - fe * s * s), C = qe * n * n, O = n * (E - f), _ = Math.pow(O, 2), b = Math.pow(O, 3), w = Math.pow(O, 4), g = Math.pow(O, 5), R = Math.pow(O, 6), v = wt * (ia * r - Os * Math.sin(2 * r) + ys * Math.sin(4 * r) - Cs * Math.sin(6 * r)), W = Nt * y * (O + b / 6 * (1 - o + C) + g / 120 * (5 - 18 * o + u + 72 * C - 58 * qe)) + 5e5, nt = Nt * (v + y * i * (_ / 2 + w / 24 * (5 - o + 9 * C + 4 * C * C) + R / 720 * (61 - 58 * o + u + 600 * C - 330 * qe)));
  return a < 0 && (nt += 1e7), {
    easting: W,
    northing: nt,
    zoneNum: d,
    zoneLetter: l
  };
}
function Ps(a) {
  return -80 <= a && a <= 84 ? oa[Math.floor((a + 80) / 8)] : null;
}
function _s(a, e) {
  if (56 <= a && a < 64 && 3 <= e && e < 12) return 32;
  if (72 <= a && a <= 84 && e >= 0) {
    if (e < 9) return 31;
    if (e < 21) return 33;
    if (e < 33) return 35;
    if (e < 42) return 37;
  }
  return Math.floor((e + 180) / 6) + 1;
}
function ca(a) {
  return (a - 1) * 6 - 180 + 3;
}
function wr(a) {
  return a / Math.PI * 180;
}
function qt(a) {
  return a * Math.PI / 180;
}
const ua = 6378137, Ms = ua / 1e3, vs = 1.609, Ls = 0.621371, Ds = 25.4, Us = 1 / Ds, ks = 1.09361, Bs = 3.28084, Pr = 3.6, $s = 2.4710538, _r = 30, Gs = 0, Ws = 29, Fs = 0, Vs = 1, js = -1, Mr = -90, vr = 90, Lr = -180, Dr = 180, xs = 1024, Ur = xs * 1024, Ys = (a) => a && (typeof a == "string" || a instanceof String), j = (a) => a === 0 || a && !isNaN(Number(a)), Ie = Object.freeze({
  Metric: "metric",
  Imperial: "imperial"
}), kr = Ie.Metric, H = Object.freeze({
  Area: "area",
  Coordinates: "coordinates",
  DistanceKm: "distance_km",
  DistanceMeters: "distance_meters",
  DistanceFeet: "distance_feet",
  Direction: "direction",
  Elevation: "elevation",
  MoonPhase: "moonphase",
  Percent: "percentage",
  Precipitation: "precipitation",
  Pressure: "pressure",
  Sentence: "sentence",
  SpeedKph: "speed_kph",
  SpeedMps: "speed_mps",
  Temperature: "temperature",
  Time: "time"
}), Ce = Object.freeze({
  North: "north",
  NW: "nw",
  West: "west",
  SW: "sw",
  South: "south",
  SE: "se",
  East: "east",
  NE: "ne"
}), ee = Object.freeze({
  FirstQuarter: "first_quarter",
  FullMoon: "full_moon",
  NewMoon: "new_moon",
  ThirdQuarter: "third_quarter",
  WaningCrescent: "waning_crescent",
  WaxingCrescent: "waxing_crescent",
  WaningGibbous: "waning_gibbous",
  WaxingGibbous: "waxing_gibbous",
  Unknown: js
}), ut = Object.freeze({
  LatLong: 0,
  DMS: 1,
  MGRS: 2,
  UTM: 3
}), xn = Object.freeze({
  [ut.LatLong]: "latlong",
  [ut.DMS]: "dms",
  [ut.MGRS]: "mgrs",
  [ut.UTM]: "utm"
}), Ae = Object.freeze({
  Blank: "blank",
  InvalidFormat: "invalid_format",
  InvalidLatitude: "invalid_latitude",
  InvalidLongitude: "invalid_longitude",
  Unknown: "unknown"
});
class Se extends Error {
  constructor(e, t) {
    super(t), this.name = "CoordinateError", this.code = e;
  }
}
class S {
  /**
   * Converts the provided value to the specified type of units and mode (metric or imperial).
   * @param {(string|number)} value the value to convert
   * @param {UnitType} unitType specifies the type of units
   * @param {UnitMode} unitMode specifies whether to format the value in metric or imperial
   * @param {number} maxDecimalPlaces (optional) the maximum number of decimal places to include for numeric values (defaults to 0).
   * @returns {object} the converted value
   */
  static ConvertValue(e, t, r = kr, s = 0) {
    switch (r = Object.values(Ie).includes(r) ? r : kr, t) {
      case H.Area:
        return S.ConvertToHaOrAcres(e, r, s);
      case H.DistanceKm:
        return S.ConvertToKmOrMiles(e, r, s);
      case H.DistanceMeters:
        return S.ConvertToMetersOrYards(e, r, s);
      case H.DistanceFeet:
        return S.ConvertToMetersOrFeet(e, r, s);
      case H.Direction:
        return S.ConvertToDirection(e);
      case H.Elevation:
        return S.ConvertToMetersOrFeet(e, r, s);
      case H.MoonPhase:
        return S.ConvertToMoonPhase(e);
      case H.Percent:
        return S.ConvertToPercent(e, s);
      case H.Precipitation:
        return S.ConvertToPrecipitation(e, r, s);
      case H.Pressure:
        return S.ConvertToPressure(e, r, s);
      case H.Sentence:
        return S.ConvertToSentenceCase(e);
      case H.SpeedKph:
        return S.ConvertToKmOrMiles(e, r, s);
      case H.SpeedMps:
        return S.ConvertToMetersOrYards(e, r, s);
      case H.Temperature:
        return S.ConvertToTemperature(e, r, s);
      case H.Time:
        return Pt.ConvertDateToEpochTimeMs(e);
    }
    return e;
  }
  static ConvertToDirection(e) {
    const t = Number(e);
    if (!(t < 0 || isNaN(t)))
      return t > 337.5 ? Ce.North : t > 292.5 ? Ce.NW : t > 247.5 ? Ce.West : t > 202.5 ? Ce.SW : t > 157.5 ? Ce.South : t > 112.5 ? Ce.SE : t > 67.5 ? Ce.East : t > 22.5 ? Ce.NE : Ce.North;
  }
  static ConvertToHaOrAcres(e, t, r) {
    const s = t === Ie.Metric ? e : S.HaToAcres(e);
    return S.FormatNumber(s, r);
  }
  static ConvertToKmOrMiles(e, t, r) {
    const s = t === Ie.Metric ? e : S.KmToMiles(e);
    return S.FormatNumber(s, r);
  }
  static ConvertToMetersOrYards(e, t, r) {
    const s = t === Ie.Metric ? e : S.MetersToYards(e);
    return S.FormatNumber(s, r);
  }
  static ConvertToMetersOrFeet(e, t, r) {
    const s = t === Ie.Metric ? e : S.MetersToFeet(e);
    return S.FormatNumber(s, r);
  }
  static ConvertToMoonPhase(e) {
    if (!S.IsValidMoonPhasePercent(e))
      return ee.Unknown;
    const t = Number(e);
    return t === 0 || t === 1 ? ee.NewMoon : t > 0 && t < 0.25 ? ee.WaxingCrescent : t === 0.25 ? ee.FirstQuarter : t > 0.25 && t < 0.5 ? ee.WaxingGibbous : t === 0.5 ? ee.FullMoon : t > 0.5 && t < 0.75 ? ee.WaningGibbous : t === 0.75 ? ee.ThirdQuarter : ee.WaningCrescent;
  }
  static ConvertMoonPhaseIndexToPercent(e) {
    return S.IsValidMoonPhaseIndex(e) ? Number(e) / _r : ee.Unknown;
  }
  static ConvertMoonPhasePercentToIndex(e) {
    return S.IsValidMoonPhasePercent(e) ? Math.round(Number(e) * _r) : ee.Unknown;
  }
  static IsValidMoonPhasePercent(e) {
    return e = parseFloat(e), isNaN(e) || e === ee.Unknown ? !1 : e >= Fs && e <= Vs;
  }
  static IsValidMoonPhaseIndex(e) {
    return e = parseInt(e), isNaN(e) || e === ee.Unknown ? !1 : e >= Gs && e <= Ws;
  }
  static ConvertToPercent(e, t) {
    return `${S.FormatNumber(e, t)}%`;
  }
  static ConvertToPrecipitation(e, t, r) {
    const s = t === Ie.Metric ? e : S.MillimetersToInches(e);
    return S.FormatNumber(s, r);
  }
  static ConvertToPressure(e, t, r) {
    const s = t === Ie.Metric ? S.HpaToKpa(e) : e;
    return S.FormatNumber(s, r);
  }
  static ConvertToSentenceCase(e) {
    return Ys(e) ? e.charAt(0).toUpperCase() + e.slice(1).toLowerCase() : void 0;
  }
  static ConvertToTemperature(e, t, r) {
    const s = t === Ie.Metric ? e : S.CelsiusToFahrenheit(e);
    return S.FormatNumber(s, r);
  }
  static DegreesToRadians(e) {
    return j(e) ? Number(e) * Math.PI / 180 : 0;
  }
  static RadiansToDegrees(e) {
    return j(e) ? Number(e) * 180 / Math.PI : 0;
  }
  static DistanceKmToRadians(e) {
    return j(e) ? Number(e) / Ms : 0;
  }
  static HaToAcres(e) {
    return j(e) ? Number(e) * $s : 0;
  }
  static KmToMiles(e) {
    return j(e) ? Number(e) * Ls : 0;
  }
  static MilesToKm(e) {
    return j(e) ? Number(e) * vs : 0;
  }
  static HpaToKpa(e) {
    return j(e) ? Number(e) * 0.1 : 0;
  }
  static CelsiusToFahrenheit(e) {
    return j(e) ? Number(e) * 9 / 5 + 32 : 0;
  }
  static MillimetersToInches(e) {
    return j(e) ? Number(e) * Us : 0;
  }
  static MetersToYards(e) {
    return j(e) ? Number(e) * ks : 0;
  }
  static MetersToFeet(e) {
    return j(e) ? Number(e) * Bs : 0;
  }
  static BytesToMb(e) {
    return j(e) ? Number(e) / Ur : 0;
  }
  static MbToBytes(e) {
    return j(e) ? Number(e) * Ur : 0;
  }
  /**
   * Converts speed from meters per second to kilometers per hour.
   * @param {number} speedMps - Speed in meters per second.
   * @returns {number} Speed in kilometers per hour.
   */
  static MpsToKmph(e) {
    return j(e) ? e * Pr : 0;
  }
  static KmphToMps(e) {
    return j(e) ? e / Pr : 0;
  }
  /**
   * Calculates the distance between two points
   * @param {( lat: number, lng: number )} startPoint
   * @param {( lat: number, lng: number )} endPoint
   * @returns {number} the distance in meters between the provided points.
   */
  static CalculateDistance(e, t) {
    const r = S.DegreesToRadians(t.lat - e.lat), s = S.DegreesToRadians(t.lng - e.lng), n = S.DegreesToRadians(e.lat), i = S.DegreesToRadians(t.lat), o = Math.sin(r / 2) * Math.sin(r / 2) + Math.sin(s / 2) * Math.sin(s / 2) * Math.cos(n) * Math.cos(i);
    return 2 * Math.atan2(Math.sqrt(o), Math.sqrt(1 - o)) * ua;
  }
  /**
   * Formats a number to have a maximum number of decimal places
   * @param {(string|number)} num - the number to format.
   * @param {number} maxDecimalPlaces - the maximum number of decimal places to preserve.
   * @returns {number} the formatted number
   */
  static FormatNumber(e, t) {
    if (!j(e))
      return e;
    if (!t || t <= 0)
      return Math.round(Number(e));
    const r = Number(e).toFixed(t).replace(/\.?0+$/, "");
    return Number(r);
  }
  /**
   * DMS helper to convert decimal degrees into degrees, minutes, and seconds.
   * The client is respnsible for formatting the DMS string in the locale-specific format.
   * @param {number} degrees - The decimal degrees to convert.
   * @returns {{ d: number, m: number, s: number }} Object containing degrees, minutes, and seconds.
   */
  static DegreesToDMS(e) {
    const t = Math.abs(e), r = Math.floor(t), s = (t - r) * 60, n = Math.floor(s), i = (s - n) * 60;
    return { d: r, m: n, s: i };
  }
  /**
   * Converts a {lat,lng} coordinates object into a MGRS string.
   * MGRS has a universal standard (no localization needed).
   * @param {{lat: number, lng: number}} coordinates - the coordinates to format.
   * @returns {string} the coordinates in MGRS format
   */
  static LatLngToMGRS(e) {
    const { lat: t, lng: r } = e;
    S.ThrowIfInvalidGridLatitude(t), S.ThrowIfInvalidLongitude(r);
    const s = gs([r, t], 5), n = s.match(/^(\d{1,2}[A-Z]{3})(\d+)$/i);
    if (n) {
      const i = n[1], o = n[2], u = o.substring(0, o.length / 2), d = o.substring(o.length / 2);
      return `${i} ${u} ${d}`;
    }
    return s;
  }
  /**
   * Converts a {lat,lng} coordinates object into a UTM string.
   * UTM has a universal standard (no localization needed).
   * @param {{lat: number, lng: number}} coordinates - the coordinates to format.
   * @returns {string} the coordinates in UTM format
   */
  static LatLngToUTM(e) {
    const { lat: t, lng: r } = e;
    if (S.ThrowIfInvalidGridLatitude(t), S.ThrowIfInvalidLongitude(r), r > 180 || r < -180)
      throw new Se(
        Ae.InvalidLongitude,
        `Longitude '${r}' out of bounds (must be between 180 deg W and 180 deg E)`
      );
    const { easting: s, northing: n, zoneNum: i, zoneLetter: o } = ws(t, r);
    return `${i}${o} ${Math.round(s)} ${Math.round(n)}`;
  }
  /**
   * Converts an MGRS string into a {lat,lng} coordinates object
   * MGRS has a universal standard (no localization needed).
   * @param {string} mgrsStr the coordinates in MGRS format
   * @returns {{lat: number, lng: number}} the coordinates object
   * @throws {CoordinateError} if parsing fails
   */
  static MGRSToLatLng(e) {
    S.ThrowIfBlankCoordinate(e);
    let t, r;
    try {
      [r, t] = Es(e.replace(/\s+/g, ""));
    } catch {
      throw new Se(Ae.InvalidFormat, "MGRS library failed to convert coordinates.");
    }
    return S.ThrowIfInvalidLatitude(t), S.ThrowIfInvalidLongitude(r), { lat: t, lng: r };
  }
  /**
   * Converts a UTM string into a {lat,lng} coordinates object
   * UTM has a universal standard (no localization needed).
   * @param {string} utmStr the coordinates in UTM format
   * @returns {{lat: number, lng: number}} the coordinates object
   * @throws {CoordinateError} if parsing fails
   */
  static UTMToLatLng(e) {
    S.ThrowIfBlankCoordinate(e);
    const t = /^(\d{1,2})\s*([C-X])\s+(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)$/i, r = e.trim().match(t);
    if (!r)
      throw new Se(Ae.InvalidFormat, "String does not match standard UTM format.");
    const s = parseInt(r[1], 10), n = r[2].toUpperCase(), i = parseFloat(r[3]), o = parseFloat(r[4]);
    if (s < 1 || s > 60)
      throw new Se(Ae.InvalidFormat, "UTM Zone must be between 1 and 60.");
    let u, d;
    try {
      ({ latitude: u, longitude: d } = Ns(i, o, s, n));
    } catch {
      throw new Se(Ae.InvalidFormat, "UTM library failed to convert coordinates.");
    }
    return S.ThrowIfInvalidLatitude(u), S.ThrowIfInvalidLongitude(d), { lat: u, lng: d };
  }
  /**
   * Creates a bounding box around a given center coordinate and radius.
   * @param {{lat: number, lng: number}} coordinates - the coordinates for the center of the bounding box.
   * @param {number} radiusKm - radius in km
   * @returns array specifying the bounding box coordinates [sw, ne], where each coordinate is an array of [lng, lat] pair
   */
  static BoundingBoxForCoordinates(e, t) {
    const { lat: r, lng: s } = e, n = S.DegreesToRadians(r), i = S.DistanceKmToRadians(t), o = r - i * 180 / Math.PI, u = r + i * 180 / Math.PI, d = Math.asin(Math.sin(i) / Math.cos(n)), l = s - d * 180 / Math.PI, E = s + d * 180 / Math.PI;
    return [[l, o], [E, u]];
  }
  static isValidLatLng(e) {
    if (!e || typeof e != "object")
      return !1;
    const { lat: t, lng: r } = e;
    return S.IsValidLatitude(t) && S.IsValidLongitude(r);
  }
  static IsValidLatitude(e) {
    const t = parseFloat(e);
    return !isNaN(t) && t >= Mr && t <= vr;
  }
  static IsValidLongitude(e) {
    const t = parseFloat(e);
    return !isNaN(t) && t >= Lr && t <= Dr;
  }
  static ThrowIfInvalidLatitude(e) {
    if (!S.IsValidLatitude(e))
      throw new Se(
        Ae.InvalidLatitude,
        `Latitude is out of bounds (must be between ${Math.abs(Mr)}° S and ${Math.abs(vr)}° N).`
      );
  }
  static ThrowIfInvalidLongitude(e) {
    if (!S.IsValidLongitude(e))
      throw new Se(
        Ae.InvalidLongitude,
        `Longitude is out of bounds (must be between ${Math.abs(Lr)}° W and ${Math.abs(Dr)}° E).`
      );
  }
  /**
   * Validates latitude is within grid / projected math limits
   * @param {*} latitude
   * @throws CoordinateError (CoordinateErrorCode.InvalidLatitude) if invalid
   */
  static ThrowIfInvalidGridLatitude(e) {
    if (isNaN(e) || e < -80 || e > 84)
      throw new Se(
        Ae.InvalidLatitude,
        `Latitude is out of bounds (must be between ${Math.abs(-80)}° S and ${Math.abs(84)}° N).`
      );
  }
  static ThrowIfBlankCoordinate(e) {
    if (!e || typeof e != "string" || !e.trim())
      throw new Se(Ae.Blank, "String cannot be blank.");
  }
}
const Yn = Object.freeze({
  CheckApache: {
    scriptName: "check_apache.sh",
    displayName: "Check Apache",
    description: "Verifies the health and running status of the Apache web server."
  },
  CheckCacheUsage: {
    scriptName: "check_cache_usage.sh",
    displayName: "Check Cache Usage",
    description: "Reports the used versus available disk space of the local NVMe cache directory.",
    parameters: [
      {
        id: "cache-type",
        label: "Cache Type",
        options: ["db", "tiles"],
        required: !1
      },
      {
        id: "region",
        label: "Region",
        required: !1
      }
    ]
  },
  CheckCpu: {
    scriptName: "check_cpu.sh",
    displayName: "Check CPU",
    description: "Checks the system cpu and process status."
  },
  ClearCache: {
    scriptName: "clear_cache.sh",
    displayName: "Clear Cache",
    description: "Deletes all cached files from the local NVMe cache for a specific cache type.",
    parameters: [
      {
        id: "cache-type",
        label: "Cache Type",
        options: ["db", "tiles"],
        required: !0
      },
      {
        id: "region",
        label: "Region",
        required: !1
      },
      {
        id: "dry-run",
        label: "Dry Run",
        options: ["true", "false"],
        required: !1
      }
    ]
  },
  GetCacheFlags: {
    scriptName: "get_cache_flags.sh",
    displayName: "Get Cache Feature Flags",
    description: "Gets the feature flags for the local NVMe cache."
  },
  InvalidateCache: {
    scriptName: "invalidate_cache.sh",
    displayName: "Invalidate Cache",
    description: "Deletes any outdated or orphaned files from the local NVMe cache, based on the last updated time in the corresponding source file.",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !0
      },
      {
        id: "dry-run",
        label: "Dry Run",
        options: ["true", "false"],
        required: !1
      }
    ]
  },
  PopulateCache: {
    scriptName: "populate_cache.sh",
    displayName: "Populate Cache",
    description: "Populates missing SQLite db files into the local NVMe cache.",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      },
      {
        id: "dry-run",
        label: "Dry Run",
        options: ["true", "false"],
        required: !1
      }
    ]
  },
  PublishCatalog: {
    scriptName: "publish_catalog.sh",
    displayName: "Publish Catalog",
    description: "Publishes a fresh catalog to the cluster EFS drive.",
    targetDeployServer: !0
  },
  WarmCatalog: {
    scriptName: "warm_catalog.sh",
    displayName: "Warm Catalog",
    description: "Warms the local NVMe cache with the current catalog from the cluster EFS drive."
  },
  CheckHealth: {
    scriptName: "check_health.sh",
    displayName: "Check Health",
    description: "Reports the deep health of each instance: EFS, NVMe, published catalog, Martin and Postgres."
  },
  RestartApache: {
    scriptName: "restart_apache.sh",
    displayName: "Force Restart Apache",
    description: "Hard reset the Apache web server process by force killing all processes and restarting fresh."
  },
  ReloadApache: {
    scriptName: "reload_apache.sh",
    displayName: "Reload Apache",
    description: "Safely reloads the Apache web server process to apply configuration or environment changes."
  },
  ReloadMartin: {
    scriptName: "reload_martin.sh",
    displayName: "Reload Martin",
    description: "Safely reloads the Martin service to clear .mbtiles cache and apply configuration changes."
  },
  ReloadPHP: {
    scriptName: "reload_php.sh",
    displayName: "Reload PHP",
    description: "Safely reloads the PHP-FPM service to clear .php OPcache and update PHP-FPM configuration."
  },
  SetCacheFlag: {
    scriptName: "set_cache_flag.sh",
    displayName: "Set Cache Feature Flag",
    description: "Enables or disables local caching to the NVMe drive for a specific cache type.",
    parameters: [
      {
        id: "cache-type",
        label: "Cache Type",
        options: ["db", "tiles"],
        required: !0
      },
      {
        id: "cache-state",
        label: "Cache State",
        options: ["enable", "disable"],
        required: !0
      }
    ]
  },
  UpdateCache: {
    scriptName: "update_cache.sh",
    displayName: "Update Cache",
    description: "Updates any missing or outdated SQLite db files in the local NVMe cache.",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      },
      {
        id: "dry-run",
        label: "Dry Run",
        options: ["true", "false"],
        required: !1
      }
    ]
  },
  ViewApacheLogs: {
    scriptName: "view_apache_logs.sh",
    displayName: "View Apache Logs",
    description: "Gets the Apache HTTP server logs."
  },
  ViewDeployLogs: {
    scriptName: "view_deploy_audit_logs.sh",
    displayName: "View Deploy Audit Logs",
    description: "Gets the last 20 audit entries from the local deployment log on the deploy server.",
    targetDeployServer: !0
  }
}), zn = Object.freeze({
  ProductCatalog: {
    displayName: "Product Catalog",
    paths: ["/product/regions.json", "/product/catalog.json", "/product/skus.json", "/product/prices.json", "/product/{region}/catalog.json"],
    description: "Product catalog.json, regions.json, skus.json and prices.json",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      }
    ]
  },
  ProductMessages: {
    displayName: "Product Messages",
    paths: ["/product/{region}/messages.json", "/product/{region}/{platform}/messages.json"],
    description: "Product messages.json for various regions and platforms",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      },
      {
        id: "platform",
        label: "Platform",
        options: ["web", "ios", "android"],
        required: !1
      }
    ]
  },
  LocationWeather: {
    displayName: "Weather",
    paths: "/location/weather/*",
    description: "Weather data for various locations in /location/weather/*"
  },
  LocationSolunar: {
    displayName: "Solunar",
    paths: "/location/solunar/*",
    description: "Solunar data for various locations in /location/solunar/*"
  },
  LocationElevation: {
    displayName: "Elevation",
    paths: "/location/elevation/*",
    description: "Elevation data for various locations in /location/elevation/*"
  },
  RasterTiles: {
    displayName: "Raster Tiles",
    paths: "/tiles/{region}/*",
    description: "Raster tiles for map layers in /tiles/{region}/*",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      }
    ]
  },
  LayerData: {
    displayName: "Layer Data",
    paths: "/layers/{region}/*",
    description: "All layer data including vector tiles in /layers/{region}/*",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      }
    ]
  },
  Regulations: {
    displayName: "Regulations",
    paths: ["/layers/{region}/regulations/*"],
    description: "Regulations for various regions in /layers/{region}/regulations/*",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      }
    ]
  },
  Assets: {
    displayName: "Static Assets",
    paths: ["/assets/*"],
    description: "Static assets in /assets/*"
  },
  Locale: {
    displayName: "Locale Strings",
    paths: ["/locale/*"],
    description: "Locale static assets in /locale/*"
  },
  MobileResources: {
    displayName: "Mobile Resources",
    paths: ["/res/{region}/*"],
    description: "Mobile .zip resource bundles in /res/{region}/*",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      }
    ]
  },
  WebResources: {
    displayName: "Web Resources",
    paths: ["/res/provinces/{region}/*"],
    description: "Web resource metadata.json, .pdf and .png tiles in /res/provinces/{region}/*",
    parameters: [
      {
        id: "region",
        label: "Region",
        required: !1
      }
    ]
  }
}), zs = 8e3, Br = 60 * 1e3;
function Hs(a) {
  return !a || a === "none" ? null : a.trim().replace(/^W\//, "").replace(/"/g, "");
}
function $r(a) {
  const e = a ? Date.parse(a) : NaN;
  return Number.isNaN(e) ? null : e;
}
function qs(a) {
  const e = {};
  for (const t of (a || "").split(",")) {
    const [r, ...s] = t.trim().split(";");
    if (!r) continue;
    const n = {};
    for (const i of s) {
      const [o, u] = i.trim().split("=");
      o === "dur" && (n.dur = Number(u)), o === "desc" && (n.desc = (u || "").replace(/^"|"$/g, ""));
    }
    e[r.trim()] = n;
  }
  return e;
}
function Kt() {
  return typeof performance < "u" ? performance.now() : Date.now();
}
async function Ks(a, e = {}) {
  const { method: t = "GET", headers: r = {}, read: s, credentials: n, mode: i, redirect: o, timeoutMs: u = zs } = e, d = e.fetch || globalThis.fetch;
  let l = e.body;
  const E = { ...r };
  l && typeof l == "object" && (l = JSON.stringify(l), E["Content-Type"] = E["Content-Type"] || "application/json");
  const m = typeof AbortController < "u" ? new AbortController() : null, f = m ? setTimeout(() => m.abort(), u) : null, y = Kt();
  try {
    const C = { method: t, headers: E, body: l, cache: "no-store", signal: m == null ? void 0 : m.signal };
    n && (C.credentials = n), i && (C.mode = i), o && (C.redirect = o);
    const O = await d(a, C), _ = await O.arrayBuffer(), b = Math.round(Kt() - y), w = (v) => O.headers.get(v), g = w("age"), R = {
      url: a,
      method: t,
      status: O.status,
      ok: O.ok,
      latencyMs: b,
      etag: Hs(w("etag")),
      date: w("date"),
      age: g === null ? null : Number(g),
      lastModified: w("last-modified"),
      cacheControl: w("cache-control"),
      xCache: w("x-cache"),
      pop: w("x-amz-cf-pop"),
      servedBy: w("x-served-by"),
      contentType: w("content-type"),
      contentLength: w("content-length") === null ? null : Number(w("content-length")),
      serverTiming: w("server-timing") ? qs(w("server-timing")) : null,
      size: _.byteLength
    };
    if (s === "json" || s === "text") {
      const v = new TextDecoder().decode(_);
      if (s === "text")
        R.body = v;
      else
        try {
          R.body = JSON.parse(v);
        } catch {
          R.body = null, R.parseError = `Response is not JSON (${R.contentType || "unknown content type"})`;
        }
    }
    return R;
  } catch (C) {
    const O = (C == null ? void 0 : C.name) === "AbortError";
    return {
      url: a,
      method: t,
      status: null,
      ok: !1,
      latencyMs: Math.round(Kt() - y),
      age: null,
      timedOut: O,
      error: O ? `timed out after ${u}ms` : `network or CORS error (${C.message})`
    };
  } finally {
    f && clearTimeout(f);
  }
}
function Hn(a, e, t, r, s, n = (i) => new Date(i).toLocaleString()) {
  const i = [];
  if (a.status !== 200 && i.push(`Origin ${a.error || `returned ${a.status}`}`), e.status !== 200 && i.push(`CDN ${e.error || `returned ${e.status}`}`), i.length)
    return i;
  !a.etag || !e.etag ? i.push("ETag header is not readable (deploy Access-Control-Expose-Headers in htdocs.conf, then invalidate)") : (e.etag !== a.etag && i.push(`CDN ETag ${e.etag} differs from origin ${a.etag}`), t && a.etag !== t && i.push(`Origin ETag ${a.etag} differs from published ${t}`));
  const o = $r(e.date);
  r && o !== null && o < r - Br && i.push(`CDN copy was fetched ${n(o)}, before ${n(r)} (${e.xCache || "unknown cache status"})`);
  const u = $r(e.lastModified);
  return s && u !== null && u < s - Br && i.push(`Last-Modified ${n(u)} predates the publish`), i;
}
const k = Object.freeze({
  OK: "ok",
  DEGRADED: "degraded",
  DOWN: "down",
  SKIPPED: "skipped"
}), p = Object.freeze({
  CRITICAL: 1,
  CORE: 2,
  SECONDARY: 3
}), Ne = Object.freeze({
  BROWSER: "browser",
  SERVER: "server"
}), A = [Ne.BROWSER, Ne.SERVER], Jt = [Ne.BROWSER], la = [Ne.SERVER], h = Object.freeze({
  APP: "app",
  WEB_V2: "webV2",
  WEB_V1: "webV1",
  MOBILE: "mobile",
  FUNCTIONS: "functions",
  FIREBASE: "firebase",
  CLUSTER: "cluster",
  CDN: "cdn",
  THIRD_PARTY: "thirdParty",
  CERTIFICATES: "certificates"
}), qn = Object.freeze([
  {
    id: h.APP,
    name: "Releases",
    description: "Deployed versions of web v2, web v1, the Dashboard and Store, and the App Store release"
  },
  {
    id: h.MOBILE,
    name: "Mobile Resources",
    description: "Data the iOS and Android apps download (the tiles host is an alias of the resource cluster)"
  },
  {
    id: h.WEB_V2,
    name: "Web v2",
    description: "The ihunter_web app (beta); missing files still return index.html, so these check content, not just status"
  },
  {
    id: h.WEB_V1,
    name: "Web v1",
    description: "The ihunter_webapp host; also serves HuntLog to every app, and PHP APIs used by the mobile apps"
  },
  { id: h.FUNCTIONS, name: "Functions APIs", description: "Firebase functions behind the api host" },
  { id: h.CLUSTER, name: "Cluster Resources", description: "Origin servers behind the resources host" },
  { id: h.CDN, name: "CDN Resources", description: "CloudFront distribution behind the maps host" },
  { id: h.FIREBASE, name: "Firebase Services", description: "Realtime Database and Authentication" },
  { id: h.THIRD_PARTY, name: "Third-party Services", description: "External services the apps, functions and resource cluster depend on" },
  { id: h.CERTIFICATES, name: "Certificates", description: "TLS certificate expiry" }
]), te = Object.freeze({
  CDN: 350,
  ORIGIN: 500,
  FUNCTION: 500,
  THIRD_PARTY: 2e3
}), Gr = Object.freeze({
  [h.APP]: te.ORIGIN,
  [h.WEB_V2]: te.ORIGIN,
  [h.WEB_V1]: te.ORIGIN,
  [h.MOBILE]: te.ORIGIN,
  [h.FUNCTIONS]: te.FUNCTION,
  [h.FIREBASE]: te.ORIGIN,
  [h.CLUSTER]: te.ORIGIN,
  [h.CDN]: te.CDN,
  [h.THIRD_PARTY]: te.THIRD_PARTY,
  [h.CERTIFICATES]: null
  // TLS lookups via a function; not a measure of the host
}), T = Object.freeze({
  region: "ab",
  group: "wmu",
  layer: "wmu_3",
  boundary: "300",
  lat: 49.18,
  lon: -113.67,
  tile: Object.freeze({ z: 10, x: 188, y: 350 }),
  lang: "en",
  iosBundleId: "com.kindevelopment.ihunteralberta",
  // Required by the mobile apps on a fresh install; the rest are optional or purchase-only
  requiredBundles: Object.freeze(["wmu", "layers"]),
  mailchimpDatacenter: "us13"
}), Js = "https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js", Wr = "mapbox/standard-satellite", Xt = "ihunter-status-probe", Xs = 7, Zs = 14, Fr = (a) => a.target === Ne.BROWSER && !a.isSameOrigin(a.config.url.api) ? "Not available cross-origin; see the server result" : null;
function Qs(a) {
  const e = (a || "").match(/<versions\b([^>]*)\/?>/);
  if (!e)
    return null;
  const t = {};
  for (const [, r, s] of e[1].matchAll(/(\w+)="([^"]*)"/g))
    t[r] = s;
  return t;
}
const I = (a, e) => ({ state: k.OK, detail: a, ...e }), P = (a, e) => ({ state: k.DEGRADED, detail: a, ...e }), L = (a, e) => ({ state: k.DOWN, detail: a, ...e });
function or(a) {
  var s, n, i, o;
  const e = {}, t = a.method === "GET" && !/no-store/i.test(a.cacheControl || "");
  a.etag && t && (e.etag = a.etag), a.servedBy && (e.servedBy = a.servedBy), a.xCache && (e.cache = a.xCache), a.pop && (e.pop = a.pop), a.age !== null && a.age !== void 0 && (e.age = a.age);
  const r = a.serverTiming;
  if (r && !/hit/i.test(a.xCache || "")) {
    const u = ((s = r.app) == null ? void 0 : s.dur) ?? ((n = r.total) == null ? void 0 : n.dur);
    u !== void 0 && (e.server = `${Math.round(u)}ms`), (i = r.cache) != null && i.desc && r.cache.desc !== "unused" && (e.originCache = r.cache.desc), (o = r.manifest) != null && o.desc && (e.manifestCache = r.manifest.desc);
  }
  return e;
}
function ue(a) {
  return a.error || `HTTP ${a.status}`;
}
async function N(a, e, t = {}, r) {
  const s = await a.probe(e, t), n = or(s);
  if (!(t.expectStatus || [200]).includes(s.status))
    return L(ue(s), { probe: s, facts: n });
  if (s.parseError)
    return L(s.parseError, { probe: s, facts: n });
  const o = r ? await r(s.body, s) : null;
  return { ...o || I(`HTTP ${s.status}`), probe: s, facts: { ...n, ...o == null ? void 0 : o.facts } };
}
function Vr(a, e) {
  var r, s;
  const t = (s = (r = e.serverTiming) == null ? void 0 : r.cache) == null ? void 0 : s.desc;
  return t === "legacy" ? P("Serving the legacy catalog; no catalog has been published") : t === "disabled" ? P("Served from EFS; this instance's local cache is unavailable") : I(`HTTP ${e.status}`);
}
function lt(a) {
  return (e) => {
    const t = e && typeof e == "object" ? Object.keys(e).length : 0;
    return t ? I(`${t} ${a}`) : L(`No ${a}`);
  };
}
function Zt(a) {
  if (!(a != null && a.version))
    return L("Manifest has no version (is the SPA rewrite serving index.html?)");
  const e = a.release || [a.date, a.time].filter(Boolean).join(" ") || void 0;
  return I(`Version ${a.version}`, { facts: { released: e } });
}
function Ve(a, e) {
  return a.config.url.api + e;
}
function pe(a, e) {
  return a.config.url.resources + e;
}
function he(a, e) {
  return a.config.url.maps + e;
}
function en(a) {
  return c(a, { lat: T.lat, lng: T.lon, lon: T.lon, lang: T.lang });
}
async function jr(a) {
  const e = await a.getToken();
  if (!e)
    throw new Error("Not signed in");
  return { Authorization: `Firebase ${e}` };
}
function J({ id: a, tier: e, name: t, description: r, runsOn: s = la, probes: n }) {
  return {
    id: a,
    group: h.THIRD_PARTY,
    tier: e,
    name: t,
    description: r,
    runsOn: s,
    run: async (i) => {
      const o = await Promise.all(
        n.map(async (m) => {
          const { url: f, expectStatus: y, label: C, ...O } = m, _ = await i.probe(f.replace("{project}", i.config.firebase), O);
          return { label: m.label, result: _, reachable: y.includes(_.status) };
        })
      ), u = o.filter((m) => !m.reachable), d = Math.max(...o.map((m) => m.result.latencyMs || 0)), l = (m) => m.label ? `${m.label} ` : "";
      if (u.length) {
        const m = u.map((f) => `${l(f)}${ue(f.result)}`).join("; ");
        return u.length === o.length ? L(m, { probe: u[0].result, latencyMs: d }) : P(m, { probe: u[0].result, latencyMs: d });
      }
      const E = o.map((m) => `${l(m)}HTTP ${m.result.status}`).join(", ");
      return I(`Reachable (${E})`, { probe: o[0].result, latencyMs: d });
    }
  };
}
function Be(a, e, t = p.SECONDARY) {
  return {
    id: `certificates.${a}`,
    group: h.CERTIFICATES,
    tier: t,
    name: e,
    urlKey: a,
    runsOn: A,
    skip: (r) => r.certExpiry ? r.config.url[a] ? null : `No ${a} url configured` : "Certificate lookup is not available",
    run: async (r) => {
      const s = r.config.url[a], n = await r.certExpiry(s), i = { host: new URL(s).host, expires: n == null ? void 0 : n.expiry };
      if (!n || n.error)
        return L((n == null ? void 0 : n.error) || "Certificate lookup failed", { facts: i });
      const o = `Expires in ${n.days} days`;
      return n.days <= Xs ? L(o, { facts: i }) : n.days <= Zs ? P(o, { facts: i }) : I(o, { facts: i });
    }
  };
}
const tn = Object.freeze([
  // Apps
  {
    id: "app.webV2",
    group: h.APP,
    tier: p.CORE,
    name: "Web v2",
    description: "The deployed version (manifest.json is JSON, not the index.html fallback)",
    runsOn: A,
    run: (a) => N(a, a.config.url.web + "/manifest.json", { read: "json" }, Zt)
  },
  {
    id: "app.webV1",
    group: h.APP,
    tier: p.CORE,
    name: "Web v1",
    description: "The deployed build (version.txt)",
    runsOn: A,
    run: (a) => N(a, a.config.url.webapp + "/version.txt", { read: "text" }, (e) => {
      const t = Object.fromEntries([...(e || "").matchAll(/^(\w+)="?([^"\n]*)"?$/gm)].map(([, n, i]) => [n, i]));
      if (!t.BUILD_VERSION)
        return L("version.txt has no BUILD_VERSION");
      const r = Number(t.BUILD_STAMP), s = { build: t.BUILD_HASH, released: r ? new Date(r).toISOString() : void 0 };
      return t.BUILD_DEBUG === "true" && !a.config.debug ? P(`Version ${t.BUILD_VERSION} is a debug build`, { facts: s }) : I(`Version ${t.BUILD_VERSION}`, { facts: s });
    })
  },
  {
    id: "app.dashboard",
    group: h.APP,
    tier: p.SECONDARY,
    name: "Dashboard",
    runsOn: A,
    skip: Fr,
    run: (a) => N(a, Ve(a, "/manifest.json"), { read: "json" }, Zt)
  },
  {
    id: "app.store",
    group: h.APP,
    tier: p.CORE,
    name: "Store",
    runsOn: A,
    run: (a) => N(a, a.config.url.store + "/manifest.json", { read: "json" }, Zt)
  },
  {
    id: "app.ios",
    group: h.APP,
    tier: p.SECONDARY,
    name: "iOS App Store listing",
    runsOn: A,
    run: (a) => N(a, `https://itunes.apple.com/lookup?bundleId=${T.iosBundleId}`, { read: "json" }, (e) => {
      var r;
      const t = (r = e == null ? void 0 : e.results) == null ? void 0 : r[0];
      return t ? I(`Version ${t.version}`, { facts: { released: t.currentVersionReleaseDate } }) : L("App is not listed");
    })
  },
  // Functions
  {
    id: "functions.session",
    group: h.FUNCTIONS,
    tier: p.CRITICAL,
    name: "Session sign-in API",
    description: "session-api/status exchanges the shared session cookie at web app boot; any non-5xx reply means it is alive",
    runsOn: A,
    skip: Fr,
    run: (a) => N(
      a,
      Ve(a, "/session-api/status"),
      { credentials: "omit", expectStatus: [200, 401, 403] },
      (e, t) => I(`Responding (HTTP ${t.status} without a session)`)
    )
  },
  {
    id: "functions.info",
    group: h.FUNCTIONS,
    tier: p.CORE,
    name: "Functions liveness",
    description: "/info/status",
    runsOn: A,
    run: (a) => N(a, Ve(a, "/info/status"), { read: "json" }, (e) => I(e != null && e.version ? `Version ${e.version}` : "Responding"))
  },
  {
    id: "functions.authenticated",
    group: h.FUNCTIONS,
    tier: p.CRITICAL,
    name: "Authenticated API",
    description: "An authenticated round-trip through authHandler (/user/scopes)",
    runsOn: Jt,
    run: async (a) => N(a, Ve(a, "/user/scopes"), { read: "json", headers: await jr(a) }, () => I("Authorized"))
  },
  {
    id: "functions.crypto",
    group: h.FUNCTIONS,
    tier: p.CORE,
    name: "Encrypt / decrypt",
    budgetMs: 2 * te.FUNCTION,
    // Two requests
    description: "Round-trip through utilities-api, which the web app needs to show users' own pins, tracks and chats",
    runsOn: Jt,
    run: async (a) => {
      var i, o, u, d;
      const e = await jr(a), t = await a.probe(Ve(a, "/utilities-api/encrypt"), {
        method: "POST",
        read: "json",
        headers: e,
        body: { unencryptedData: [{ id: "probe", value: Xt }], properties: ["value"], idProperty: "id" }
      }), r = (o = (i = t.body) == null ? void 0 : i.probe) == null ? void 0 : o.value;
      if (t.status !== 200 || !r)
        return L(`Encrypt failed: ${t.parseError || ue(t)}`, { probe: t });
      if (r === Xt)
        return L("Encrypt returned the plain text", { probe: t });
      const s = await a.probe(Ve(a, "/utilities-api/decrypt"), {
        method: "POST",
        read: "json",
        headers: e,
        body: { encryptedData: [{ id: "probe", value: r }], properties: ["value"], idProperty: "id" }
      }), n = t.latencyMs + s.latencyMs;
      return s.status !== 200 ? L(`Decrypt failed: ${s.parseError || ue(s)}`, { probe: s, latencyMs: n }) : ((d = (u = s.body) == null ? void 0 : u.probe) == null ? void 0 : d.value) !== Xt ? L("Decrypted value does not match", { probe: s, latencyMs: n }) : I("Round-trip matches", { probe: s, latencyMs: n });
    }
  },
  // Firebase
  {
    id: "firebase.auth",
    group: h.FIREBASE,
    tier: p.CRITICAL,
    name: "Authentication",
    description: "Refreshes the ID token (securetoken.googleapis.com), which every authenticated call depends on",
    runsOn: Jt,
    run: async (a) => await a.getToken(!0) ? I("Token refreshed") : L("No signed-in user")
  },
  {
    id: "firebase.rtdb",
    group: h.FIREBASE,
    tier: p.CRITICAL,
    name: "Realtime Database",
    description: "User preferences gate the web app map; reachable if it denies an anonymous shallow read",
    runsOn: A,
    run: (a) => N(
      a,
      `https://${a.config.firebase}.firebaseio.com/.json?shallow=true`,
      { expectStatus: [200, 401] },
      (e, t) => I(`Reachable (HTTP ${t.status})`, { facts: { project: a.config.firebase } })
    )
  },
  // Resource cluster (origin)
  {
    id: "cluster.status",
    group: h.CLUSTER,
    tier: p.CRITICAL,
    name: "Load balancer health",
    description: "status.php, as queried by the load balancer",
    runsOn: A,
    run: (a) => N(
      a,
      pe(a, "/status.php"),
      { read: "text" },
      (e) => (e == null ? void 0 : e.trim()) === "OK" ? I("OK") : L((e == null ? void 0 : e.trim()) || "Unexpected response")
    )
  },
  {
    id: "cluster.health",
    group: h.CLUSTER,
    tier: p.CRITICAL,
    name: "Instance health",
    description: "health.php on whichever instance answers: EFS, NVMe, published catalog, Martin and Postgres",
    runsOn: A,
    run: async (a) => {
      var o;
      const e = await a.probe(pe(a, "/health.php"), { read: "json" }), t = or(e), r = e.body;
      if (!(r != null && r.components)) {
        const u = e.status === 404 ? "health.php is not deployed" : e.parseError || ue(e);
        return L(u, { probe: e, facts: t });
      }
      t.host = r.host, t.generation = (o = r.components.catalog) == null ? void 0 : o.generation;
      const s = Object.entries(r.components).filter(([, u]) => u.state !== k.OK).map(([u, d]) => `${u}: ${d.detail}`);
      r.online || s.unshift("Instance is offline");
      const n = Object.values(k).includes(r.state) ? r.state : k.DOWN, i = s.length ? s.join("; ") : `All components healthy on ${r.host}`;
      return { state: n, detail: i, probe: e, facts: t, data: r };
    }
  },
  {
    id: "cluster.catalog",
    group: h.CLUSTER,
    tier: p.CORE,
    name: "Catalog (origin)",
    description: "Origin cache: hit (local NVMe), miss (mirrored from EFS), disabled (no local cache) or legacy (no published manifest)",
    runsOn: A,
    run: (a) => N(a, pe(a, Te.Catalog()), {}, Vr)
  },
  {
    id: "cluster.skus",
    group: h.CLUSTER,
    tier: p.CORE,
    name: "SKUs (origin)",
    description: "Published with the catalog; same origin cache states as the catalog",
    runsOn: A,
    run: (a) => N(a, pe(a, Te.Skus()), { read: "json" }, (e, t) => {
      const r = Vr(e, t);
      return r.state === k.OK ? lt("SKUs")(e) : r;
    })
  },
  {
    id: "cluster.prices",
    group: h.CLUSTER,
    tier: p.CORE,
    name: "Prices (origin)",
    description: "From the Firebase product prices, cached for an hour: hit, stale (refreshing), or miss (fetched from Firebase)",
    runsOn: A,
    run: (a) => N(a, pe(a, Te.Prices()), { read: "json" }, lt("prices"))
  },
  {
    id: "cluster.batchLocation",
    group: h.CLUSTER,
    tier: p.CORE,
    name: "Map tap (boundaries at location)",
    runsOn: A,
    run: (a) => N(
      a,
      pe(a, Xe.BatchBoundariesAtLocation(T.region)),
      {
        method: "POST",
        read: "json",
        body: { lat: T.lat, lon: T.lon, layers: [{ group: T.group, layer: T.layer }] }
      },
      (e) => {
        var r, s;
        return (((s = (r = e == null ? void 0 : e.results) == null ? void 0 : r[0]) == null ? void 0 : s.boundaries) || []).some((n) => n.code === T.boundary) ? I(`Found ${T.layer} ${T.boundary}`) : P(`Expected ${T.layer} ${T.boundary} at ${T.lat},${T.lon}`);
      }
    )
  },
  {
    id: "cluster.batchSearch",
    group: h.CLUSTER,
    tier: p.CORE,
    name: "Search (boundaries matching search)",
    runsOn: A,
    run: (a) => N(
      a,
      pe(a, Xe.BatchBoundariesMatchingSearch(T.region)),
      {
        method: "POST",
        read: "json",
        body: { search: T.boundary, layers: [{ group: T.group, layer: T.layer, max: 1 }] }
      },
      (e) => {
        var t, r, s;
        return (s = (r = (t = e == null ? void 0 : e.results) == null ? void 0 : t[0]) == null ? void 0 : r.boundaries) != null && s.length ? I(`Found ${e.results[0].boundaries[0].title}`) : P(`No results for "${T.boundary}"`);
      }
    )
  },
  {
    id: "cluster.weather",
    group: h.CLUSTER,
    tier: p.SECONDARY,
    name: "Weather (OpenWeather)",
    budgetMs: 3e3,
    // Live OpenWeather request on a cache miss
    runsOn: A,
    run: (a) => N(
      a,
      pe(a, Te.Weather(T.lat, T.lon, T.lang)),
      { read: "json" },
      (e) => (e == null ? void 0 : e.temp) !== void 0 && (e == null ? void 0 : e.temp) !== "" ? I(`${e.temp}° ${e.weather_desc || ""}`.trim()) : P("No weather data")
    )
  },
  {
    id: "cluster.elevation",
    group: h.CLUSTER,
    tier: p.CRITICAL,
    name: "Elevation (geogratis)",
    budgetMs: 2e3,
    // Live GeoGratis request
    runsOn: A,
    run: (a) => N(
      a,
      pe(a, Te.Elevation(T.lat, T.lon)),
      { read: "json" },
      (e) => typeof (e == null ? void 0 : e.altitude) == "number" ? I(`${e.altitude} m`) : P("No elevation data")
    )
  },
  {
    id: "cluster.solunar",
    group: h.CLUSTER,
    tier: p.SECONDARY,
    name: "Solunar",
    runsOn: A,
    run: (a) => N(
      a,
      pe(a, en("/location/solunar/{lat},{lon}.json")),
      { read: "json" },
      (e) => e != null && e.moonrise ? I(`Moonrise ${e.moonrise}`) : P("No solunar data")
    )
  },
  // CDN
  {
    id: "cdn.catalog",
    group: h.CDN,
    tier: p.CRITICAL,
    name: "Catalog",
    description: "The web app renders no layers or region picker without it",
    runsOn: A,
    run: (a) => N(a, he(a, Te.Catalog()), { read: "json" }, (e) => {
      var r, s, n, i;
      const t = Object.keys(e || {});
      return t.length ? (i = (n = (s = (r = e[T.region]) == null ? void 0 : r.resources) == null ? void 0 : s[T.group]) == null ? void 0 : n.layers) != null && i[T.layer] ? I(`${t.length} regions`) : P(
        `Fixture layer ${T.region}/${T.group}/${T.layer} is missing; update CheckFixture`
      ) : L("Catalog is empty");
    })
  },
  {
    id: "cdn.consistency",
    group: h.CDN,
    tier: p.CRITICAL,
    name: "Catalog consistency",
    budgetMs: null,
    // Compares other checks' results; makes no requests of its own
    description: "The CDN, the origin and the published manifest serve the same catalog ETag",
    runsOn: A,
    run: async (a) => {
      var d, l, E, m, f;
      const [e, t, r] = await Promise.all([a.result("cdn.catalog"), a.result("cluster.catalog"), a.result("cluster.health")]), s = (d = e == null ? void 0 : e.facts) == null ? void 0 : d.etag, n = (l = t == null ? void 0 : t.facts) == null ? void 0 : l.etag, i = (f = (m = (E = r == null ? void 0 : r.data) == null ? void 0 : E.components) == null ? void 0 : m.catalog) == null ? void 0 : f.etag, o = { cdn: s, origin: n, published: i };
      if ((e == null ? void 0 : e.status) !== 200 || (t == null ? void 0 : t.status) !== 200)
        return L("The catalog is unavailable from the CDN or the origin (see those checks)", { facts: o });
      if (!s || !n) {
        const y = [!s && "CDN", !n && "origin"].filter(Boolean).join(" and ");
        return a.target === Ne.BROWSER ? {
          state: k.SKIPPED,
          detail: `The browser can't read the ${y} ETag (not in Access-Control-Expose-Headers); see the server result`,
          facts: o
        } : P(`No ETag from the ${y}`, { facts: o });
      }
      const u = [];
      return s !== n && u.push(`CDN serves ${s}, origin ${n} (invalidate the product catalog paths)`), i && n !== i && u.push(`Origin serves ${n}, published ${i} (warm the catalog)`), u.length ? P(u.join("; "), { facts: o }) : I(i ? "CDN, origin and published manifest match" : "CDN and origin match", { facts: o });
    }
  },
  {
    id: "cdn.skus",
    group: h.CDN,
    tier: p.CORE,
    name: "SKUs",
    runsOn: A,
    run: (a) => N(a, he(a, Te.Skus()), { read: "json" }, lt("SKUs"))
  },
  {
    id: "cdn.prices",
    group: h.CDN,
    tier: p.CORE,
    name: "Prices",
    description: "Read by the Store",
    runsOn: A,
    run: (a) => N(a, he(a, Te.Prices()), { read: "json" }, lt("prices"))
  },
  {
    id: "cdn.messages",
    group: h.CDN,
    tier: p.CORE,
    name: "News messages",
    runsOn: A,
    run: (a) => N(
      a,
      he(a, Te.Messages(T.region, "web")),
      { read: "json" },
      (e) => Array.isArray(e) ? I(`${e.length} messages`) : P("Messages are not a list")
    )
  },
  {
    id: "cdn.region",
    group: h.CDN,
    tier: p.CORE,
    name: "Region metadata",
    runsOn: A,
    run: (a) => N(
      a,
      he(a, z.RegionMetadata(T.region)),
      { read: "json" },
      (e) => I(e != null && e.regulations_version ? `Regulations ${e.regulations_version}` : "Loaded")
    )
  },
  {
    id: "cdn.layerMetadata",
    group: h.CDN,
    tier: p.CORE,
    name: "Layer metadata",
    runsOn: A,
    run: (a) => N(
      a,
      he(a, z.ResourceLayerMetadata(T.region, T.group, T.layer)),
      { read: "json" },
      (e) => I((e == null ? void 0 : e.name) || "Loaded", { facts: { version: e == null ? void 0 : e.version } })
    )
  },
  {
    id: "cdn.vectorMetadata",
    group: h.CDN,
    tier: p.CORE,
    name: "Vector tileset metadata",
    runsOn: A,
    run: (a) => N(
      a,
      he(a, Xe.VectorMetadata(T.region, T.group, T.layer)),
      { read: "json" },
      (e) => (e == null ? void 0 : e.maxzoom) !== void 0 ? I(`Zoom ${e.minzoom}-${e.maxzoom}`) : P("Missing zoom range")
    )
  },
  {
    id: "cdn.vectorTile",
    group: h.CDN,
    tier: p.CORE,
    name: "Vector tile (Martin)",
    runsOn: A,
    run: (a) => {
      const e = c(Xe.VectorTile(T.region, T.group, T.layer), T.tile);
      return N(
        a,
        he(a, e),
        {},
        (t, r) => r.size > 0 ? I(`${r.size} bytes`) : P("Tile is empty")
      );
    }
  },
  {
    id: "cdn.regulations",
    group: h.CDN,
    tier: p.CRITICAL,
    name: "Regulations",
    runsOn: A,
    run: (a) => N(
      a,
      he(a, Xe.Regulations(T.region, T.boundary)),
      { read: "json" },
      (e) => Array.isArray(e) && e.length ? I(`${e.length} seasons`) : P(`No regulations for ${T.boundary}`)
    )
  },
  {
    id: "cdn.counties",
    group: h.CDN,
    tier: p.SECONDARY,
    name: "Landowner maps index",
    runsOn: A,
    run: (a) => N(
      a,
      he(a, z.CountyMetadata(T.region)),
      { read: "json" },
      (e) => {
        var t;
        return I(`${((t = e == null ? void 0 : e.counties) == null ? void 0 : t.length) || 0} maps`);
      }
    )
  },
  // Third-party
  {
    id: "thirdParty.mapbox",
    group: h.THIRD_PARTY,
    tier: p.CRITICAL,
    name: "Mapbox basemap",
    description: `The default basemap style (${Wr})`,
    runsOn: A,
    skip: (a) => {
      var e;
      return (e = a.config.mapbox) != null && e.accessToken ? null : "No Mapbox access token configured";
    },
    run: (a) => N(
      a,
      `https://api.mapbox.com/styles/v1/${Wr}?access_token=${a.config.mapbox.accessToken}`,
      { read: "json" },
      (e) => e != null && e.version ? I(e.name || "Style loaded") : P("Unexpected style response")
    )
  },
  {
    id: "thirdParty.mapkit",
    group: h.THIRD_PARTY,
    tier: p.CRITICAL,
    name: "Apple MapKit JS",
    description: "Loaded as a render-blocking script on every web v2 page load, and by web v1",
    runsOn: A,
    run: (a) => N(a, Js, {}, (e, t) => t.size > 0 ? I(`${t.size} bytes`) : P("Script is empty"))
  },
  J({
    id: "thirdParty.googleMaps",
    tier: p.CRITICAL,
    name: "Google Maps",
    description: "The default basemap on Android, and the web v1 basemap",
    probes: [{ url: "https://maps.googleapis.com/maps/api/js", expectStatus: [200] }]
  }),
  J({
    id: "thirdParty.firebaseAuth",
    tier: p.CRITICAL,
    name: "Firebase Authentication API",
    description: "Sign-in for every app (identitytoolkit), and the certificates functions use to verify tokens",
    probes: [
      {
        label: "Identity Toolkit",
        url: "https://identitytoolkit.googleapis.com/v1/accounts:lookup",
        method: "POST",
        body: {},
        expectStatus: [400, 401, 403]
      },
      {
        label: "Token certificates",
        url: "https://www.googleapis.com/robot/v1/metadata/x509/securetoken@system.gserviceaccount.com",
        expectStatus: [200]
      }
    ]
  }),
  J({
    id: "thirdParty.appCheck",
    tier: p.CRITICAL,
    name: "Firebase App Check",
    description: "Verifies the mobile apps for place search and the other api calls",
    probes: [{ url: "https://firebaseappcheck.googleapis.com/v1/jwks", expectStatus: [200] }]
  }),
  J({
    id: "thirdParty.firestore",
    tier: p.CRITICAL,
    name: "Cloud Firestore",
    description: "Store checkout pricing and coupons, contact invites",
    probes: [
      { url: "https://firestore.googleapis.com/v1/projects/{project}/databases/(default)/documents/status/probe", expectStatus: [401, 403] }
    ]
  }),
  J({
    id: "thirdParty.places",
    tier: p.CRITICAL,
    name: "Google Places",
    description: "Place search in every app, via utilities-api",
    probes: [
      { url: "https://places.googleapis.com/v1/places:autocomplete", method: "POST", body: { input: "calgary" }, expectStatus: [401, 403] }
    ]
  }),
  J({
    id: "thirdParty.stripe",
    tier: p.CRITICAL,
    name: "Stripe",
    description: "Store checkout, the customer portal and subscription webhooks",
    runsOn: A,
    probes: [{ url: "https://api.stripe.com/v1/charges", expectStatus: [401] }]
  }),
  J({
    id: "thirdParty.ses",
    tier: p.CORE,
    name: "AWS SES",
    description: "Sign-in link, account and password reset emails, contact us, invites",
    probes: [{ url: "https://email.us-west-2.amazonaws.com/", expectStatus: [400, 403, 404] }]
  }),
  J({
    id: "thirdParty.openWeather",
    tier: p.CRITICAL,
    name: "OpenWeather",
    description: "Weather for every app, via the resource cluster and web v1 (both call it over http)",
    probes: [{ url: "http://api.openweathermap.org/data/2.5/weather?lat=0&lon=0&appid=status-probe", expectStatus: [401] }]
  }),
  {
    id: "thirdParty.geogratis",
    group: h.THIRD_PARTY,
    tier: p.CORE,
    name: "NRCan GeoGratis elevation",
    description: "Elevation for waypoints in the mobile apps and web v2, via the resource cluster",
    runsOn: A,
    run: (a) => N(
      a,
      `https://geogratis.gc.ca/services/elevation/cdem/altitude?lat=${T.lat}&lon=${T.lon}`,
      { read: "json" },
      (e) => typeof (e == null ? void 0 : e.altitude) == "number" ? I(`${e.altitude} m`) : P("No altitude in the response")
    )
  },
  J({
    id: "thirdParty.recAccess",
    tier: p.CRITICAL,
    name: "Alberta RecAccess",
    description: "Agricultural lease contacts and access conditions; the cluster falls back to its cache when it is down",
    runsOn: A,
    probes: [{ url: "https://geospatial.alberta.ca/services/RecAccessService/api/recaccess/", expectStatus: [404] }]
  }),
  J({
    id: "thirdParty.storage",
    tier: p.CRITICAL,
    name: "Firebase Storage",
    description: "Waypoint, chat and profile images",
    runsOn: A,
    probes: [{ url: "https://firebasestorage.googleapis.com/v0/b/{project}.appspot.com/o/status-probe", expectStatus: [401, 403, 404] }]
  }),
  J({
    id: "thirdParty.remoteConfig",
    tier: p.SECONDARY,
    name: "Firebase Remote Config",
    description: "iOS StoreKit mode and invite limits (both fall back to defaults)",
    probes: [{ url: "https://firebaseremoteconfig.googleapis.com/v1/projects/{project}/remoteConfig", expectStatus: [401, 403] }]
  }),
  J({
    id: "thirdParty.mailchimp",
    tier: p.SECONDARY,
    name: "Mailchimp",
    description: "Newsletter opt-in and email sync",
    probes: [{ url: `https://${T.mailchimpDatacenter}.api.mailchimp.com/3.0/ping`, expectStatus: [401] }]
  }),
  J({
    id: "thirdParty.aws",
    tier: p.SECONDARY,
    name: "AWS admin APIs",
    description: "SSM and CloudFront for the Dashboard AWS and CDN tools, CloudWatch for cluster metrics",
    probes: [
      { label: "SSM", url: "https://ssm.us-west-2.amazonaws.com/", expectStatus: [400, 403, 404] },
      { label: "CloudFront", url: "https://cloudfront.amazonaws.com/2020-05-31/distribution", expectStatus: [403] },
      { label: "CloudWatch", url: "https://monitoring.us-west-2.amazonaws.com/", expectStatus: [400, 403, 404] }
    ]
  }),
  J({
    id: "thirdParty.arcgis",
    tier: p.CORE,
    name: "Esri ArcGIS imagery",
    description: "Basemap option in the mobile apps",
    runsOn: A,
    probes: [{ url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/5/10/6", expectStatus: [200] }]
  }),
  // Web v2 (ihunter_web)
  {
    id: "webV2.shell",
    group: h.WEB_V2,
    tier: p.CRITICAL,
    name: "Web v2 host",
    budgetMs: 2 * te.ORIGIN,
    // index.html, then its bundles
    description: "index.html, and the hashed script and style bundles it loads",
    runsOn: A,
    run: async (a) => {
      const e = await a.probe(a.config.url.web + "/", { read: "text" });
      if (e.status !== 200)
        return L(ue(e), { probe: e, facts: or(e) });
      const t = e.body || "", r = [...new Set([...t.matchAll(/(?:src|href)="\.?\/?(assets\/[^"]+\.(?:js|css))"/g)].map((l) => l[1]))];
      if (!/<title>iHunter Web<\/title>/.test(t) || !r.length)
        return L("index.html does not load the app bundles", { probe: e });
      const s = await Promise.all(
        r.map(async (l) => ({ asset: l, result: await a.probe(`${a.config.url.web}/${l}`, { method: "HEAD" }) }))
      ), n = ({ asset: l, result: E }) => E.status === 200 && (l.endsWith(".js") ? /javascript/i : /css/i).test(E.contentType || ""), i = s.filter((l) => !n(l)), o = s.reduce((l, E) => l + (E.result.contentLength || 0), 0), u = e.latencyMs + Math.max(...s.map((l) => l.result.latencyMs || 0)), d = { bundles: `${r.length} files`, size: `${(o / 1048576).toFixed(1)} MB` };
      if (i.length) {
        const l = i.map((E) => `${E.asset} ${E.result.status === 200 ? `served as ${E.result.contentType}` : ue(E.result)}`).join("; ");
        return L(`Missing bundles: ${l}`, { probe: e, facts: d, latencyMs: u });
      }
      return I(`Serving ${r.find((l) => /index-.*\.js$/.test(l)) || r[0]}`, { probe: e, facts: d, latencyMs: u });
    }
  },
  {
    id: "webV2.regions",
    group: h.WEB_V2,
    tier: p.CRITICAL,
    name: "Region picker data",
    description: "regions_filtered.geojson",
    runsOn: A,
    run: (a) => N(
      a,
      a.config.url.web + "/regions_filtered.geojson",
      { read: "json" },
      (e) => {
        var t;
        return (t = e == null ? void 0 : e.features) != null && t.length ? I(`${e.features.length} regions`) : L("Not GeoJSON (is it the index.html fallback?)");
      }
    )
  },
  {
    id: "webV2.authHandler",
    group: h.WEB_V2,
    tier: p.CRITICAL,
    name: "Sign-in handler",
    description: "Firebase Hosting /__/auth/handler, used for Google sign-in popups",
    runsOn: la,
    run: (a) => N(
      a,
      a.config.url.web + "/__/auth/handler",
      { read: "text" },
      (e) => /fireauth/.test(e || "") && /handler\.js/.test(e || "") ? I("Serving the handler") : P("Unexpected handler page")
    )
  },
  {
    id: "webV2.huntlog",
    group: h.WEB_V2,
    tier: p.CORE,
    name: "HuntLog drawer",
    description: "The HuntLog iframe, which web v2 loads from the web v1 host (url.web in its config)",
    runsOn: A,
    run: (a) => N(
      a,
      a.config.url.webapp + "/huntlog/index.html",
      { read: "text" },
      (e) => /ABHuntLog/.test(e || "") ? I("Serving HuntLog") : P("Unexpected HuntLog page")
    )
  },
  {
    id: "webV2.licenses",
    group: h.WEB_V2,
    tier: p.SECONDARY,
    name: "Open source licenses",
    description: "licenses.txt from web v2's own build, linked from its About page",
    runsOn: A,
    run: (a) => N(a, a.config.url.web + "/licenses.txt", { read: "text" }, (e, t) => /text\/plain/i.test(t.contentType || "") ? (e || "").length > 1e4 ? I(`${Math.round(e.length / 1024)} KB`) : P("licenses.txt is unexpectedly small") : P(`Served as ${t.contentType} (is it the index.html fallback?)`))
  },
  // Web v1 (ihunter_webapp)
  {
    id: "webV1.shell",
    group: h.WEB_V1,
    tier: p.CRITICAL,
    name: "Web v1 host",
    runsOn: A,
    run: (a) => N(
      a,
      a.config.url.webapp + "/",
      { read: "text" },
      (e) => /<title>iHunter<\/title>/.test(e || "") && /main\.[0-9a-f]+\.js/.test(e || "") ? I("Serving the app") : P("Unexpected index.html")
    )
  },
  {
    id: "webV1.huntlog",
    group: h.WEB_V1,
    tier: p.CRITICAL,
    name: "HuntLog dashboard",
    description: "Embedded by web v2, iOS and Android; a 404 means the htdocs/webapp/huntlog symlink is broken",
    runsOn: A,
    run: (a) => N(
      a,
      a.config.url.webapp + "/huntlog/index.html",
      { read: "text" },
      (e) => /ABHuntLog/.test(e || "") ? I("Serving HuntLog") : P("Unexpected HuntLog page")
    )
  },
  {
    id: "webV1.layerData",
    group: h.WEB_V1,
    tier: p.CRITICAL,
    name: "Remote layer lookups",
    description: "Map taps on remote layers (no access, ATS) in the mobile apps; PHP and the local Postgres",
    runsOn: A,
    run: (a) => N(
      a,
      a.config.url.webapp + "/getShapefileLayerData.php?prov=ab&layer=noaccess&lat=0&lon=0",
      { read: "json" },
      (e) => Array.isArray(e) ? I("Responding") : P("Unexpected response")
    )
  },
  {
    id: "webV1.weather",
    group: h.WEB_V1,
    tier: p.CRITICAL,
    name: "Weather (mobile apps)",
    budgetMs: 3e3,
    // Live OpenWeather request on a cache miss
    description: "getWeatherInformation.php: OpenWeather, cached in the local Postgres",
    runsOn: A,
    run: (a) => N(
      a,
      `${a.config.url.webapp}/getWeatherInformation.php?lat=${T.lat}&lon=${T.lon}`,
      { read: "json" },
      (e) => (e == null ? void 0 : e.temp) !== void 0 && (e == null ? void 0 : e.temp) !== "" ? I(`${e.temp}° ${e.weather_desc || ""}`.trim()) : P("No weather data")
    )
  },
  {
    id: "webV1.licenses",
    group: h.WEB_V1,
    tier: p.SECONDARY,
    name: "Open source licenses",
    description: "licenses.txt, shown by the web v2 About page; only prod builds generate it",
    runsOn: A,
    run: async (a) => {
      var t;
      const e = await N(
        a,
        a.config.url.webapp + "/licenses.txt",
        { read: "text" },
        (r) => (r || "").length > 1e4 ? I(`${Math.round(r.length / 1024)} KB`) : P("licenses.txt is unexpectedly small")
      );
      return ((t = e.probe) == null ? void 0 : t.status) === 404 && a.config.debug ? { ...e, state: k.SKIPPED, detail: "Not generated by dev builds of web v1" } : e;
    }
  },
  {
    id: "webV1.provinces",
    group: h.WEB_V1,
    tier: p.CRITICAL,
    name: "Province data",
    description: "res/provinces, loaded at web v1 startup",
    runsOn: A,
    run: (a) => N(
      a,
      a.config.url.webapp + "/res/provinces/provinces.json",
      { read: "json" },
      (e) => {
        var t;
        return (t = e == null ? void 0 : e.provinces) != null && t.includes(T.region) ? I(`${e.provinces.length} provinces`) : P(`${T.region} is missing`);
      }
    )
  },
  // Mobile apps (iOS and Android)
  {
    id: "mobile.versions",
    group: h.MOBILE,
    tier: p.CRITICAL,
    name: "Update manifest",
    description: "versions.xml gates every regulation, resource and subscription update; apps keep running on cached data without it",
    runsOn: A,
    run: (a) => N(a, `${a.config.url.tiles}/tiles/data/provinces/${T.region}/versions.xml`, { read: "text" }, (e) => {
      const t = Qs(e);
      return t != null && t.regsversion ? I(`Regulations ${t.regsversion}`, {
        facts: { ios: t.latestversionios, android: t.latestversionandroid },
        data: t
      }) : L("versions.xml has no regsversion");
    })
  },
  {
    id: "mobile.bundles",
    group: h.MOBILE,
    tier: p.CRITICAL,
    name: "Resource bundles",
    description: "Every zip listed in versions.xml; apps download one when it is newer than their built-in version",
    runsOn: A,
    run: async (a) => {
      var u;
      const e = (u = await a.result("mobile.versions")) == null ? void 0 : u.data;
      if (!e)
        return { state: k.SKIPPED, detail: "versions.xml is unavailable" };
      const t = Object.entries(e).filter(([d]) => d.endsWith("_version")).map(([d, l]) => ({ group: d.replace(/_version$/, ""), version: l })), r = await Promise.all(
        t.map(async (d) => ({
          ...d,
          result: await a.probe(`${a.config.url.resources}/res/${T.region}/${d.group}/${d.version}.zip`, {
            method: "HEAD"
          })
        }))
      ), s = r.filter((d) => d.result.status !== 200), n = r.reduce((d, l) => d + (l.result.contentLength || 0), 0), i = { bundles: r.map((d) => `${d.group} ${d.version}`).join(", "), size: `${Math.round(n / 1048576)} MB` }, o = Math.max(...r.map((d) => d.result.latencyMs || 0));
      if (s.length === r.length)
        return L(`No bundles available (${ue(s[0].result)})`, { facts: i, latencyMs: o, probe: s[0].result });
      if (s.length) {
        const d = s.filter((E) => T.requiredBundles.includes(E.group)), l = s.map((E) => `${E.group} ${E.version} ${ue(E.result)}`).join("; ") + (d.length ? ". App builds with an older built-in version can't download it" : "");
        return P(l, { facts: i, latencyMs: o, probe: s[0].result });
      }
      return I(`${r.length} bundles available`, { facts: i, latencyMs: o });
    }
  },
  {
    id: "mobile.regulations",
    group: h.MOBILE,
    tier: p.CRITICAL,
    name: "Regulations database",
    runsOn: A,
    run: async (a) => {
      var r, s;
      const e = (s = (r = await a.result("mobile.versions")) == null ? void 0 : r.data) == null ? void 0 : s.regsversion;
      if (!e)
        return { state: k.SKIPPED, detail: "versions.xml is unavailable" };
      const t = `${a.config.url.tiles}/tiles/data/provinces/${T.region}/regulations_${e}.db`;
      return N(
        a,
        t,
        { method: "HEAD" },
        (n, i) => I(`regulations_${e}.db${i.contentLength ? ` (${Math.round(i.contentLength / 1024)} KB)` : ""}`)
      );
    }
  },
  {
    id: "mobile.counties",
    group: h.MOBILE,
    tier: p.CRITICAL,
    name: "Landowner maps catalog",
    runsOn: A,
    run: (a) => N(
      a,
      a.config.url.tiles + z.CountyMetadata(T.region),
      { read: "json" },
      (e) => {
        var t;
        return (t = e == null ? void 0 : e.counties) != null && t.length ? I(`${e.counties.length} maps`) : P("No maps listed");
      }
    )
  },
  {
    id: "mobile.mapCorrections",
    group: h.MOBILE,
    tier: p.CRITICAL,
    name: "Landowner map corrections",
    runsOn: A,
    run: (a) => N(a, `${a.config.url.tiles}/tiles/${T.region}/map_corrections.json`, { read: "json" })
  },
  {
    id: "mobile.extras",
    group: h.MOBILE,
    tier: p.CRITICAL,
    name: "CWD and sponsor data",
    runsOn: A,
    run: async (a) => {
      const e = `${a.config.url.tiles}/tiles/data/provinces/${T.region}`, [t, r] = await Promise.all([
        a.probe(`${e}/cwd.zip`, { method: "HEAD" }),
        a.probe(`${e}/sponsors.zip`, { method: "HEAD" })
      ]), s = [
        ["cwd.zip", t],
        ["sponsors.zip", r]
      ].filter(([, i]) => i.status !== 200), n = Math.max(t.latencyMs, r.latencyMs);
      return s.length ? P(s.map(([i, o]) => `${i} ${ue(o)}`).join("; "), { probe: s[0][1], latencyMs: n }) : I("Available", { probe: t, latencyMs: n });
    }
  },
  {
    id: "mobile.messages",
    group: h.MOBILE,
    tier: p.CRITICAL,
    name: "In-app messages",
    description: "www.ihunterapp.com (Bluehost); also the source of the resource cluster news messages",
    runsOn: A,
    run: (a) => N(
      a,
      "https://www.ihunterapp.com/messages/getMessages.php?platform=android&province=AB&app=ihunter&timestamp=0",
      { read: "json" },
      (e) => Array.isArray(e) ? I(`${e.length} messages`) : P("Messages are not a list")
    )
  },
  // Certificates
  Be("web", "Web v2", p.CORE),
  Be("api", "Functions and Dashboard", p.CRITICAL),
  // Used by the mobile apps
  Be("resources", "Resource cluster", p.CRITICAL),
  // Used by the mobile apps
  Be("maps", "CDN"),
  Be("store", "Store", p.CORE),
  Be("webapp", "Web v1", p.CRITICAL),
  // Used by the mobile apps
  Be("tiles", "Mobile data (tiles alias)", p.CRITICAL)
  // Used by the mobile apps
]);
function rn(a) {
  return a && a.replace(/(access_token|api_secret|appid|key|token)=[^&]+/gi, "$1=…");
}
function an(a) {
  return a.some((e) => e.tier === p.CRITICAL && e.state === k.DOWN) ? k.DOWN : a.some((e) => e.state === k.DOWN || e.state === k.DEGRADED) ? k.DEGRADED : k.OK;
}
function at() {
  return typeof performance < "u" ? performance.now() : Date.now();
}
function cr(a) {
  var e, t;
  return /miss/i.test((a == null ? void 0 : a.xCache) || "") || ((t = (e = a == null ? void 0 : a.serverTiming) == null ? void 0 : e.cache) == null ? void 0 : t.desc) === "miss";
}
function da(a, e) {
  return e && cr(a) ? Math.max(e, te.ORIGIN) : e;
}
function sn(a, e) {
  var t;
  return (t = a.serverTiming) != null && t.cold ? "cold start" : cr(a) && !cr(e) ? "cache miss" : "connection setup";
}
const nn = 3, on = 8, cn = 500;
function un(a) {
  let e = 0;
  const t = [], r = () => {
    e < a && t.length && (e++, t.shift()());
  };
  return async (s) => {
    await new Promise((n) => {
      t.push(n), r();
    });
    try {
      return await s();
    } finally {
      e--, r();
    }
  };
}
function xr(a) {
  return a.status === null || a.status >= 500;
}
function ln(a) {
  let e = 0, t = 0;
  const r = [], s = () => {
    for (; e === 0 && r.length && t < nn; )
      t++, r.shift()();
  };
  return {
    probe: async (n, i) => {
      e++;
      try {
        return await a(n, i);
      } finally {
        e--, s();
      }
    },
    repeat: async (n, i) => {
      await new Promise((o) => {
        r.push(o), s();
      });
      try {
        return await a(n, i);
      } finally {
        t--, s();
      }
    }
  };
}
async function dn(a, e, t) {
  const r = await a.probe(e, t);
  if (!xr(r))
    return r;
  await new Promise((n) => setTimeout(n, cn));
  const s = await a.probe(e, t);
  return { ...s, retried: { reason: ue(r), recovered: !xr(s) } };
}
async function pn(a, e, t, r) {
  const s = await dn(a, e, t);
  if (!r || s.status === null || s.latencyMs <= da(s, r))
    return s;
  const n = await a.repeatProbe(e, t);
  return n.status === null || n.latencyMs >= s.latencyMs ? s : { ...n, retried: s.retried, firstRequest: { latencyMs: s.latencyMs, reason: sn(s, n) } };
}
function Yr(a) {
  return a >= 1e3 ? `${(a / 1e3).toFixed(1)}s` : `${a}ms`;
}
async function hn(a, e) {
  var o, u, d, l, E, m;
  const t = at(), r = a.group in Gr ? Gr[a.group] : te.ORIGIN, s = a.budgetMs !== void 0 ? a.budgetMs : r, n = { ...e, probe: (f, y) => pn(e, f, y, s) }, i = {
    id: a.id,
    group: a.group,
    tier: a.tier,
    name: a.name,
    description: a.description
  };
  try {
    const f = (o = a.skip) == null ? void 0 : o.call(a, n);
    if (f)
      return { ...i, state: k.SKIPPED, detail: f, facts: {}, latencyMs: null };
    const y = await a.run(n), C = y.latencyMs ?? ((u = y.probe) == null ? void 0 : u.latencyMs) ?? Math.round(at() - t), O = da(y.probe, s);
    let { state: _, detail: b } = y;
    const w = (d = y.probe) == null ? void 0 : d.retried;
    return w && (b = w.recovered ? `${b}; first attempt failed (${w.reason}), the retry succeeded` : `${b}; also failed on a retry`), O && _ === k.OK && C > O && (_ = k.DEGRADED, b = `${b}; slow (${Yr(C)}, expected under ${Yr(O)})`), {
      ...i,
      state: _,
      detail: b,
      facts: Object.fromEntries(Object.entries(y.facts || {}).filter(([, g]) => g != null)),
      url: rn((l = y.probe) == null ? void 0 : l.url),
      status: ((E = y.probe) == null ? void 0 : E.status) ?? null,
      latencyMs: C,
      budgetMs: O,
      firstRequest: (m = y.probe) == null ? void 0 : m.firstRequest,
      retried: w,
      data: y.data
    };
  } catch (f) {
    return { ...i, state: k.DOWN, detail: f.message, facts: {}, latencyMs: Math.round(at() - t) };
  }
}
async function Kn(a, e = {}) {
  const t = e.target || Ne.BROWSER, r = tn.filter((g) => g.runsOn.includes(t)), s = e.only ? r.filter((g) => e.only.includes(g.id)) : r, n = /* @__PURE__ */ new Date(), i = at(), o = /* @__PURE__ */ new Map(), u = (g, R = {}) => t === Ne.SERVER && /^https:\/\/([a-z0-9-]+\.)*ihunterapp\.com\//i.test(g) && !R.Origin ? { ...R, Origin: new URL(a.url.api).origin } : R, d = un(e.concurrency || on), l = (g, R = {}) => d(
    () => Ks(g, { fetch: e.fetch, timeoutMs: e.timeoutMs, ...R, headers: u(g, R.headers) })
  ), E = /* @__PURE__ */ new Map(), m = (g) => {
    let R;
    try {
      R = new URL(g).origin;
    } catch {
      return null;
    }
    if (!E.has(R)) {
      const v = t === Ne.BROWSER ? { credentials: "omit" } : {};
      E.set(
        R,
        l(`${R}/`, { method: "HEAD", redirect: "manual", ...v }).then((W) => ({
          origin: R,
          latencyMs: W.latencyMs,
          // A manual redirect is opaque in the browser, with no readable status
          status: W.status || null,
          error: W.timedOut ? W.error : void 0,
          // In the browser: usually CORS or a redirect hid the response (a network failure looks the same)
          opaque: !W.status && !W.timedOut
        }))
      );
    }
    return E.get(R);
  }, f = ln(async (g, R) => (await m(g), l(g, R)));
  let y = null;
  const C = [...new Set(r.filter((g) => g.urlKey).map((g) => a.url[g.urlKey]))].filter(Boolean), O = e.certExpiries ? async (g) => {
    y = y || e.certExpiries(C);
    const R = await y;
    return R == null ? void 0 : R[g];
  } : e.certExpiry && ((g) => d(() => e.certExpiry(g))), _ = {
    config: a,
    target: t,
    getToken: e.getToken || (async () => null),
    certExpiry: O,
    probe: f.probe,
    repeatProbe: f.repeat,
    isSameOrigin: (g) => {
      var R;
      return typeof window < "u" && ((R = window.location) == null ? void 0 : R.origin) === new URL(g).origin;
    },
    // Run (or join) another check; null if it does not run on this target
    result: (g) => {
      if (!o.has(g)) {
        const R = r.find((v) => v.id === g);
        o.set(g, R ? hn(R, _) : Promise.resolve(null));
      }
      return o.get(g);
    }
  }, b = await Promise.all(
    s.map(async (g) => {
      var v;
      const R = await _.result(g.id);
      return (v = e.onResult) == null || v.call(e, R), R;
    })
  ), w = {};
  for (const g of b)
    w[g.state] = (w[g.state] || 0) + 1;
  return {
    environment: a.name,
    target: t,
    startedAt: n.toISOString(),
    durationMs: Math.round(at() - i),
    state: an(b),
    counts: w,
    results: b,
    connections: (await Promise.all(E.values())).sort((g, R) => g.origin.localeCompare(R.origin))
  };
}
var Rt = { exports: {} };
function gn(a, e = 0) {
  let t = 3735928559 ^ e, r = 1103547991 ^ e;
  for (let s = 0, n; s < a.length; s++)
    n = a.charCodeAt(s), t = Math.imul(t ^ n, 2654435761), r = Math.imul(r ^ n, 1597334677);
  return t = Math.imul(t ^ t >>> 16, 2246822507) ^ Math.imul(r ^ r >>> 13, 3266489909), r = Math.imul(r ^ r >>> 16, 2246822507) ^ Math.imul(t ^ t >>> 13, 3266489909), (r >>> 0).toString(16).padStart(8, 0) + (t >>> 0).toString(16).padStart(8, 0);
}
Rt.exports = gn;
const Jn = (Rt.exports == null ? {} : Rt.exports).default || Rt.exports;
var Tt = { exports: {} };
function En(a) {
  if (!a)
    return !0;
  for (var e in a)
    return !1;
  return !0;
}
Tt.exports = En;
const Xn = (Tt.exports == null ? {} : Tt.exports).default || Tt.exports;
var Ot = { exports: {} };
async function mn(a, e = 10, t = 10, r = 0) {
  let s = 0;
  r > 0 && (await new Promise((n) => setTimeout(n, r)), s += r);
  for (let n = 1; n <= t; n++) {
    if (await a(s, n))
      return !0;
    const o = e * Math.pow(2, n - 1);
    await new Promise((u) => setTimeout(u, o)), s += o;
  }
  return !1;
}
Ot.exports = mn;
const Zn = (Ot.exports == null ? {} : Ot.exports).default || Ot.exports;
var yt = { exports: {} };
const fn = (a) => a && Object.keys(a).length === 0 && a.constructor === Object;
yt.exports = fn;
const Qn = (yt.exports == null ? {} : yt.exports).default || yt.exports;
var Ct = { exports: {} };
function Rn(a, e) {
  if (typeof a == "boolean")
    return a;
  if (typeof a == "string") {
    const t = a.toLowerCase().trim();
    if (t === "true") return !0;
    if (t === "false" || t === "") return !1;
  }
  return e !== void 0 ? e : !!a;
}
Ct.exports = Rn;
const ei = (Ct.exports == null ? {} : Ct.exports).default || Ct.exports;
var At = { exports: {} };
function Tn(a, e = 10) {
  const t = Number.parseFloat(a);
  return Number.isNaN(t) ? null : t;
}
At.exports = Tn;
const ti = (At.exports == null ? {} : At.exports).default || At.exports;
var St = { exports: {} };
const On = (a) => new Promise((e) => setTimeout(e, a));
St.exports = On;
const zr = (St.exports == null ? {} : St.exports).default || St.exports;
var It = { exports: {} };
const yn = async (a, e) => {
  try {
    const t = zr(e);
    return (await Promise.all([a, t]))[0];
  } catch (t) {
    throw await zr(e), t;
  }
};
It.exports = yn;
const ri = (It.exports == null ? {} : It.exports).default || It.exports;
export {
  Nn as Analytics,
  Te as AppHostedResources,
  zn as AwsCacheResources,
  Yn as AwsSsmCommand,
  wn as BillingResources,
  Pn as CatalogFirebaseProvider,
  M as CatalogFirebaseResources,
  _n as CatalogHostedProvider,
  z as CatalogHostedResources,
  Mn as CatalogPromotions,
  Oe as CatalogPropertyMap,
  T as CheckFixture,
  h as CheckGroup,
  qn as CheckGroups,
  k as CheckState,
  Ne as CheckTarget,
  p as CheckTier,
  B as CollectionItem,
  Dt as CollectionResources,
  Ue as CollectionType,
  Ce as CompassDirection,
  ur as Configuration,
  Se as CoordinateError,
  Ae as CoordinateErrorCode,
  ut as CoordinateFormat,
  xn as CoordinateFormatKey,
  Wa as DataAccessLayer,
  Pt as DateHelpers,
  ea as EmailError,
  ce as EmailResources,
  Fn as EmailType,
  Jr as Environment,
  jn as FCMNotificationResources,
  st as FirebaseRepository,
  tn as InfrastructureChecks,
  ie as InviteError,
  ye as InviteErrorCode,
  lr as InviteInfo,
  Vt as InviteOperation,
  We as InviteResources,
  Wn as LandownerResources,
  Xe as LayerHostedResources,
  vn as MailingListProvider,
  Ze as MailingListResources,
  Ln as MapResources,
  Vn as MessageAlertType,
  V as MessageNotificationType,
  Ye as MessageResources,
  zt as MessageType,
  ee as MoonPhase,
  Le as PreferenceResources,
  Dn as ProfileProvider,
  Qe as ProfileResources,
  Un as PurchaseProvider,
  Bt as PurchaseResources,
  bt as RequestResources,
  $n as StoreMessages,
  kn as StoreResources,
  Bn as StoreRoutes,
  S as UnitHelpers,
  Ie as UnitMode,
  H as UnitType,
  Gn as UserProvider,
  oe as UserResources,
  xa as allMap,
  xa as allSettledMap,
  Hn as compareProbes,
  Jn as cyrb53,
  Xn as empty,
  Zn as exponentialBackoff,
  Qn as isEmpty,
  Qa as isNumeric,
  Hs as normalizeEtag,
  ei as parseBoolean,
  ti as parseNumber,
  $r as parseTime,
  Ks as probe,
  Ja as resizeImage,
  Kn as runChecks,
  zr as sleep,
  ri as sleepForMinTime,
  kt as splitProduct,
  an as summarizeChecks,
  c as templ8r
};
